import { Lawyer } from '../types';

// Translators catalog from MOJ
// Updated on 2025-12-03 23:38:23
// Total translators: 427

export const allTranslatorsFromJsonParser: Lawyer[] = [
  {
    "id": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "slug": "al-sharq-legal-translation-services",
    "name": "Al Sharq Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2000-04-29",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-13",
    "licenseIssueDate": "2023-08-29",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Sharq Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9c392772-b626-49d4-9f1c-4212cd35d4e6",
        "address": "",
        "phone": "507077500",
        "email": "info@orientlt.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "168",
    "owner": "D.Safaa Mahmoud Al-Janabi",
    "individuals": [
      "6834681b-8301-4ec4-bd99-2d62f50241ee",
      "a12bbdfb-a254-41ff-bf50-57f5f8b53831",
      "96170f1f-c5ad-4d6a-968d-24c824ea655f",
      "2eecd433-45ec-45bf-852b-29b76b8c0451",
      "f15e736d-1c39-48ba-a610-19565e6990a0",
      "8e7827c0-e062-4d21-bd42-20f164f6b235",
      "0a6d8b34-1876-4678-aae0-6eeb383bdc1a"
    ],
    "lawyerCount": 7
  },
  {
    "id": "f080e54f-c513-4526-90a2-bd2b1aac9b2d",
    "slug": "kamel-bashir-for-legal-translation",
    "name": "Kamel Bashir for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2004-12-26",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-21",
    "licenseIssueDate": "2023-09-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Kamel Bashir for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f080e54f-c513-4526-90a2-bd2b1aac9b2d",
        "address": "",
        "phone": "507181032",
        "email": "kamil@dubaitranslation.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "252",
    "owner": "D.Kamel Bashir Othman",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "10223459-4874-462e-8d5a-c9709e112d15",
    "slug": "wordcraft-translation-services-abu-dhabi",
    "name": "Wordcraft Translation Services - Abu Dhabi",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2024-05-09",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-09",
    "licenseIssueDate": "2024-05-29",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Wordcraft Translation Services - Abu Dhabi",
    "consultationFee": 300,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_10223459-4874-462e-8d5a-c9709e112d15",
        "address": "",
        "phone": "501451543",
        "email": "hadialtaie@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "615",
    "owner": "D.Hadi Abdullah Hadi Al-Taie",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "6af323d2-2edc-4a33-9345-f1877eadedf1",
    "slug": "dts-translation-services",
    "name": "DTS Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-08-01",
    "licenseStatus": "active",
    "licenseExpiry": "2027-04-21",
    "licenseIssueDate": "2024-04-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: DTS Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6af323d2-2edc-4a33-9345-f1877eadedf1",
        "address": "",
        "phone": "0507305230",
        "email": "aema427@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "657",
    "owner": "Abu Al-Futouh Ezzat Abu Zaid",
    "individuals": [
      "2eecd433-45ec-45bf-852b-29b76b8c0451"
    ],
    "lawyerCount": 1
  },
  {
    "id": "21c83386-371b-44e4-a7fb-649915d3f561",
    "slug": "al-nilein-translation-services",
    "name": "Al-Nilein Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-07-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-06",
    "licenseIssueDate": "2023-08-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Nilein Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_21c83386-371b-44e4-a7fb-649915d3f561",
        "address": "",
        "phone": "528984266",
        "email": "gasimfakilg@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "523",
    "owner": "Abu Al-Qasim Muhammad Al-Faki",
    "individuals": [
      "a2d246e3-d25e-4f7b-87cd-ca1649eea193"
    ],
    "lawyerCount": 1
  },
  {
    "id": "569b1561-5c92-47ed-80e0-3891bc25baad",
    "slug": "kemet-legal-translation",
    "name": "Kemet Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-06-10",
    "licenseIssueDate": "2024-08-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Kemet Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_569b1561-5c92-47ed-80e0-3891bc25baad",
        "address": "",
        "phone": "0507542668",
        "email": "translatorosama@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "263",
    "owner": "Osama Ahmed Qassam",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "efecba44-ae76-4cbe-853e-447816c4edbe",
    "slug": "vision-for-translation-and-business-services",
    "name": "Vision for translation and business services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBWVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-07-18",
    "licenseStatus": "active",
    "licenseExpiry": "2025-01-23",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Vision for translation and business services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_efecba44-ae76-4cbe-853e-447816c4edbe",
        "address": "",
        "phone": "502690929",
        "email": "usamatranslator@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "719",
    "owner": "Osama Al-Sayed Muhammad Dawoud",
    "individuals": [
      "dcc53252-dde0-4ee2-918e-574335d2c554"
    ],
    "lawyerCount": 1
  },
  {
    "id": "16a4de03-db09-4dd9-a9a2-87c4c1ac78ca",
    "slug": "galimps-legal-translation",
    "name": "Galimps Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-11-01",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-04",
    "licenseIssueDate": "2023-01-12",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Galimps Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_16a4de03-db09-4dd9-a9a2-87c4c1ac78ca",
        "address": "",
        "phone": "",
        "email": "ibrahimelbialy@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "746",
    "owner": "Ibrahim Al-Baili Muhammad Mahrous",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "a2820d1d-565f-4729-a2b7-854210b88f15",
    "slug": "frontline-legal-translation",
    "name": "Frontline Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-11-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-25",
    "licenseIssueDate": "2024-03-14",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Frontline Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a2820d1d-565f-4729-a2b7-854210b88f15",
        "address": "",
        "phone": "556169417",
        "email": "ibrahim.farouk49@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "763",
    "owner": "Ibrahim Farouk Ibrahim Ali Nada",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "002fdfeb-bd5b-4551-bc73-e67046cc43f0",
    "slug": "palmira-legal-translation-services",
    "name": "Palmira Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-06-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-14",
    "licenseIssueDate": "2023-08-28",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Palmira Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_002fdfeb-bd5b-4551-bc73-e67046cc43f0",
        "address": "",
        "phone": "0502737415",
        "email": "abuzar_mohd5@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "703",
    "owner": "Abu Dharr Babakir Muhammad",
    "individuals": [
      "510ac6ad-256b-459a-92d6-8df5eeb83051"
    ],
    "lawyerCount": 1
  },
  {
    "id": "88b3686a-a8d1-4fc4-9add-e204d4d732bd",
    "slug": "al-shahba-legal-translation",
    "name": "Al-Shahba Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-09",
    "licenseIssueDate": "2023-07-11",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Shahba Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_88b3686a-a8d1-4fc4-9add-e204d4d732bd",
        "address": "",
        "phone": "504741535",
        "email": "Alshahba.translation@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "209",
    "owner": "Ahmed Muhammad Issa Hilal",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "66758b44-395a-4747-811d-44b6140106ac",
    "slug": "global-gulf-legal-translation-services",
    "name": "Global Gulf Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-11-22",
    "licenseStatus": "active",
    "licenseExpiry": "2028-08-21",
    "licenseIssueDate": "2025-08-27",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Global Gulf Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_66758b44-395a-4747-811d-44b6140106ac",
        "address": "",
        "phone": "507626856",
        "email": "tyja@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "482",
    "owner": "Ahmed Al-Tijani Idris",
    "individuals": [
      "15626684-75ab-4ef3-b10f-4f82a9fc4fc8"
    ],
    "lawyerCount": 1
  },
  {
    "id": "bdb32fe4-ccaf-4ab9-b019-f31a610afa48",
    "slug": "department-of-services-ras-al-khaimah-government",
    "name": "Department of Services (Ras Al Khaimah Government)",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-04-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-21",
    "licenseIssueDate": "2023-06-22",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Department of Services (Ras Al Khaimah Government)",
    "consultationFee": 300,
    "emirate": "Ras Al Khaimah",
    "verified": true,
    "offices": [
      {
        "id": "office_bdb32fe4-ccaf-4ab9-b019-f31a610afa48",
        "address": "",
        "phone": "0508897613",
        "email": "abdo_5535@yahoo.com",
        "emirate": "Ras Al Khaimah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "553",
    "owner": "Ahmed Al-Sayed Abdel-Rasoul Alimi",
    "individuals": [
      "d1c83cb0-8b00-4ba9-896b-d70c8b71f38e",
      "5db54015-c952-4fe0-8c19-69d838234a7d",
      "70f6cd1a-99b9-498f-92c4-4daf30611ddb"
    ],
    "lawyerCount": 3
  },
  {
    "id": "3b97f53d-ba89-48f8-84a3-9af18041cbdd",
    "slug": "atlas-of-legal-translation",
    "name": "Atlas of legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-08-12",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-20",
    "licenseIssueDate": "2023-08-29",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Atlas of legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3b97f53d-ba89-48f8-84a3-9af18041cbdd",
        "address": "",
        "phone": "0508803310",
        "email": "ahmed@atlaslt.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "333",
    "owner": "Ahmed Badran Badir",
    "individuals": [
      "5d61e454-d9ee-4dda-a3fc-e5612c5b0dc9"
    ],
    "lawyerCount": 1
  },
  {
    "id": "57068848-a379-4d4f-9361-9fffafa4b82d",
    "slug": "arab-american-center-for-legal-translation",
    "name": "Arab American Center for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-01",
    "licenseIssueDate": "2023-10-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Arab American Center for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_57068848-a379-4d4f-9361-9fffafa4b82d",
        "address": "",
        "phone": "507138917",
        "email": "ahmedtawfik44@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "640",
    "owner": "Ahmed Tawfiq Ahmed Al-Kholy",
    "individuals": [
      "657f81a9-cf79-4365-ae5f-153445ec9084"
    ],
    "lawyerCount": 1
  },
  {
    "id": "624f6326-8232-401a-a36d-48115569de8b",
    "slug": "leaders-legal-translation",
    "name": "Leaders Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2007-01-23",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-06",
    "licenseIssueDate": "2023-01-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Leaders Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_624f6326-8232-401a-a36d-48115569de8b",
        "address": "",
        "phone": "507710485",
        "email": "dosbtranalation@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "293",
    "owner": "Ahmed Hassan Deeb",
    "individuals": [
      "d878b732-723d-4865-835d-cc1392243e65"
    ],
    "lawyerCount": 1
  },
  {
    "id": "533757eb-8584-4361-81fa-0724d4551452",
    "slug": "legal-translation-house",
    "name": "Legal Translation House",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-11-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-18",
    "licenseIssueDate": "2023-09-26",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Legal Translation House",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_533757eb-8584-4361-81fa-0724d4551452",
        "address": "",
        "phone": "0971507973431",
        "email": "ahmedfortranslation@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "454",
    "owner": "Ahmed Hassan Awad",
    "individuals": [
      "d878b732-723d-4865-835d-cc1392243e65"
    ],
    "lawyerCount": 1
  },
  {
    "id": "b3924fb8-085a-493f-81cd-e50a869271a0",
    "slug": "kalimat-legal-translation-services",
    "name": "Kalimat Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-02-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-19",
    "licenseIssueDate": "2024-03-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Kalimat Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b3924fb8-085a-493f-81cd-e50a869271a0",
        "address": "",
        "phone": "567194995",
        "email": "ahmedsalim1979@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "665",
    "owner": "Ahmed Salim Ahmed",
    "individuals": [
      "2cd106ab-f849-424b-888b-86209618816e"
    ],
    "lawyerCount": 1
  },
  {
    "id": "684a17b2-cfa2-4dbc-bc5f-b21ad92d16a9",
    "slug": "al-wadi-holding-legal-translation",
    "name": "Al Wadi Holding Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-11-04",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-19",
    "licenseIssueDate": "2023-03-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Wadi Holding Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_684a17b2-cfa2-4dbc-bc5f-b21ad92d16a9",
        "address": "",
        "phone": "527883277",
        "email": "Ahmed.sabertranslator@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "726",
    "owner": "Ahmed Saber El-Beltagy",
    "individuals": [
      "ba2fb9ec-ffde-46c0-bf72-6d71606274ca",
      "6aeafa36-ef6a-459b-8921-d43524310af2"
    ],
    "lawyerCount": 2
  },
  {
    "id": "1b41c90d-9f54-415f-b311-0c9df6c1d34d",
    "slug": "bahr-al-maani-legal-translation",
    "name": "Bahr Al Maani Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-09-24",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-14",
    "licenseIssueDate": "2023-10-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Bahr Al Maani Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1b41c90d-9f54-415f-b311-0c9df6c1d34d",
        "address": "",
        "phone": "506766388",
        "email": "ahmedswai@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "416",
    "owner": "Ahmed Abdel Razzaq Sawy",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "85ec0444-d4d6-4251-8d2f-834e3ddafacf",
    "slug": "trans-expert-for-legal-translation-services",
    "name": "Trans Expert for legal translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2024-06-06",
    "licenseIssueDate": "2021-07-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Trans Expert for legal translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_85ec0444-d4d6-4251-8d2f-834e3ddafacf",
        "address": "",
        "phone": "0501546428",
        "email": "aghtranslator88@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "658",
    "owner": "Ahmed Abdel Ghaffar Muhammad",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "7cf8a3f9-c632-48bb-abe6-1c36fa9c6212",
    "slug": "lingua-smart-legal-translation",
    "name": "Lingua Smart Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-09-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-06",
    "licenseIssueDate": "2024-12-27",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Lingua Smart Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7cf8a3f9-c632-48bb-abe6-1c36fa9c6212",
        "address": "",
        "phone": "0561514239",
        "email": "ahmedabdelmoneim035@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "772",
    "owner": "Ahmed Abdel Moneim Abdel Hamid Mohamed",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "82318044-aaf4-4586-a5ad-628793f04240",
    "slug": "translation-center",
    "name": "Translation Center",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2004-12-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-12",
    "licenseIssueDate": "2023-01-31",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Translation Center",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_82318044-aaf4-4586-a5ad-628793f04240",
        "address": "",
        "phone": "506429323",
        "email": "tcenter.com@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "235",
    "owner": "Ahmed Fawzi Tamim",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "b74340b5-9b7c-42b5-a0c7-be285a01a92b",
    "slug": "babel-k-legal-translation",
    "name": "Babel K Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCSwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-03-14",
    "licenseStatus": "active",
    "licenseExpiry": "2025-06-01",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Babel K Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b74340b5-9b7c-42b5-a0c7-be285a01a92b",
        "address": "",
        "phone": "0588708071",
        "email": "ahmed.serag10@ymail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "739",
    "owner": "Ahmed Muhammad Imam Muhammad",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "47c8aec7-4ec9-40b2-89a2-5f76c57ac580",
    "slug": "middle-east-legal-translation",
    "name": "Middle East Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2006-01-16",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "licenseIssueDate": "2023-03-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Middle East Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_47c8aec7-4ec9-40b2-89a2-5f76c57ac580",
        "address": "",
        "phone": "506461708",
        "email": "ahabib57@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "276",
    "owner": "Ahmed Muhammad Habib Al-Mashrabak",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "4e80f464-0b75-4b51-8c33-f88dcc8c16ac",
    "slug": "sources-legal-translation",
    "name": "Sources Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-05-20",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "licenseIssueDate": "2023-10-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Sources Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4e80f464-0b75-4b51-8c33-f88dcc8c16ac",
        "address": "",
        "phone": "552858671",
        "email": "Sur Sez Legal Translation Dubai 0552858671",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "512",
    "owner": "Ahmed Mohamed Saleh Shehata",
    "individuals": [
      "70f6cd1a-99b9-498f-92c4-4daf30611ddb"
    ],
    "lawyerCount": 1
  },
  {
    "id": "3716f105-fdb9-4a1e-9b68-39aa06ea8cb4",
    "slug": "mondo-legal-translation",
    "name": "Mondo Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2008-02-11",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-19",
    "licenseIssueDate": "2023-03-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Mondo Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3716f105-fdb9-4a1e-9b68-39aa06ea8cb4",
        "address": "",
        "phone": "0545885472",
        "email": "ahmedsabar@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "302",
    "owner": "Ahmed Mohamed Sabbar",
    "individuals": [
      "70f6cd1a-99b9-498f-92c4-4daf30611ddb"
    ],
    "lawyerCount": 1
  },
  {
    "id": "f3b8a025-8274-4736-bcc9-ea3dd5a3ab95",
    "slug": "ugarit-alpha-translation-services",
    "name": "Ugarit Alpha Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-05-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-30",
    "licenseIssueDate": "2023-08-22",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Ugarit Alpha Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f3b8a025-8274-4736-bcc9-ea3dd5a3ab95",
        "address": "",
        "phone": "503424010",
        "email": "Sphinx.tra@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "441",
    "owner": "Ahmed Mohieddin Ahmed",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "71a33768-015a-4e53-b20c-72d69e427ad2",
    "slug": "half-time-legal-translation-services",
    "name": "Half Time Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-03-30",
    "licenseStatus": "active",
    "licenseExpiry": "2024-01-04",
    "licenseIssueDate": "2021-01-05",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Half Time Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_71a33768-015a-4e53-b20c-72d69e427ad2",
        "address": "",
        "phone": "055-1212850",
        "email": "adib352@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "352",
    "owner": "Adeeb Hassan Ali Al-Musleh",
    "individuals": [
      "54452986-fe9a-4b6b-a78c-47ae400be5c9"
    ],
    "lawyerCount": 1
  },
  {
    "id": "e85f25e6-2169-4d37-9ec7-dadd36fbf7a0",
    "slug": "ministry-of-defense-administrative-affairs-department",
    "name": "Ministry of Defense - Administrative Affairs Department",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-04-03",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Ministry of Defense - Administrative Affairs Department",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e85f25e6-2169-4d37-9ec7-dadd36fbf7a0",
        "address": "",
        "phone": "0508199557",
        "email": "osamaeldeyasty@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "554",
    "owner": "Osama Al-Desti Al-Sayed Al-Bayoumi",
    "individuals": [
      "e0439939-0081-46ec-a3eb-cab980a4dcc5",
      "e3592671-3ed2-4693-90f2-777db84b98cd",
      "25a5a84b-819b-4817-b22f-9afe26bb5137"
    ],
    "lawyerCount": 3
  },
  {
    "id": "687ede0a-db61-44c9-a3cf-87406e7944b4",
    "slug": "ajyad-legal-translation",
    "name": "Ajyad Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-14",
    "licenseIssueDate": "2025-07-24",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Ajyad Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_687ede0a-db61-44c9-a3cf-87406e7944b4",
        "address": "",
        "phone": "971509604038",
        "email": "osama80nasser@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "778",
    "owner": "Osama Al-Nasser",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "8ce46547-815a-473f-ab15-1bfd4cef5fc3",
    "slug": "city-center-for-legal-translation",
    "name": "City Center for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2024-09-30",
    "licenseStatus": "active",
    "licenseExpiry": "2024-10-23",
    "licenseIssueDate": "2024-11-14",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: City Center for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8ce46547-815a-473f-ab15-1bfd4cef5fc3",
        "address": "",
        "phone": "0509779017",
        "email": "isaacmohamed359@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "774",
    "owner": "Ishaq Muhammad Abdel Qader Al-Batsh",
    "individuals": [
      "75df029c-bc84-47da-a3d5-45758bdf715f"
    ],
    "lawyerCount": 1
  },
  {
    "id": "6d8d301f-7079-4f26-b0b7-f5ef1ca8ba9c",
    "slug": "raven-legal-translation",
    "name": "Raven Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2003-06-08",
    "licenseStatus": "active",
    "licenseExpiry": "2027-04-21",
    "licenseIssueDate": "2024-05-28",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Raven Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6d8d301f-7079-4f26-b0b7-f5ef1ca8ba9c",
        "address": "",
        "phone": "050-5491202",
        "email": "ISRAAME@GMAIL.COM",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "217",
    "owner": "Israa Ahmed Makki",
    "individuals": [
      "acf2211c-6afd-47d0-92b6-aab6d4a29abe"
    ],
    "lawyerCount": 1
  },
  {
    "id": "c04b803f-72c5-47e7-a4f8-e00a64875dea",
    "slug": "al-wakil-center-for-legal-translation",
    "name": "Al-Wakil Center for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-03-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-03",
    "licenseIssueDate": "2023-01-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Wakil Center for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c04b803f-72c5-47e7-a4f8-e00a64875dea",
        "address": "",
        "phone": "507199978",
        "email": "israa.nasrallah@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "752",
    "owner": "Israa Nasrallah Sawaleh",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "5417bb8b-1613-488a-a1d0-b08fd5226963",
    "slug": "dana-for-office-services-and-legal-translation",
    "name": "Dana for office services and legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-11-04",
    "licenseStatus": "active",
    "licenseExpiry": "2024-12-05",
    "licenseIssueDate": "2021-12-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Dana for office services and legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5417bb8b-1613-488a-a1d0-b08fd5226963",
        "address": "",
        "phone": "0547701817",
        "email": "islam_zizo@live.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "725",
    "owner": "Islam Juma Shahat Othman",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "7f08b2bf-70db-45d8-b4e1-bcf36f6301fb",
    "slug": "on-time-legal-translation",
    "name": "On Time Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-09-24",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-22",
    "licenseIssueDate": "2023-04-11",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: On Time Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7f08b2bf-70db-45d8-b4e1-bcf36f6301fb",
        "address": "",
        "phone": "0529076513",
        "email": "asma0070@yahoo.fr",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "234",
    "owner": "Asma Bu Mazariq",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "578644d6-9663-4f3f-8821-24f551471d7f",
    "slug": "abu-dhabi-agriculture-and-food-safety-authority",
    "name": "Abu Dhabi Agriculture and Food Safety Authority",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "Chinese"
    ],
    "mojLicense": "2017-04-27",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-23",
    "licenseIssueDate": "2023-08-24",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Abu Dhabi Agriculture and Food Safety Authority",
    "consultationFee": 300,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_578644d6-9663-4f3f-8821-24f551471d7f",
        "address": "",
        "phone": "504149520",
        "email": "smailtchina@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "624",
    "owner": "Ismail Chena",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "337c0eb9-036f-481d-874a-b0b3436efbcc",
    "slug": "raya-al-alam-legal-translation",
    "name": "Raya Al Alam Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBSQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-11-03",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-04",
    "licenseIssueDate": "2023-12-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Raya Al Alam Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_337c0eb9-036f-481d-874a-b0b3436efbcc",
        "address": "",
        "phone": "0505080998",
        "email": "Waditranslation786@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "374",
    "owner": "Ismail Muhammad Ismail",
    "individuals": [
      "a10f953c-b5bc-4d77-b785-20e005e55e92"
    ],
    "lawyerCount": 1
  },
  {
    "id": "437ff572-2462-4d44-a11d-355eb2437658",
    "slug": "al-arabi-legal-translation",
    "name": "Al Arabi Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-11-29",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-17",
    "licenseIssueDate": "2023-01-30",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Arabi Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_437ff572-2462-4d44-a11d-355eb2437658",
        "address": "",
        "phone": "565656349",
        "email": "ashrafsadek_2010@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "530",
    "owner": "Ashraf Sadiq Al-Adl",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "c5779b29-70ee-4d6b-8354-b723e72ebba6",
    "slug": "turjuman-for-legal-translation-services",
    "name": "Turjuman for legal translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-08-07",
    "licenseStatus": "active",
    "licenseExpiry": "2027-10-06",
    "licenseIssueDate": "2025-01-07",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Turjuman for legal translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c5779b29-70ee-4d6b-8354-b723e72ebba6",
        "address": "",
        "phone": "505866257",
        "email": "arkamkarrar@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "271",
    "owner": "The number is Ahmed Babiker",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "b7cea452-d05e-48f6-882d-0755db9ad066",
    "slug": "al-rolla-legal-translation",
    "name": "Al Rolla Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2003-06-16",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-27",
    "licenseIssueDate": "2023-10-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Rolla Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b7cea452-d05e-48f6-882d-0755db9ad066",
        "address": "",
        "phone": "0552330770",
        "email": "hafizmalikshayeb0@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "218",
    "owner": "Hafiz Ahmed Malik",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "8a2189c6-75cc-4adf-ae32-15777120d9d3",
    "slug": "uranus-legal-translation",
    "name": "Uranus Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-04-20",
    "licenseStatus": "active",
    "licenseExpiry": "2027-08-27",
    "licenseIssueDate": "2024-09-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Uranus Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8a2189c6-75cc-4adf-ae32-15777120d9d3",
        "address": "",
        "phone": "971502139653   -  0557329802  -  557669003",
        "email": "Elsnosyali1980@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "717",
    "owner": "Sanusi Muhammad Ali",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "74cc46f2-eb9a-49f1-8879-7981261d2639",
    "slug": "the-new-world-of-legal-translation",
    "name": "The new world of legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBOVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-05-09",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-12",
    "licenseIssueDate": "2023-07-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: The new world of legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_74cc46f2-eb9a-49f1-8879-7981261d2639",
        "address": "",
        "phone": "0509917769",
        "email": "saama_20068@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "756",
    "owner": "Al-Aqqad Haj Adam Abdel Rahim",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "071e20b3-8887-4b1b-8de4-e32a5e5302c9",
    "slug": "mawazine-legal-translation",
    "name": "Mawazine Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-12-12",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-15",
    "licenseIssueDate": "2023-04-05",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Mawazine Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_071e20b3-8887-4b1b-8de4-e32a5e5302c9",
        "address": "",
        "phone": "527769988",
        "email": "Amjad@mawazein.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "689",
    "owner": "Amjad Muhammad Mounir is a gift",
    "individuals": [
      "4705aa17-b28c-4e95-a21e-199215b9851d"
    ],
    "lawyerCount": 1
  },
  {
    "id": "58bcb645-edf8-4afb-a3bf-87c026489064",
    "slug": "department-of-financial-control-government-of-dubai",
    "name": "Department of Financial Control, Government of Dubai",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBERgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2007-04-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-07",
    "licenseIssueDate": "2023-11-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Department of Financial Control, Government of Dubai",
    "consultationFee": 300,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_58bcb645-edf8-4afb-a3bf-87c026489064",
        "address": "",
        "phone": "507244141",
        "email": "amiroy@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "287",
    "owner": "Amir Ibrahim Sadiq",
    "individuals": [
      "d37acb21-c44b-4f97-9d82-8f0570d0a8f5",
      "27bc534d-51c8-42b3-b725-121daad39a0c",
      "4a46b847-f97b-409d-bd96-1b5074c90e91",
      "773779b8-794e-40a9-9658-e2447eeb0499"
    ],
    "lawyerCount": 4
  },
  {
    "id": "50161fdb-f4a0-44aa-91cd-7e1ace83dbc9",
    "slug": "sureline-legal-translation",
    "name": "Sureline Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-06-02",
    "licenseIssueDate": "2024-05-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Sureline Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_50161fdb-f4a0-44aa-91cd-7e1ace83dbc9",
        "address": "",
        "phone": "0555143006",
        "email": "amirgomaa1@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "659",
    "owner": "Amir Juma Al-Halwani",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "a4571681-1d11-4ead-886c-34cb788ed197",
    "slug": "aburov-legal-translation",
    "name": "Aburov Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-04-10",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-01",
    "licenseIssueDate": "2023-06-12",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Aburov Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a4571681-1d11-4ead-886c-34cb788ed197",
        "address": "",
        "phone": "567489060",
        "email": "rashadsharshar@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "411",
    "owner": "Amira Rashad Abdel Wahab",
    "individuals": [
      "4346680b-42d1-48db-afbd-aa39a1d13ea1"
    ],
    "lawyerCount": 1
  },
  {
    "id": "fc0fa9a0-01f0-4d49-907d-27bced6f002d",
    "slug": "unic-legal-translation-abu-dhabi",
    "name": "UNIC Legal Translation - Abu Dhabi",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2025-09-04",
    "licenseIssueDate": "2025-09-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: UNIC Legal Translation - Abu Dhabi",
    "consultationFee": 300,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_fc0fa9a0-01f0-4d49-907d-27bced6f002d",
        "address": "",
        "phone": "0509905886",
        "email": "trans.amirasabry@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "798",
    "owner": "Amira Sabry Muhammad Madbouly",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "f399919f-2197-498a-9a63-3ef61861e9a3",
    "slug": "word-perfect-for-legal-translation",
    "name": "Word Perfect for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-05-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-17",
    "licenseIssueDate": "2023-09-25",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Word Perfect for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f399919f-2197-498a-9a63-3ef61861e9a3",
        "address": "",
        "phone": "0503222610",
        "email": "Omaimababiker74@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "436",
    "owner": "Omaima Ahmed Muhammad Babakir",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "c2c4523d-013f-46b3-9e83-e349422611ec",
    "slug": "shakespeare-legal-translation",
    "name": "Shakespeare Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "Spanish"
    ],
    "mojLicense": "2012-04-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-13",
    "licenseIssueDate": "2023-06-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Shakespeare Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c2c4523d-013f-46b3-9e83-e349422611ec",
        "address": "",
        "phone": "508587301",
        "email": "Syruae1@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "414",
    "owner": "Anas Ibrahim Al-Hariri",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "78e9e045-588f-42b6-83b9-95e6ea318558",
    "slug": "high-sky-typing-and-legal-translation",
    "name": "High Sky Typing and Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-09-30",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-18",
    "licenseIssueDate": "2023-12-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: High Sky Typing and Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_78e9e045-588f-42b6-83b9-95e6ea318558",
        "address": "",
        "phone": "0551666786",
        "email": "eyadoo1@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "528",
    "owner": "Iyad Ishaq Al-Hamasha",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "3c58864e-5b42-42ac-af67-25514e405110",
    "slug": "avani-legal-translation-services",
    "name": "Avani Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-04-20",
    "licenseStatus": "active",
    "licenseExpiry": "2027-09-30",
    "licenseIssueDate": "2024-10-01",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Avani Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3c58864e-5b42-42ac-af67-25514e405110",
        "address": "",
        "phone": "0521046655",
        "email": "ejp@moj.gov.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "96",
    "owner": "Iyad Adnan Zeino",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "b653156f-0951-4beb-9f48-c1efed056edb",
    "slug": "unic-legal-translation-al-ain",
    "name": "UNIC Legal Translation - Al Ain",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-06-01",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-16",
    "licenseIssueDate": "2023-10-17",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: UNIC Legal Translation - Al Ain",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b653156f-0951-4beb-9f48-c1efed056edb",
        "address": "",
        "phone": "0529667567",
        "email": "Unique12300a@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "600",
    "owner": "Iyas Muhammad Al-Atoum",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "be3c6f29-15ae-4930-8c34-915d05c1306e",
    "slug": "perfect-legal-translation",
    "name": "Perfect Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-04-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-06",
    "licenseIssueDate": "2023-06-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Perfect Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_be3c6f29-15ae-4930-8c34-915d05c1306e",
        "address": "",
        "phone": "0503389090",
        "email": "perfecttrans.shj@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "407",
    "owner": "Enas Adel Joseph",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "63665512-79f7-45cd-a93b-b216a64f6d4d",
    "slug": "abu-rouf-legal-translation-abu-dhabi",
    "name": "Abu Rouf Legal Translation - Abu Dhabi",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Abu Rouf Legal Translation - Abu Dhabi",
    "consultationFee": 300,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_63665512-79f7-45cd-a93b-b216a64f6d4d",
        "address": "",
        "phone": "0581238081",
        "email": "altlegal4@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "272",
    "owner": "Babiker Mustafa Al-Hajj",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "bae5a875-c773-4dac-8d4e-cdabd178b6e0",
    "slug": "tim-legal-translation",
    "name": "Tim Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-11-04",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-27",
    "licenseIssueDate": "2024-12-05",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Tim Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bae5a875-c773-4dac-8d4e-cdabd178b6e0",
        "address": "",
        "phone": "505396630",
        "email": "bahaatrans@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "724",
    "owner": "Bahaa Ahmed Fouad Shamah",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "b07c1529-62a9-4dd6-a72b-609765559e1b",
    "slug": "madad-legal-translation",
    "name": "Madad Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-03-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-22",
    "licenseIssueDate": "2023-10-30",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Madad Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b07c1529-62a9-4dd6-a72b-609765559e1b",
        "address": "",
        "phone": "553392297",
        "email": "bahaaabuelmagd@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "391",
    "owner": "Bahaa Abdel Wahab Abdel",
    "individuals": [
      "4346680b-42d1-48db-afbd-aa39a1d13ea1"
    ],
    "lawyerCount": 1
  },
  {
    "id": "4b37ba26-eac2-4b4c-a6ee-d8fdc12fb5a6",
    "slug": "cervantes-legal-translation",
    "name": "Cervantes Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-06-01",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "licenseIssueDate": "2023-02-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Cervantes Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4b37ba26-eac2-4b4c-a6ee-d8fdc12fb5a6",
        "address": "",
        "phone": "529139394",
        "email": "tmw.orientemedio@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "611",
    "owner": "Tamer Magdy Wahba",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "0350c022-4493-4c94-9536-53a0ce6f868b",
    "slug": "al-masa-legal-translation",
    "name": "Al Masa Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1997-07-05",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-13",
    "licenseIssueDate": "2023-05-30",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Masa Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0350c022-4493-4c94-9536-53a0ce6f868b",
        "address": "",
        "phone": "506127447",
        "email": "gm@dlt.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "131",
    "owner": "Tayseer Muhammad Al-Ghouthani",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "6ed1fbad-687a-4130-ab79-0e78b9454c9f",
    "slug": "mada-legal-consultations-and-translation",
    "name": "Mada Legal Consultations and Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-03-30",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-07",
    "licenseIssueDate": "2023-06-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Mada Legal Consultations and Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6ed1fbad-687a-4130-ab79-0e78b9454c9f",
        "address": "",
        "phone": "0505882252",
        "email": "jalal@madapr.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "373",
    "owner": "Jalal Hussein Al-Khalil",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "ee4ab79f-3a5f-47de-9d23-ad65f6a4448b",
    "slug": "transbridge-legal-translation",
    "name": "Transbridge Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-06-01",
    "licenseStatus": "active",
    "licenseExpiry": "2025-07-03",
    "licenseIssueDate": "2022-10-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Transbridge Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ee4ab79f-3a5f-47de-9d23-ad65f6a4448b",
        "address": "",
        "phone": "0506997645",
        "email": "Jmhdlg56@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "605",
    "owner": "Jalal Muhammad Sayed",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "1c2b01df-553c-4167-afee-24fcc8d3644e",
    "slug": "zoe-legal-translation",
    "name": "Zoe Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBaTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-06-04",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-03",
    "licenseIssueDate": "2024-01-22",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Zoe Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1c2b01df-553c-4167-afee-24fcc8d3644e",
        "address": "",
        "phone": "0563549873",
        "email": "shafikgamal@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "468",
    "owner": "Gamal Abd Rabbo Shafiq",
    "individuals": [
      "e81ea903-d54c-457c-8c18-0ec5927e7f22"
    ],
    "lawyerCount": 1
  },
  {
    "id": "77d913de-602f-4726-9a6a-88183a369694",
    "slug": "moscow-legal-translation",
    "name": "Moscow Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2003-05-28",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-07",
    "licenseIssueDate": "2023-04-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Moscow Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_77d913de-602f-4726-9a6a-88183a369694",
        "address": "",
        "phone": "505758807",
        "email": "jamal969@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "210",
    "owner": "Jamal Mahmoud Rashad Abu Kishk",
    "individuals": [
      "3548058e-fbdb-464d-920e-fde5f21bd0f2"
    ],
    "lawyerCount": 1
  },
  {
    "id": "59acd253-2c8f-416d-8572-44b22f5fb34c",
    "slug": "al-alsun-translation-services-dubai",
    "name": "Al-Alsun Translation Services - Dubai",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-02-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-18",
    "licenseIssueDate": "2023-10-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Alsun Translation Services - Dubai",
    "consultationFee": 300,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_59acd253-2c8f-416d-8572-44b22f5fb34c",
        "address": "",
        "phone": "0544379997",
        "email": "info@alsuntranslation.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "621",
    "owner": "Juma Hashem Fouda",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "861f3f2e-7757-4f94-a8e7-d667c5f118a3",
    "slug": "arab-levant-legal-translation",
    "name": "Arab Levant Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1999-12-19",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-14",
    "licenseIssueDate": "2023-11-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Arab Levant Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_861f3f2e-7757-4f94-a8e7-d667c5f118a3",
        "address": "",
        "phone": "529999905",
        "email": "jena.translator@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "161",
    "owner": "Jinan Ahmed Abdel Khaleq",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "5cb38216-c0f3-4485-afd9-f4641fc17925",
    "slug": "arcadia-legal-translation",
    "name": "Arcadia Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Arcadia Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5cb38216-c0f3-4485-afd9-f4641fc17925",
        "address": "",
        "phone": "504947310",
        "email": "georgeanthonykhawam@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "115",
    "owner": "George Antoine Khawam",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "da9fc650-e437-45b4-9876-342223bdf53f",
    "slug": "opal-legal-translation-services",
    "name": "Opal Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-11-01",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Opal Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_da9fc650-e437-45b4-9876-342223bdf53f",
        "address": "",
        "phone": "0559025037",
        "email": "gihan.rezk@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "741",
    "owner": "Jihan Abdul Nabi Muhammad",
    "individuals": [
      "80807574-b187-483e-a506-292f175536a2"
    ],
    "lawyerCount": 1
  },
  {
    "id": "ae5c0403-5ac2-4cab-8e2c-3f48694e7b5f",
    "slug": "smooth-legal-translation",
    "name": "Smooth legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-12-12",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": "2023-01-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Smooth legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ae5c0403-5ac2-4cab-8e2c-3f48694e7b5f",
        "address": "",
        "phone": "508883909",
        "email": "Salasa Legal Translation Office Dubai",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "686",
    "owner": "Hazem Al-Sharqawi",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "64e12419-74f7-435d-96e1-e9ce2c14a1ff",
    "slug": "active-translation-services-dubai",
    "name": "Active Translation Services - Dubai",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-12-24",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-09",
    "licenseIssueDate": "2023-04-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Active Translation Services - Dubai",
    "consultationFee": 300,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_64e12419-74f7-435d-96e1-e9ce2c14a1ff",
        "address": "",
        "phone": "0501289040",
        "email": "manager@a4t.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "427",
    "owner": "Hossam Hamed Mansour",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "48eea47d-2d85-42e8-af51-a8208ea3db29",
    "slug": "prestige-legal-translation",
    "name": "Prestige Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2004-04-11",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-02",
    "licenseIssueDate": "2023-08-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Prestige Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_48eea47d-2d85-42e8-af51-a8208ea3db29",
        "address": "",
        "phone": "507849474",
        "email": "translator1964@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "231",
    "owner": "Hassan Ali Saeed",
    "individuals": [
      "54452986-fe9a-4b6b-a78c-47ae400be5c9"
    ],
    "lawyerCount": 1
  },
  {
    "id": "982ec3ed-826c-4b32-af4d-e1450b987363",
    "slug": "ugarit-delta-legal-translation",
    "name": "Ugarit Delta Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-11-01",
    "licenseStatus": "active",
    "licenseExpiry": "2023-03-12",
    "licenseIssueDate": "2022-11-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Ugarit Delta Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_982ec3ed-826c-4b32-af4d-e1450b987363",
        "address": "",
        "phone": "0543281260",
        "email": "randahassan045@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "742",
    "owner": "Hassan Kamal Sayed Hassan",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "0f67fe6e-3ee8-4c5f-85d9-cb00b90166ae",
    "slug": "al-awael-legal-translation",
    "name": "Al Awael Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2006-06-17",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-24",
    "licenseIssueDate": "2023-05-24",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Awael Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0f67fe6e-3ee8-4c5f-85d9-cb00b90166ae",
        "address": "",
        "phone": "503721160",
        "email": "alawael_trans@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "256",
    "owner": "Hussein Mahmoud Hafez",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "c5bc6662-4658-4f70-97b4-71d09bf643ae",
    "slug": "al-manar-legal-translation",
    "name": "Al-Manar Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-06-01",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-03",
    "licenseIssueDate": "2023-05-30",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Manar Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c5bc6662-4658-4f70-97b4-71d09bf643ae",
        "address": "",
        "phone": "0506644157",
        "email": "hamadhussien44@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "601",
    "owner": "Hamad El Nil Hussein",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "4cdb9b22-d80a-445d-97fa-85a83699aa79",
    "slug": "professional-legal-translation",
    "name": "Professional legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-02-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-01",
    "licenseIssueDate": "2023-03-07",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Professional legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4cdb9b22-d80a-445d-97fa-85a83699aa79",
        "address": "",
        "phone": "521764210",
        "email": "hamdy588@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "628",
    "owner": "Hamdi Muhammad Abu Zahra",
    "individuals": [
      "65e5c070-45f3-4806-8b78-a5067c6ec296"
    ],
    "lawyerCount": 1
  },
  {
    "id": "77d4ce89-5797-4b6c-9f86-fb524731e7cd",
    "slug": "arkan-legal-translation",
    "name": "Arkan Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-06-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-16",
    "licenseIssueDate": "2023-11-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Arkan Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_77d4ce89-5797-4b6c-9f86-fb524731e7cd",
        "address": "",
        "phone": "564313250",
        "email": "translatorelwan@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "701",
    "owner": "Khaled Muhammad Abdel Tawab",
    "individuals": [
      "75df029c-bc84-47da-a3d5-45758bdf715f"
    ],
    "lawyerCount": 1
  },
  {
    "id": "b32fbba6-ac2e-4bfb-825c-a4d92be78a22",
    "slug": "excel-house-translation-services",
    "name": "Excel House Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-16",
    "licenseIssueDate": "2025-10-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Excel House Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b32fbba6-ac2e-4bfb-825c-a4d92be78a22",
        "address": "",
        "phone": "581497298",
        "email": "trans.khalid@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "783",
    "owner": "Khaled Mayhoub Muhammad Salem",
    "individuals": [
      "80807574-b187-483e-a506-292f175536a2"
    ],
    "lawyerCount": 1
  },
  {
    "id": "53abefd0-07e8-4358-8326-8a2461ae35f3",
    "slug": "al-resala-legal-translation-services",
    "name": "Al Resala Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-16",
    "licenseIssueDate": "2025-07-07",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Resala Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_53abefd0-07e8-4358-8326-8a2461ae35f3",
        "address": "",
        "phone": "0561442598",
        "email": "khadijahabdulrahman51@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "785",
    "owner": "Khadija Abdul Rahman Bakr Al-Amiri",
    "individuals": [
      "55a24229-97d3-4b63-86f6-a3b4b61705c0"
    ],
    "lawyerCount": 1
  },
  {
    "id": "dfac1461-60ec-4232-983d-6bc336b99679",
    "slug": "dynamic-translation-and-office-services",
    "name": "Dynamic translation and office services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-11-19",
    "licenseStatus": "active",
    "licenseExpiry": "2025-04-27",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Dynamic translation and office services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dfac1461-60ec-4232-983d-6bc336b99679",
        "address": "",
        "phone": "0563585722",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "451",
    "owner": "Khader Amin Ibrahim",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "f6141f50-5f76-4cfd-968a-b52664f84db4",
    "slug": "hafeet-legal-translation",
    "name": "Hafeet Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 39,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1986-11-11",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-03",
    "licenseIssueDate": "2023-01-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Hafeet Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f6141f50-5f76-4cfd-968a-b52664f84db4",
        "address": "",
        "phone": "508312217",
        "email": "khader4@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "31",
    "owner": "Khader Abdel Saeed Al-Helou",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "b0ef39ac-6bc8-4727-ae64-1b9b4787a2e3",
    "slug": "international-union-for-translation-and-administrative-services",
    "name": "International Union for Translation and Administrative Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJVQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-12-24",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-07",
    "licenseIssueDate": "2023-03-14",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: International Union for Translation and Administrative Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b0ef39ac-6bc8-4727-ae64-1b9b4787a2e3",
        "address": "",
        "phone": "026281199",
        "email": "K_jayousi@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "431",
    "owner": "Khalil Rashid Al-Jayousi",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "5e3b09dd-16e3-4e15-97e4-cd8e020202ff",
    "slug": "turjuman-al-khaleej-legal-translation-services",
    "name": "Turjuman Al Khaleej Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "Hindi"
    ],
    "mojLicense": "2018-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-24",
    "licenseIssueDate": "2024-04-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Turjuman Al Khaleej Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5e3b09dd-16e3-4e15-97e4-cd8e020202ff",
        "address": "",
        "phone": "971509269235",
        "email": "legal@torjoman.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "664",
    "owner": "Tents behind Sayed",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "f0afac49-7b73-4d2e-94ba-0277b200ea17",
    "slug": "ideal-for-legal-translation-and-business-services",
    "name": "Ideal for legal translation and business services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-04-11",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-16",
    "licenseIssueDate": "2023-04-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Ideal for legal translation and business services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f0afac49-7b73-4d2e-94ba-0277b200ea17",
        "address": "",
        "phone": "503466630",
        "email": "ideal@eim.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "371",
    "owner": "Dima Nabih Badawi",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "029a4eb3-8886-4cd0-947c-a2ea67af0c11",
    "slug": "dar-al-alsun-for-legal-translation-abu-dhabi",
    "name": "Dar Al-Alsun for Legal Translation - Abu Dhabi",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-04-20",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-28",
    "licenseIssueDate": "2024-06-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Dar Al-Alsun for Legal Translation - Abu Dhabi",
    "consultationFee": 300,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_029a4eb3-8886-4cd0-947c-a2ea67af0c11",
        "address": "",
        "phone": "0528905051",
        "email": "dinaabdullah88@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "715",
    "owner": "Dina Abdullah Muhammad Hammam",
    "individuals": [
      "207f4ae0-4b16-4fa0-8e14-dd37f4663484"
    ],
    "lawyerCount": 1
  },
  {
    "id": "ead62fbc-0051-41e4-a839-3a14105930b1",
    "slug": "al-yusr-legal-translation",
    "name": "Al Yusr Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBWQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-04-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-22",
    "licenseIssueDate": "2023-12-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Yusr Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ead62fbc-0051-41e4-a839-3a14105930b1",
        "address": "",
        "phone": "0504993540",
        "email": "rami.982@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "555",
    "owner": "Ramy Jamil Bousalah",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "42334afe-de42-460a-8a78-cfafef09291e",
    "slug": "al-nibras-legal-translation",
    "name": "Al Nibras Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-12-14",
    "licenseStatus": "active",
    "licenseExpiry": "2028-05-31",
    "licenseIssueDate": "2025-05-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Nibras Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_42334afe-de42-460a-8a78-cfafef09291e",
        "address": "",
        "phone": "0504077044",
        "email": "trans.ramireda@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "730",
    "owner": "Rami Reda Fathi Ahmed",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "7e6dd372-353b-438d-8662-920391d24aca",
    "slug": "legal-translation-center",
    "name": "Legal Translation Center",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-06-01",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "licenseIssueDate": "2023-07-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Legal Translation Center",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7e6dd372-353b-438d-8662-920391d24aca",
        "address": "",
        "phone": "0554578584",
        "email": "ranyaghantoos@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "608",
    "owner": "Rania Khalil Ghantous",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "171b337d-903f-44d2-826d-9f0a9f4d08aa",
    "slug": "transpro-legal-translation",
    "name": "Transpro Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-05-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-24",
    "licenseIssueDate": "2023-09-26",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Transpro Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_171b337d-903f-44d2-826d-9f0a9f4d08aa",
        "address": "",
        "phone": "506566642",
        "email": "info@transprome.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "514",
    "owner": "Rania Kabani Iskander",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "9afcff58-138c-4049-ba3b-33e4f66b1ffc",
    "slug": "index-for-legal-translation",
    "name": "Index for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-10-07",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-07",
    "licenseIssueDate": "2023-06-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Index for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9afcff58-138c-4049-ba3b-33e4f66b1ffc",
        "address": "",
        "phone": "555842144",
        "email": "rabtranslator@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "444",
    "owner": "Rabiei Ebada Muhammad",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "59cdea39-0f91-4e72-8c2b-7d2c86c7fa34",
    "slug": "dar-al-murjan-translation-services",
    "name": "Dar Al-Murjan Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-05-14",
    "licenseStatus": "active",
    "licenseExpiry": "2028-05-12",
    "licenseIssueDate": "2025-08-22",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Dar Al-Murjan Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_59cdea39-0f91-4e72-8c2b-7d2c86c7fa34",
        "address": "",
        "phone": "557553162",
        "email": "rfkh999@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "713",
    "owner": "Rashad Faleh Ali Al-Hassan",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "67484e6d-dba0-4565-8f2f-e4e1bbee2a77",
    "slug": "elaf-legal-translation",
    "name": "Elaf Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Elaf Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_67484e6d-dba0-4565-8f2f-e4e1bbee2a77",
        "address": "",
        "phone": "0544986633",
        "email": "elit4rms@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "648",
    "owner": "Radwan Zawash",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "05790b16-db88-46a2-9c0b-2ac263eca518",
    "slug": "al-sayed-legal-translation",
    "name": "Al Sayed Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-04-13",
    "licenseStatus": "active",
    "licenseExpiry": "2023-11-02",
    "licenseIssueDate": "2020-11-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Sayed Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_05790b16-db88-46a2-9c0b-2ac263eca518",
        "address": "",
        "phone": "0523260128",
        "email": "info@translationindubai.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "549",
    "owner": "Ramadan Ahmed Kardala",
    "individuals": [
      "b6717395-badd-40f2-9c6e-60415166a655"
    ],
    "lawyerCount": 1
  },
  {
    "id": "e5026e22-8963-489e-86c0-797aaeedef6c",
    "slug": "scribe-for-legal-translation",
    "name": "Scribe for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-11-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-25",
    "licenseIssueDate": "2024-01-29",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Scribe for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e5026e22-8963-489e-86c0-797aaeedef6c",
        "address": "",
        "phone": "0586310395",
        "email": "ramadan.gamal.5@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "762",
    "owner": "Ramadan Jamal Muhammad Ibrahim",
    "individuals": [
      "b6717395-badd-40f2-9c6e-60415166a655"
    ],
    "lawyerCount": 1
  },
  {
    "id": "fa395e03-7777-45e8-9795-79f9ed7a00e7",
    "slug": "abu-dhabi-legal-translation-center",
    "name": "Abu Dhabi Legal Translation Center",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-11-19",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-29",
    "licenseIssueDate": "2023-02-07",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Abu Dhabi Legal Translation Center",
    "consultationFee": 300,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_fa395e03-7777-45e8-9795-79f9ed7a00e7",
        "address": "",
        "phone": "501573571",
        "email": "ADLTC@EMIRATES.NET.AE",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "480",
    "owner": "Rosetta Raymond Akl",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "b89dd8c6-91a8-44ed-a333-1d68d31a5ff0",
    "slug": "context-for-legal-translation-services",
    "name": "Context for legal translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Context for legal translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b89dd8c6-91a8-44ed-a333-1d68d31a5ff0",
        "address": "",
        "phone": "0528143344",
        "email": "r.boutros@siyakconsultancy.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "655",
    "owner": "Rima George Boutros",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "e8a2318d-502b-416a-9111-3d32589e3c29",
    "slug": "al-jazeera-legal-translation-services",
    "name": "Al Jazeera Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBSgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2005-06-19",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-12",
    "licenseIssueDate": "2023-05-12",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Jazeera Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e8a2318d-502b-416a-9111-3d32589e3c29",
        "address": "",
        "phone": "0555476992",
        "email": "Transquick69@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "254",
    "owner": "Zahir Muhammad Zubair",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "8c5646fe-013e-468a-bf12-64711ebff7b8",
    "slug": "translingo-for-legal-translation-and-linguistic-proofreading-services",
    "name": "TransLingo for legal translation and linguistic proofreading services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-10",
    "licenseIssueDate": "2025-08-28",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: TransLingo for legal translation and linguistic proofreading services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8c5646fe-013e-468a-bf12-64711ebff7b8",
        "address": "",
        "phone": "0553465763",
        "email": "abedtranslator1988@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "789",
    "owner": "Zain Al-Abidin Sarhan Al-Sayed Rizk",
    "individuals": [
      "a2d246e3-d25e-4f7b-87cd-ca1649eea193"
    ],
    "lawyerCount": 1
  },
  {
    "id": "5b78bb9b-10a1-4823-aa7d-1e0ba41d2fb0",
    "slug": "oxford-legal-translation",
    "name": "Oxford Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-11-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-06",
    "licenseIssueDate": "2024-05-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Oxford Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5b78bb9b-10a1-4823-aa7d-1e0ba41d2fb0",
        "address": "",
        "phone": "50 321 2019  -  0503212019",
        "email": "zeinabadelaziz211@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "766",
    "owner": "Zainab Abdel Aziz Mohamed Ahmed",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "b8589e6c-deb6-402c-b60b-c27881c8e18a",
    "slug": "advanced-legal-translation-and-printing-services",
    "name": "Advanced legal translation and printing services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-03-22",
    "licenseStatus": "active",
    "licenseExpiry": "2023-10-18",
    "licenseIssueDate": "2020-02-02",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Advanced legal translation and printing services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b8589e6c-deb6-402c-b60b-c27881c8e18a",
        "address": "",
        "phone": "0527989833",
        "email": "suad.mannaa@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "126",
    "owner": "Souad Othman Manna",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "950af44c-b3df-4fd2-98df-8d32c8465b4c",
    "slug": "proficiency-in-legal-translation",
    "name": "Proficiency in legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-12-12",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-02",
    "licenseIssueDate": "2023-02-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Proficiency in legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_950af44c-b3df-4fd2-98df-8d32c8465b4c",
        "address": "",
        "phone": "0526750470",
        "email": "info@ejadadubai.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "685",
    "owner": "Saad Muhammad Muhammad Abu Al-Anin",
    "individuals": [
      "510ac6ad-256b-459a-92d6-8df5eeb83051"
    ],
    "lawyerCount": 1
  },
  {
    "id": "e953349c-f85b-4647-b3a4-c9ad7d0e3a04",
    "slug": "maria-maria-real-estate-development-and-investment",
    "name": "Maria Maria Real Estate Development and Investment",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-03-03",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-15",
    "licenseIssueDate": "2024-02-01",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Maria Maria Real Estate Development and Investment",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e953349c-f85b-4647-b3a4-c9ad7d0e3a04",
        "address": "",
        "phone": "552626268",
        "email": "United1954@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "356",
    "owner": "Salsabil Mahmoud Al-Kurdi",
    "individuals": [
      "f67d6e20-4a93-4e86-9559-c92db947a35d"
    ],
    "lawyerCount": 1
  },
  {
    "id": "bb05bb8f-cd09-4304-af22-26563c300f6a",
    "slug": "three-sixty-five-legal-translation",
    "name": "Three Sixty Five Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2024-03-17",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Three Sixty Five Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bb05bb8f-cd09-4304-af22-26563c300f6a",
        "address": "",
        "phone": "541776163",
        "email": "s_abdulrahman@abv.bg",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "711",
    "owner": "Salafia Misbah Abdul Rahman",
    "individuals": [
      "55a24229-97d3-4b63-86f6-a3b4b61705c0"
    ],
    "lawyerCount": 1
  },
  {
    "id": "bfe85574-d918-48d6-8daf-9c58825a875c",
    "slug": "afamia-translation-and-linguistic-services",
    "name": "Afamia Translation and Linguistic Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-12-12",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-08",
    "licenseIssueDate": "2023-03-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Afamia Translation and Linguistic Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bfe85574-d918-48d6-8daf-9c58825a875c",
        "address": "",
        "phone": "555270026",
        "email": "uboutrad@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "695",
    "owner": "Salma Abobo",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "b60252dc-d6c0-452f-8bb8-35cd709f0f26",
    "slug": "abulhoul-for-legal-translation",
    "name": "Abulhoul for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 24,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2002-02-16",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-04",
    "licenseIssueDate": "2023-07-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Abulhoul for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b60252dc-d6c0-452f-8bb8-35cd709f0f26",
        "address": "",
        "phone": "0555541198",
        "email": "abulhoul2009@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "192",
    "owner": "Salwa Hamed Abdel Muttalib",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "5f4a11fc-da16-4aa0-b199-66790ca4a627",
    "slug": "monitoring-center-for-legal-translation",
    "name": "Monitoring Center for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-03-14",
    "licenseStatus": "active",
    "licenseExpiry": "2025-04-05",
    "licenseIssueDate": "2022-05-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Monitoring Center for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5f4a11fc-da16-4aa0-b199-66790ca4a627",
        "address": "",
        "phone": "0503029055",
        "email": "sumaya102@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "737",
    "owner": "Sumaya Adam Issa Ishaq",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "a50c9fd6-6763-4c3b-b845-73fc75aae60c",
    "slug": "saeed-for-legal-administration-and-translation",
    "name": "Saeed for Legal Administration and Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-11-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-20",
    "licenseIssueDate": "2024-03-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Saeed for Legal Administration and Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a50c9fd6-6763-4c3b-b845-73fc75aae60c",
        "address": "",
        "phone": "0586606082",
        "email": "samirabdelsalam096@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "760",
    "owner": "Samir Abdel Salam Abdel Salam Ibrahim Jumaa",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "3bddc04e-2972-4bad-9414-424a117db133",
    "slug": "sawsan-latayfa-for-legal-translation-and-trademark-services",
    "name": "Sawsan Latayfa for legal translation and trademark services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2008-02-10",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-26",
    "licenseIssueDate": "2023-02-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Sawsan Latayfa for legal translation and trademark services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3bddc04e-2972-4bad-9414-424a117db133",
        "address": "",
        "phone": "0507691985",
        "email": "slataifeh@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "74",
    "owner": "Sawsan Sidqi Al-Latifa",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "7c92983f-171b-45ec-9f34-edd943929950",
    "slug": "investment-and-development-office-ras-al-khaimah-government",
    "name": "Investment and Development Office - Ras Al Khaimah Government",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBJRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-04-26",
    "licenseStatus": "active",
    "licenseExpiry": "2024-01-08",
    "licenseIssueDate": "2024-01-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Investment and Development Office - Ras Al Khaimah Government",
    "consultationFee": 300,
    "emirate": "Ras Al Khaimah",
    "verified": true,
    "offices": [
      {
        "id": "office_7c92983f-171b-45ec-9f34-edd943929950",
        "address": "",
        "phone": "566226036",
        "email": "sayed_Lsherif@yhoo.com",
        "emirate": "Ras Al Khaimah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "631",
    "owner": "Sayed Fathi Ibrahim Abdel Aal",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "9637f5f6-72c5-4b9e-a1e5-6dad98a5f9b0",
    "slug": "jusoor-legal-translation",
    "name": "Jusoor Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-06-01",
    "licenseStatus": "active",
    "licenseExpiry": "2028-08-12",
    "licenseIssueDate": "2025-09-17",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Jusoor Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9637f5f6-72c5-4b9e-a1e5-6dad98a5f9b0",
        "address": "",
        "phone": "0504321239",
        "email": "shaman.alsharou@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "603",
    "owner": "Shaman Ahmed Al-Sharaa",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "81fe642b-37f2-4445-8a91-7247e348e436",
    "slug": "domninet-legal-translation",
    "name": "Domninet Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-07-06",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-09",
    "licenseIssueDate": "2019-07-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Domninet Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_81fe642b-37f2-4445-8a91-7247e348e436",
        "address": "",
        "phone": "0557477020",
        "email": "sh.diab@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "678",
    "owner": "Shaima Jaber Morsi",
    "individuals": [
      "2ab3ef58-166f-464d-9847-4cf0ce5ccdb3"
    ],
    "lawyerCount": 1
  },
  {
    "id": "efedbc85-1393-4426-8b81-137123d1da13",
    "slug": "edraak-legal-translation",
    "name": "Edraak Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-12-14",
    "licenseStatus": "active",
    "licenseExpiry": "2025-02-28",
    "licenseIssueDate": "2022-03-01",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Edraak Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_efedbc85-1393-4426-8b81-137123d1da13",
        "address": "",
        "phone": "569886895",
        "email": "brave109@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "729",
    "owner": "Saber Salem Mohammed Salem",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "1bff184b-65bc-4514-8f0c-7b479054951f",
    "slug": "modern-office-for-legal-translation",
    "name": "Modern Office for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1998-06-08",
    "licenseStatus": "active",
    "licenseExpiry": "2023-11-14",
    "licenseIssueDate": "2023-11-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Modern Office for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1bff184b-65bc-4514-8f0c-7b479054951f",
        "address": "",
        "phone": "00971-4-2234664",
        "email": "mltb.dubai@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "143",
    "owner": "A noble military man",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "992e56a9-53e0-41ad-9605-93fd99692454",
    "slug": "communication-for-legal-translation",
    "name": "Communication for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Communication for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_992e56a9-53e0-41ad-9605-93fd99692454",
        "address": "",
        "phone": "0507431134",
        "email": "nasad.hastar@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "181",
    "owner": "Salah Ahmed Mahmoud El-Zein",
    "individuals": [
      "6ef616b3-688e-4c69-85ef-254207d5560e",
      "8455c991-12e9-4e39-84c4-9feff2f8e762"
    ],
    "lawyerCount": 2
  },
  {
    "id": "c573a7e9-b8fa-4b06-8f28-2b1139d589cb",
    "slug": "perfection-for-management-consulting-and-legal-translation",
    "name": "Perfection for management consulting and legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-11-01",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-25",
    "licenseIssueDate": "2023-04-12",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Perfection for management consulting and legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c573a7e9-b8fa-4b06-8f28-2b1139d589cb",
        "address": "",
        "phone": "0557218986",
        "email": "salah12389896@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "744",
    "owner": "Salahuddin Hassan Muhammad",
    "individuals": [
      "dcc53252-dde0-4ee2-918e-574335d2c554"
    ],
    "lawyerCount": 1
  },
  {
    "id": "522317c7-02eb-4c2f-b67f-5f0d134a1b48",
    "slug": "crown-legal-translation-services",
    "name": "Crown Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-10",
    "licenseIssueDate": "2025-09-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Crown Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_522317c7-02eb-4c2f-b67f-5f0d134a1b48",
        "address": "",
        "phone": "0557536164",
        "email": "tarek.m.elneklawy@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "780",
    "owner": "Tariq Muhammad Mamdouh Muhammad Al-Naklawy",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "a3b3203b-8661-4668-9848-3e4ab49ce323",
    "slug": "text-match-for-legal-translation",
    "name": "Text Match for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-06-16",
    "licenseStatus": "active",
    "licenseExpiry": "2023-08-18",
    "licenseIssueDate": "2023-08-24",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Text Match for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a3b3203b-8661-4668-9848-3e4ab49ce323",
        "address": "",
        "phone": "0506138410",
        "email": "Txtmatch.uae@gmal.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "380",
    "owner": "Tariq Mahmoud Al-Kafri",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "e4fb1350-6f8b-4c64-9794-62d69a8ebb74",
    "slug": "crossworld-translation-limited-source-fz",
    "name": "Crossworld Translation Limited - Source FZ",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-04-01",
    "licenseIssueDate": "2025-08-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Crossworld Translation Limited - Source FZ",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e4fb1350-6f8b-4c64-9794-62d69a8ebb74",
        "address": "",
        "phone": "0545022441",
        "email": "projects@crossworld-translation.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "776",
    "owner": "Tariq Mustafa Ibrahim Salem Marei",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "a94b9701-71a7-41b7-b621-b1f6ead3ae46",
    "slug": "the-precious-wisdom-of-legal-translation",
    "name": "The precious wisdom of legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 35,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1990-08-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-31",
    "licenseIssueDate": "2023-09-27",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: The precious wisdom of legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a94b9701-71a7-41b7-b621-b1f6ead3ae46",
        "address": "",
        "phone": "0566214522",
        "email": "abdeenaltaher2021@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "68",
    "owner": "Abdeen Al-Taher Abdel Qader Hamad",
    "individuals": [
      "49cf3146-af83-4853-a160-8b93782d274a"
    ],
    "lawyerCount": 1
  },
  {
    "id": "f0fe32bc-21c2-449a-b9d4-f64b99f606d1",
    "slug": "oswal-legal-translation",
    "name": "Oswal Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBPTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-06-16",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-12",
    "licenseIssueDate": "2023-06-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Oswal Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f0fe32bc-21c2-449a-b9d4-f64b99f606d1",
        "address": "",
        "phone": "554767192",
        "email": "info@osuol.net",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "385",
    "owner": "Adel Rajab Al-Arab",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "736e943e-d778-4370-a336-332be1b5279a",
    "slug": "al-wasl-legal-translation",
    "name": "Al Wasl Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Wasl Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_736e943e-d778-4370-a336-332be1b5279a",
        "address": "",
        "phone": "561344232",
        "email": "wasl00971@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "184",
    "owner": "Atef Othman Muhammad",
    "individuals": [
      "e858364c-18b8-4679-a966-ffb0b0e27b50"
    ],
    "lawyerCount": 1
  },
  {
    "id": "eee1fe77-c994-4fe1-9bb9-83ecd832091b",
    "slug": "praise-be-to-legal-translation",
    "name": "Praise be to legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-11-22",
    "licenseStatus": "active",
    "licenseExpiry": "2028-05-25",
    "licenseIssueDate": "2025-06-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Praise be to legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eee1fe77-c994-4fe1-9bb9-83ecd832091b",
        "address": "",
        "phone": "502890960",
        "email": "Abbas.dawoud1@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "676",
    "owner": "Abbas Muhammad Attia",
    "individuals": [
      "2e573c44-2851-498e-b52d-986105540deb"
    ],
    "lawyerCount": 1
  },
  {
    "id": "d65a89d3-4700-45d1-81ad-663c7bfeaf8c",
    "slug": "diplomat-legal-translation",
    "name": "Diplomat Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-09-24",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-28",
    "licenseIssueDate": "2024-04-05",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Diplomat Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d65a89d3-4700-45d1-81ad-663c7bfeaf8c",
        "address": "",
        "phone": "0503318599",
        "email": "Dally_59@yahoo.fr",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "477",
    "owner": "Abdul Ilah Sahnoun",
    "individuals": [
      "ad858d89-4ffd-4f9a-9e2b-622c55d54717"
    ],
    "lawyerCount": 1
  },
  {
    "id": "06fd1f2d-eac7-46dc-b85b-dd5d1096d7a1",
    "slug": "al-shadi-translation-services",
    "name": "Al-Shadi Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-06-01",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-03",
    "licenseIssueDate": "2023-08-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Shadi Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_06fd1f2d-eac7-46dc-b85b-dd5d1096d7a1",
        "address": "",
        "phone": "504708730",
        "email": "abdelhameedfayez@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "606",
    "owner": "Abdul Hamid Fayez Abdul Hamid",
    "individuals": [
      "9ac18b25-7b36-4833-b3f3-a3b9f5327a70"
    ],
    "lawyerCount": 1
  },
  {
    "id": "d7884d53-f701-4316-971d-151396b56053",
    "slug": "expert-for-legal-translation",
    "name": "Expert for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-06-16",
    "licenseStatus": "active",
    "licenseExpiry": "2023-12-27",
    "licenseIssueDate": "2020-12-28",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Expert for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d7884d53-f701-4316-971d-151396b56053",
        "address": "",
        "phone": "0561353185",
        "email": "aabdaraouf@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "384",
    "owner": "Abdul Raouf Abdul Majid",
    "individuals": [
      "21a493c7-79f7-4888-af7d-a51ee05b491f"
    ],
    "lawyerCount": 1
  },
  {
    "id": "8425e685-d98c-482c-ae60-fa5d01a8fa6b",
    "slug": "josep-legal-translation",
    "name": "JOSEP Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-06-06",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "licenseIssueDate": "2023-06-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: JOSEP Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8425e685-d98c-482c-ae60-fa5d01a8fa6b",
        "address": "",
        "phone": "556965352",
        "email": "rrahmanebencheikh@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "510",
    "owner": "Abdul Rahman bin Al-Sheikh",
    "individuals": [
      "55a24229-97d3-4b63-86f6-a3b4b61705c0"
    ],
    "lawyerCount": 1
  },
  {
    "id": "5d44732d-4505-42cb-8174-38ec25b3a83a",
    "slug": "dar-luqman-translation-services",
    "name": "Dar Luqman Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2027-07-14",
    "licenseIssueDate": "2024-08-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Dar Luqman Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5d44732d-4505-42cb-8174-38ec25b3a83a",
        "address": "",
        "phone": "566479394",
        "email": "ibnammarazhar@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "649",
    "owner": "Abdul Rahim Ammar Issa",
    "individuals": [
      "82cbf816-8a46-40aa-9516-ee5ee2635d78"
    ],
    "lawyerCount": 1
  },
  {
    "id": "fe741c16-507a-45ca-af41-e94baf4d1d33",
    "slug": "model-translation-services",
    "name": "Model translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2000-01-07",
    "licenseStatus": "active",
    "licenseExpiry": "2023-04-13",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Model translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fe741c16-507a-45ca-af41-e94baf4d1d33",
        "address": "",
        "phone": "0502713330",
        "email": "ideal3669@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "166",
    "owner": "Abdel Fattah Saeed Al-Majdalawi",
    "individuals": [
      "e3592671-3ed2-4693-90f2-777db84b98cd"
    ],
    "lawyerCount": 1
  },
  {
    "id": "2c22e589-325d-4dec-84e1-a49d3ad65e85",
    "slug": "hadi-abu-ghazaleh-for-legal-translation",
    "name": "Hadi Abu Ghazaleh for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBIQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-03-18",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-30",
    "licenseIssueDate": "2023-05-29",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Hadi Abu Ghazaleh for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2c22e589-325d-4dec-84e1-a49d3ad65e85",
        "address": "",
        "phone": "561925539",
        "email": "abdo9221984@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "498",
    "owner": "Abdul Qader Rabie Abdul Khaleq",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "4b20db97-0bf4-49ec-b2f3-a87e953f5b49",
    "slug": "al-burouj-legal-translation-services",
    "name": "Al Burouj Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-10-30",
    "licenseIssueDate": "2023-01-05",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Burouj Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4b20db97-0bf4-49ec-b2f3-a87e953f5b49",
        "address": "",
        "phone": "551968807",
        "email": "kasala_2@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "134",
    "owner": "Abdullah Hussein Muhammad",
    "individuals": [
      "e0439939-0081-46ec-a3eb-cab980a4dcc5"
    ],
    "lawyerCount": 1
  },
  {
    "id": "4246bcc8-ad90-4444-a663-af8ca93cf8a2",
    "slug": "future-legal-translation",
    "name": "Future Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-06-02",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-31",
    "licenseIssueDate": "2024-04-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Future Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4246bcc8-ad90-4444-a663-af8ca93cf8a2",
        "address": "",
        "phone": "556110554",
        "email": "Abdullah.Youssef@futurelt.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "702",
    "owner": "Abdullah Youssef Riyad",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "56b7da87-0291-48b4-bb27-1f4f8af91849",
    "slug": "mashareq-legal-translation-services",
    "name": "Mashareq Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "Hindi"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Mashareq Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_56b7da87-0291-48b4-bb27-1f4f8af91849",
        "address": "",
        "phone": "551535500",
        "email": "abdelmagidhendy@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "673",
    "owner": "Abdul Majeed Saleh Abdul Aziz Hindi",
    "individuals": [
      "f2e18952-1599-404a-8635-0e283d2ab6ea"
    ],
    "lawyerCount": 1
  },
  {
    "id": "54acdb6d-d7ee-4a0c-bcab-6e89a0e7307e",
    "slug": "as-smart-translation",
    "name": "AS Smart Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-11-19",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-18",
    "licenseIssueDate": "2023-10-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: AS Smart Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_54acdb6d-d7ee-4a0c-bcab-6e89a0e7307e",
        "address": "",
        "phone": "502655933",
        "email": "ezz_eddin_hussein@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "447",
    "owner": "Ezzedine Mohamed Mahmoud",
    "individuals": [
      "d84bc119-cbee-4b4e-bc22-dd90cb8aeab0"
    ],
    "lawyerCount": 1
  },
  {
    "id": "83615c12-6a37-4829-84ef-d3e446d0164d",
    "slug": "sawa-lingua-translation-services",
    "name": "Sawa Lingua Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-01-21",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-05",
    "licenseIssueDate": "2023-03-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Sawa Lingua Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_83615c12-6a37-4829-84ef-d3e446d0164d",
        "address": "",
        "phone": "553794421",
        "email": "Afaf.eid@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "485",
    "owner": "Afaf Muhammad Eid",
    "individuals": [
      "087809ac-bd5a-4448-b845-ae894559a90b"
    ],
    "lawyerCount": 1
  },
  {
    "id": "5587f7f8-92a1-4e91-b5b6-0fd92750a8a7",
    "slug": "al-wathiq-legal-translation",
    "name": "Al Wathiq Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "Russian"
    ],
    "mojLicense": "1998-08-17",
    "licenseStatus": "active",
    "licenseExpiry": "2023-02-12",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Wathiq Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5587f7f8-92a1-4e91-b5b6-0fd92750a8a7",
        "address": "",
        "phone": "506166724",
        "email": "alwathiqlegaltranslation@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "146",
    "owner": "Ali Jaber and trust me",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "79d03783-0197-4399-841b-612cff896099",
    "slug": "al-rafidain-legal-translation",
    "name": "Al-Rafidain Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-12",
    "licenseIssueDate": "2023-11-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Rafidain Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_79d03783-0197-4399-841b-612cff896099",
        "address": "",
        "phone": "0501878004",
        "email": "rcenter25@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "225",
    "owner": "Ali Hassan Zamil Al-Saadi",
    "individuals": [
      "54452986-fe9a-4b6b-a78c-47ae400be5c9"
    ],
    "lawyerCount": 1
  },
  {
    "id": "98a27305-da29-4e3c-bad0-5f89364c9982",
    "slug": "trustway-for-legal-translation-services",
    "name": "Trustway for legal translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "Russian"
    ],
    "mojLicense": "2015-09-30",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-09",
    "licenseIssueDate": "2023-10-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Trustway for legal translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_98a27305-da29-4e3c-bad0-5f89364c9982",
        "address": "",
        "phone": "almalomatfanyi@gmail.com",
        "email": "almalomatfanyi@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "529",
    "owner": "Ali Salem Muhammad Bakr",
    "individuals": [
      "1e1940ed-eced-4b44-81a0-248cd99e78e0"
    ],
    "lawyerCount": 1
  },
  {
    "id": "7a64987d-d068-47a1-8ee5-e2dbfe324fbd",
    "slug": "masters-international-for-legal-consultation-and-translation",
    "name": "Masters International for legal consultation and translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNSQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2008-02-06",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "licenseIssueDate": "2023-09-25",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Masters International for legal consultation and translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7a64987d-d068-47a1-8ee5-e2dbfe324fbd",
        "address": "",
        "phone": "0502664646",
        "email": "emadkna@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "301",
    "owner": "Imad Al-Din Muhammad Mahmoud Hussein",
    "individuals": [
      "dcc53252-dde0-4ee2-918e-574335d2c554"
    ],
    "lawyerCount": 1
  },
  {
    "id": "83acfa7c-d3f5-4e74-8101-c023d3e22be5",
    "slug": "trading-for-translation-services",
    "name": "Trading for translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-07-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "licenseIssueDate": "2023-01-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Trading for translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_83acfa7c-d3f5-4e74-8101-c023d3e22be5",
        "address": "",
        "phone": "501339046",
        "email": "abulmagd.emad@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "520",
    "owner": "Imad Muhammad Abu Al-Majd",
    "individuals": [
      "510ac6ad-256b-459a-92d6-8df5eeb83051"
    ],
    "lawyerCount": 1
  },
  {
    "id": "9cd7e57e-230c-409c-b57f-4f4c5d5efb06",
    "slug": "champollion-translation-services",
    "name": "Champollion Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-04-26",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-06",
    "licenseIssueDate": "2023-09-27",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Champollion Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9cd7e57e-230c-409c-b57f-4f4c5d5efb06",
        "address": "",
        "phone": "502311335",
        "email": "amar@uaefa-ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "632",
    "owner": "Ammar Muhammad Ahmed Abbas",
    "individuals": [
      "6aeafa36-ef6a-459b-8921-d43524310af2"
    ],
    "lawyerCount": 1
  },
  {
    "id": "db0c6540-b5c9-491e-8fe2-f09acd12ca3f",
    "slug": "saray-al-haqqaniya-legal-translation",
    "name": "Saray Al-Haqqaniya Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-04-26",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-15",
    "licenseIssueDate": "2023-05-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Saray Al-Haqqaniya Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_db0c6540-b5c9-491e-8fe2-f09acd12ca3f",
        "address": "",
        "phone": "0557184159",
        "email": "mtc_amr@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "634",
    "owner": "Amr Abdel Aleem Gomaa",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "4b25faff-5e77-483e-85e4-e47e84fb56f7",
    "slug": "wordcraft-legal-translation-dubai",
    "name": "Wordcraft Legal Translation - Dubai",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-06-02",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-04",
    "licenseIssueDate": "2024-02-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Wordcraft Legal Translation - Dubai",
    "consultationFee": 300,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4b25faff-5e77-483e-85e4-e47e84fb56f7",
        "address": "",
        "phone": "0589365930",
        "email": "bita.anntat@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "700",
    "owner": "Antar Bitat",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "a25509e8-c5f4-49c3-838e-cc359ef54e45",
    "slug": "lingolin-translation-services",
    "name": "Lingolin Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-01-21",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-16",
    "licenseIssueDate": "2023-11-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Lingolin Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a25509e8-c5f4-49c3-838e-cc359ef54e45",
        "address": "",
        "phone": "anterkhair@gmail.com",
        "email": "anterkhair@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "488",
    "owner": "Antar Sayed Ahmed",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "ca2d7eb1-c236-490e-8e03-3641e2e34a80",
    "slug": "aswan-legal-translation",
    "name": "Aswan Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-10-05",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-27",
    "licenseIssueDate": "2024-10-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Aswan Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ca2d7eb1-c236-490e-8e03-3641e2e34a80",
        "address": "",
        "phone": "0504974328",
        "email": "awad.ahmed.shj@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "335",
    "owner": "Awadallah Ahmed Abdel Basset",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "aa529255-4410-4c6f-866f-cd8164284409",
    "slug": "al-raya-legal-translation",
    "name": "Al-Raya Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-02-07",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-01",
    "licenseIssueDate": "2023-02-02",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Raya Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_aa529255-4410-4c6f-866f-cd8164284409",
        "address": "",
        "phone": "0543582410",
        "email": "fouadkettana@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "538",
    "owner": "Fouad Fawzi Ismail Kattana",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "afb52437-ec76-4ef9-bd97-72b37f0c62e4",
    "slug": "dictionary-translation-services",
    "name": "Dictionary translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2002-10-12",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-10",
    "licenseIssueDate": "2023-11-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Dictionary translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_afb52437-ec76-4ef9-bd97-72b37f0c62e4",
        "address": "",
        "phone": "505105400",
        "email": "fatimagasim@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "220",
    "owner": "Fatima Al-Zahra Abu Al-Qasim",
    "individuals": [
      "a2d246e3-d25e-4f7b-87cd-ca1649eea193"
    ],
    "lawyerCount": 1
  },
  {
    "id": "e2e5cb98-a362-4551-b70c-3d42c899129a",
    "slug": "golden-globe-legal-translation-services",
    "name": "Golden Globe Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "French"
    ],
    "mojLicense": "2007-07-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-17",
    "licenseIssueDate": "2020-03-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Golden Globe Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e2e5cb98-a362-4551-b70c-3d42c899129a",
        "address": "",
        "phone": "504575250",
        "email": "goldenglobe@eim.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "281",
    "owner": "Francesca Bordi",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "64b99adb-9027-4666-a8e9-e477a78fdfc2",
    "slug": "sky-legal-translation",
    "name": "Sky Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-04-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-01",
    "licenseIssueDate": "2023-11-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Sky Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_64b99adb-9027-4666-a8e9-e477a78fdfc2",
        "address": "",
        "phone": "0503309866",
        "email": "feryallo@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "550",
    "owner": "Faryal Abdel Ali Yassin",
    "individuals": [
      "49cf3146-af83-4853-a160-8b93782d274a"
    ],
    "lawyerCount": 1
  },
  {
    "id": "b703fe6b-6cb5-4766-84d3-6ae26a40097d",
    "slug": "consultation-for-legal-translation",
    "name": "Consultation for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-16",
    "licenseIssueDate": "2021-08-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Consultation for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b703fe6b-6cb5-4766-84d3-6ae26a40097d",
        "address": "",
        "phone": "0561381888",
        "email": "yarayahiatr@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "667",
    "owner": "What do you want?",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "3006eb7e-f092-425e-8264-ecb37f8c6506",
    "slug": "langbros-legal-translation",
    "name": "Langbros Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-06-01",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-17",
    "licenseIssueDate": "2023-03-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Langbros Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3006eb7e-f092-425e-8264-ecb37f8c6506",
        "address": "",
        "phone": "0557526650",
        "email": "matteo@langpros.net",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "609",
    "owner": "Matteo Abolletti",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "b31ccacb-1942-4a19-9206-fc76274f3b87",
    "slug": "trust-for-legal-translation-and-printing",
    "name": "Trust for legal translation and printing.",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "Russian"
    ],
    "mojLicense": "2009-07-14",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-12",
    "licenseIssueDate": "2023-09-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Trust for legal translation and printing.",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b31ccacb-1942-4a19-9206-fc76274f3b87",
        "address": "",
        "phone": "0503246652",
        "email": "magdyindex@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "329",
    "owner": "Magdy Fawzi Farag El-Sherbiny",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "2ff253ca-9fd5-47c0-bd6f-7e84f754d2d5",
    "slug": "al-rowad-legal-translation",
    "name": "Al-Rowad Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 37,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1988-12-10",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-01",
    "licenseIssueDate": "2023-11-02",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Rowad Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2ff253ca-9fd5-47c0-bd6f-7e84f754d2d5",
        "address": "",
        "phone": "506337763",
        "email": "ruwadtranslation@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "42",
    "owner": "Mohamed Ahmed Abdel Qader",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "8e2141cc-b4c5-496a-adc8-af3a5788f103",
    "slug": "the-platform-for-legal-translation",
    "name": "The platform for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-07",
    "licenseIssueDate": "2024-05-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: The platform for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e2141cc-b4c5-496a-adc8-af3a5788f103",
        "address": "",
        "phone": "0569468452",
        "email": "muhamado@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "650",
    "owner": "Muhammad Al-Amin Othman",
    "individuals": [
      "e858364c-18b8-4679-a966-ffb0b0e27b50"
    ],
    "lawyerCount": 1
  },
  {
    "id": "89babc21-97f8-42dd-ad85-fb5518d12929",
    "slug": "best-line-legal-translation",
    "name": "Best Line Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2003-05-28",
    "licenseStatus": "active",
    "licenseExpiry": "2023-08-10",
    "licenseIssueDate": "2020-08-17",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Best Line Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_89babc21-97f8-42dd-ad85-fb5518d12929",
        "address": "",
        "phone": "504129405",
        "email": "Indextarjum2006@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "208",
    "owner": "Muhammad Al-Hassan Ahmed",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "63a8a65d-3da0-4782-8e21-63127bc958a3",
    "slug": "summit-legal-translation",
    "name": "Summit Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-12-12",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-08",
    "licenseIssueDate": "2023-03-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Summit Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_63a8a65d-3da0-4782-8e21-63127bc958a3",
        "address": "",
        "phone": "527584494",
        "email": "Summit Legal Translation Office Dubai",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "688",
    "owner": "Muhammad Khaled Al-Sayed Rizk",
    "individuals": [
      "80807574-b187-483e-a506-292f175536a2"
    ],
    "lawyerCount": 1
  },
  {
    "id": "48ccf414-9c07-41c6-9164-7e2c45d72a40",
    "slug": "petra-legal-translation",
    "name": "Petra Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-11-19",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-28",
    "licenseIssueDate": "2023-01-05",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Petra Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_48ccf414-9c07-41c6-9164-7e2c45d72a40",
        "address": "",
        "phone": "0554616709",
        "email": "smart4word@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "484",
    "owner": "Muhammad Saeed Al-Sayyid Ahmed",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "617254f7-f266-4d85-86fc-7cfd76e6b18e",
    "slug": "al-madar-legal-translation",
    "name": "Al Madar Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 30,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1996-05-16",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "licenseIssueDate": "2023-11-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Madar Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_617254f7-f266-4d85-86fc-7cfd76e6b18e",
        "address": "",
        "phone": "506454530",
        "email": "Dralaboodi@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "117",
    "owner": "Muhammad Suleiman Al-Aboudi",
    "individuals": [
      "496ef9f2-76b3-431f-a7bc-4d710e4c7a7e"
    ],
    "lawyerCount": 1
  },
  {
    "id": "5cbd29e6-de48-400c-8fb8-07f19ab39491",
    "slug": "al-jihad-for-legal-translation-and-printing-services",
    "name": "Al-Jihad for legal translation and printing services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 26,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1999-12-19",
    "licenseStatus": "active",
    "licenseExpiry": "2023-02-02",
    "licenseIssueDate": "2020-02-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Jihad for legal translation and printing services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5cbd29e6-de48-400c-8fb8-07f19ab39491",
        "address": "",
        "phone": "503825038",
        "email": "msalehalmallouhi@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "160",
    "owner": "Muhammad Saleh Al-Mallouhi",
    "individuals": [
      "7b6c7186-929f-491d-b274-3c528050dfbd"
    ],
    "lawyerCount": 1
  },
  {
    "id": "20ae26fc-e3b4-464f-ab7e-37ec3e6f46c5",
    "slug": "the-supplier-for-legal-translation",
    "name": "The supplier for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2001-02-20",
    "licenseStatus": "active",
    "licenseExpiry": "2024-12-26",
    "licenseIssueDate": "2023-01-05",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: The supplier for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_20ae26fc-e3b4-464f-ab7e-37ec3e6f46c5",
        "address": "",
        "phone": "03/7544321",
        "email": "talebsyd@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "178",
    "owner": "Muhammad Talib Abdul Karim",
    "individuals": [
      "80807574-b187-483e-a506-292f175536a2"
    ],
    "lawyerCount": 1
  },
  {
    "id": "3f2543bb-ea0e-4a79-bc2d-611f4c0d48ee",
    "slug": "translegal-for-legal-translation",
    "name": "Translegal for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-11-04",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-22",
    "licenseIssueDate": "2024-11-25",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Translegal for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3f2543bb-ea0e-4a79-bc2d-611f4c0d48ee",
        "address": "",
        "phone": "508417811",
        "email": "mohd.mugharbil@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "722",
    "owner": "Muhammad Abdelkafi Al-Maghribal",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "d6834852-d8d2-4156-b877-57cb8a48c982",
    "slug": "emirates-gate-for-security-services",
    "name": "Emirates Gate for Security Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-16",
    "licenseStatus": "active",
    "licenseExpiry": "2028-08-27",
    "licenseIssueDate": "2025-09-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Emirates Gate for Security Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d6834852-d8d2-4156-b877-57cb8a48c982",
        "address": "",
        "phone": "0504353819",
        "email": "mkareem_mkareem83@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "644",
    "owner": "Muhammad Abdel Karim Ahmed Ahmed",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "dd80b558-6792-4ab2-9679-b19f0faa7fb5",
    "slug": "al-basha-legal-translation",
    "name": "Al Basha Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Basha Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dd80b558-6792-4ab2-9679-b19f0faa7fb5",
        "address": "",
        "phone": "564625946",
        "email": "aamoez@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "738",
    "owner": "Muhammad Abdel Moez Abdel Muti",
    "individuals": [
      "75df029c-bc84-47da-a3d5-45758bdf715f"
    ],
    "lawyerCount": 1
  },
  {
    "id": "2ac597f2-c510-4a5c-95f2-bca5e103a707",
    "slug": "al-masara-for-printing-copying-and-legal-translation-services",
    "name": "Al-Masara for printing, copying and legal translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-11-23",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-09",
    "licenseIssueDate": "2024-05-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Masara for printing, copying and legal translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2ac597f2-c510-4a5c-95f2-bca5e103a707",
        "address": "",
        "phone": "557136245",
        "email": "radmea78@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "706",
    "owner": "Muhammad Abdel Moneim Al-Hassan Ahmed",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "41056950-c4e3-4499-b1fa-9288c7047111",
    "slug": "al-ahram-for-business-services-and-translation",
    "name": "Al-Ahram for business services and translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-05-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-25",
    "licenseIssueDate": "2023-11-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Ahram for business services and translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_41056950-c4e3-4499-b1fa-9288c7047111",
        "address": "",
        "phone": "0505045681",
        "email": "muhammadagzy@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "672",
    "owner": "Mohamed Abdel Moneim Mohamed",
    "individuals": [
      "87ec02f5-b782-4e63-9fd6-cc737e70036d"
    ],
    "lawyerCount": 1
  },
  {
    "id": "40dea162-b047-4bd7-ac2f-a688c3cbb713",
    "slug": "golden-letters-for-legal-translation-dubai",
    "name": "Golden Letters for Legal Translation - Dubai",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-05-13",
    "licenseStatus": "active",
    "licenseExpiry": "2027-07-03",
    "licenseIssueDate": "2024-06-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Golden Letters for Legal Translation - Dubai",
    "consultationFee": 300,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_40dea162-b047-4bd7-ac2f-a688c3cbb713",
        "address": "",
        "phone": "505491400",
        "email": "mohd@alhorof.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "671",
    "owner": "Muhammad Othman Muhammad",
    "individuals": [
      "e858364c-18b8-4679-a966-ffb0b0e27b50"
    ],
    "lawyerCount": 1
  },
  {
    "id": "ff49d49c-ab63-4eff-a651-becc82af42af",
    "slug": "sim-trans-translation",
    "name": "Sim Trans Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2008-05-04",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-29",
    "licenseIssueDate": "2023-11-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Sim Trans Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ff49d49c-ab63-4eff-a651-becc82af42af",
        "address": "",
        "phone": "0502726802",
        "email": "m_kadash@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "305",
    "owner": "Muhammad Ali Muhammad Karsh",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "272bb245-fad0-4bfa-afb0-ed7d8c860bde",
    "slug": "msk-legal-translation",
    "name": "MSK Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-10-05",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-26",
    "licenseIssueDate": "2023-05-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: MSK Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_272bb245-fad0-4bfa-afb0-ed7d8c860bde",
        "address": "",
        "phone": "0505236719",
        "email": "mohamed.farag315@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "339",
    "owner": "Muhammad Faraj Abu Al-Ezz",
    "individuals": [
      "f67d6e20-4a93-4e86-9559-c92db947a35d"
    ],
    "lawyerCount": 1
  },
  {
    "id": "e6424363-d5a5-4f09-8428-3c0e3b24428b",
    "slug": "csc-legal-translation",
    "name": "CSC Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBDTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-12-11",
    "licenseStatus": "active",
    "licenseExpiry": "2028-06-25",
    "licenseIssueDate": "2025-06-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: CSC Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e6424363-d5a5-4f09-8428-3c0e3b24428b",
        "address": "",
        "phone": "0505453767",
        "email": "MHDFalhalabieh@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "452",
    "owner": "Muhammad Fahd Ahmed Al-Halabiyya",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "ef3dff06-e58c-4ffb-9881-edc586eda9b0",
    "slug": "hamza-legal-translation",
    "name": "Hamza Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBITAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-12-12",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-27",
    "licenseIssueDate": "2023-10-17",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Hamza Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ef3dff06-e58c-4ffb-9881-edc586eda9b0",
        "address": "",
        "phone": "0567722989",
        "email": "0567722989",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "684",
    "owner": "Muhammad Muhammad Reda Saadi",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "86ce3825-4eb5-4e3c-b5a1-1cc7957734e8",
    "slug": "word-bridges-for-legal-translation",
    "name": "Word bridges for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2024-03-27",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-28",
    "licenseIssueDate": "2024-06-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Word bridges for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_86ce3825-4eb5-4e3c-b5a1-1cc7957734e8",
        "address": "",
        "phone": "0553886819",
        "email": "transmomostafa@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "771",
    "owner": "Muhammad Mustafa Ismail Al-Sansar",
    "individuals": [
      "a10f953c-b5bc-4d77-b785-20e005e55e92"
    ],
    "lawyerCount": 1
  },
  {
    "id": "63fb112c-b55a-44f1-9b37-30271373cbe7",
    "slug": "gust-legal-translation",
    "name": "GUST Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-11-29",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-16",
    "licenseIssueDate": "2023-04-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: GUST Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_63fb112c-b55a-44f1-9b37-30271373cbe7",
        "address": "",
        "phone": "0506822362",
        "email": "mm.altaweel@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "532",
    "owner": "Muhammad Mustafa Al-Taweel",
    "individuals": [
      "cd832f05-0998-4ec3-aea9-1d452f1957d3"
    ],
    "lawyerCount": 1
  },
  {
    "id": "eb81542c-99ae-4eea-9527-96f44b30da10",
    "slug": "al-majd-legal-translation",
    "name": "Al Majd Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-04-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-31",
    "licenseIssueDate": "2023-08-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Majd Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eb81542c-99ae-4eea-9527-96f44b30da10",
        "address": "",
        "phone": "0503721160",
        "email": "Alawael_trans@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "405",
    "owner": "Muhammad Moawad Al-Baz",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "f1f7e9bc-6189-4b39-86c4-044436c1d044",
    "slug": "multilingo-legal-translation",
    "name": "MultiLingo Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2027-06-25",
    "licenseIssueDate": "2024-06-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: MultiLingo Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f1f7e9bc-6189-4b39-86c4-044436c1d044",
        "address": "",
        "phone": "526346344",
        "email": "mohdfatwa6@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "653",
    "owner": "Muhammad Naasan Fatwa",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "9e8f2aa7-1b0b-4206-81f8-221e600d56e0",
    "slug": "majestic-business-services-and-legal-translation",
    "name": "Majestic Business Services and Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-06-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-08",
    "licenseIssueDate": "2023-08-29",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Majestic Business Services and Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9e8f2aa7-1b0b-4206-81f8-221e600d56e0",
        "address": "",
        "phone": "559504800",
        "email": "info@bashadxb.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "699",
    "owner": "Mahmoud Ibrahim Hamed Sharab",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "756665e2-72d9-4c09-bf20-ea04cbe4952b",
    "slug": "al-anwar-legal-translation",
    "name": "Al Anwar Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-11-12",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-14",
    "licenseIssueDate": "2023-03-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Anwar Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_756665e2-72d9-4c09-bf20-ea04cbe4952b",
        "address": "",
        "phone": "562607468",
        "email": "m_abomazen1988@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "687",
    "owner": "Mahmoud Tharwat Ahmed",
    "individuals": [
      "8455c991-12e9-4e39-84c4-9feff2f8e762"
    ],
    "lawyerCount": 1
  },
  {
    "id": "7f867c31-c0d9-4e4e-badf-f26fe53149b3",
    "slug": "dorrat-al-majd-for-translation-and-legal-translation-services",
    "name": "Dorrat Al Majd for translation and legal translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBEQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-01-29",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-11",
    "licenseIssueDate": "2023-01-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Dorrat Al Majd for translation and legal translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7f867c31-c0d9-4e4e-badf-f26fe53149b3",
        "address": "",
        "phone": "0521587840",
        "email": "Mahmoud.Yaqub@Durratranslation.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "534",
    "owner": "Mahmoud Shaaban Abdel Hafeez",
    "individuals": [
      "e85a86d8-25af-4d1c-aded-671273a01007"
    ],
    "lawyerCount": 1
  },
  {
    "id": "4cf2dbeb-531f-4ea2-9f84-6d3f9816056e",
    "slug": "al-diyar-legal-translation",
    "name": "Al Diyar Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 30,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1995-12-25",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-05",
    "licenseIssueDate": "2023-12-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Diyar Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4cf2dbeb-531f-4ea2-9f84-6d3f9816056e",
        "address": "",
        "phone": "506284563",
        "email": "mahmoudsubhin@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "101",
    "owner": "Mahmoud Sobhi Abdullah Nassar",
    "individuals": [
      "e3592671-3ed2-4693-90f2-777db84b98cd"
    ],
    "lawyerCount": 1
  },
  {
    "id": "402cf430-b1b2-4437-bfdf-36f1df3c2591",
    "slug": "al-diwan-legal-translation",
    "name": "Al Diwan Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 29,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1997-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-09",
    "licenseIssueDate": "2023-04-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Diwan Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_402cf430-b1b2-4437-bfdf-36f1df3c2591",
        "address": "",
        "phone": "553899995",
        "email": "info@aldiwan.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "123",
    "owner": "Mahmoud Abdullah Amr",
    "individuals": [
      "e3592671-3ed2-4693-90f2-777db84b98cd"
    ],
    "lawyerCount": 1
  },
  {
    "id": "4a7066af-3f07-41bb-ae0e-3df7b8915374",
    "slug": "badr-for-legal-translation-and-printing",
    "name": "Badr for legal translation and printing",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBCTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Badr for legal translation and printing",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4a7066af-3f07-41bb-ae0e-3df7b8915374",
        "address": "",
        "phone": "0504215325",
        "email": "baztranslating@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "652",
    "owner": "Mahmoud Ali Mustafa Al-Baz",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "fb782fa5-08e0-4974-bf8e-8fdaf10fa63f",
    "slug": "ward-tech-for-legal-translation-and-transaction-follow-up-services",
    "name": "Ward Tech for legal translation and transaction follow-up services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-02-17",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-28",
    "licenseIssueDate": "2025-07-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Ward Tech for legal translation and transaction follow-up services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fb782fa5-08e0-4974-bf8e-8fdaf10fa63f",
        "address": "",
        "phone": "0501318769",
        "email": "mukhtarquds@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "736",
    "owner": "Mukhtar Abdul Quddus Mukhtar Othman",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "9ed512ba-294d-4f7c-ab38-3a4e0cfc11c6",
    "slug": "alif-gopal-legal-translation-services",
    "name": "Alif Gopal Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBRwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-02-11",
    "licenseStatus": "active",
    "licenseExpiry": "2028-03-05",
    "licenseIssueDate": "2025-03-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Alif Gopal Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9ed512ba-294d-4f7c-ab38-3a4e0cfc11c6",
        "address": "",
        "phone": "0525361787",
        "email": "marhoum96@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "733",
    "owner": "Mortada Hassan, deceased",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "cd9f77c0-3e88-45e2-b8e5-265e301248bd",
    "slug": "dunya-legal-translation",
    "name": "Dunya Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBETAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-04-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-03",
    "licenseIssueDate": "2023-07-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Dunya Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cd9f77c0-3e88-45e2-b8e5-265e301248bd",
        "address": "",
        "phone": "505033530",
        "email": "m.nada@duniatranslation.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "415",
    "owner": "Musaad Saad Muhammad Nada",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "d3a07ed3-b06d-4851-9eae-e9fcee87da61",
    "slug": "lighthouse-legal-translation",
    "name": "Lighthouse Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2005-05-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-18",
    "licenseIssueDate": "2023-10-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Lighthouse Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d3a07ed3-b06d-4851-9eae-e9fcee87da61",
        "address": "",
        "phone": "507661459",
        "email": "mu_hoj53@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "251",
    "owner": "Mustafa Ibrahim Hajjaj",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "1b3a6387-b681-404f-b727-d396d49def00",
    "slug": "al-nahda-legal-translation",
    "name": "Al Nahda Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-11-10",
    "licenseStatus": "active",
    "licenseExpiry": "2026-02-13",
    "licenseIssueDate": "2023-03-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Nahda Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1b3a6387-b681-404f-b727-d396d49def00",
        "address": "",
        "phone": "562222893",
        "email": "elite_214@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "614",
    "owner": "Mustafa Ramadan Al Hammadi",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "1db8c6e9-4855-40a1-b690-908ce81e3b7d",
    "slug": "united-legal-translation-and-printing",
    "name": "United Legal Translation and Printing",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBVTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-03-29",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-27",
    "licenseIssueDate": "2023-04-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: United Legal Translation and Printing",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1db8c6e9-4855-40a1-b690-908ce81e3b7d",
        "address": "",
        "phone": "507603641",
        "email": "Mustafa.sayedali@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "464",
    "owner": "Mustafa Mohieddin Al-Sayed",
    "individuals": [
      "c98a7b62-e409-445e-b932-89b6e52b4e7d"
    ],
    "lawyerCount": 1
  },
  {
    "id": "fe0bd18a-ab0a-426e-8bd5-9a0f8d91f47f",
    "slug": "takhlees-for-government-services",
    "name": "Takhlees for government services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBURwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-04-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-09",
    "licenseIssueDate": "2023-08-31",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Takhlees for government services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fe0bd18a-ab0a-426e-8bd5-9a0f8d91f47f",
        "address": "",
        "phone": "567068703",
        "email": "knightof73@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "400",
    "owner": "Moaz Muhammad Abdel Moneim",
    "individuals": [
      "75df029c-bc84-47da-a3d5-45758bdf715f"
    ],
    "lawyerCount": 1
  },
  {
    "id": "681ff386-f915-4db5-87bb-913514a9af91",
    "slug": "al-habbari-legal-translation-office",
    "name": "Al-Habbari Legal Translation Office",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 36,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1990-04-17",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-31",
    "licenseIssueDate": "2023-09-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Habbari Legal Translation Office",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_681ff386-f915-4db5-87bb-913514a9af91",
        "address": "",
        "phone": "507228400",
        "email": "kabbashi@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "62",
    "owner": "Moatasem Ibrahim Kabbashi",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "77d9998a-244d-49b4-8183-591ab13b3884",
    "slug": "al-turjuman-legal-translation-services-fujairah",
    "name": "Al Turjuman Legal Translation Services - Fujairah",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Turjuman Legal Translation Services - Fujairah",
    "consultationFee": 300,
    "emirate": "Fujairah",
    "verified": true,
    "offices": [
      {
        "id": "office_77d9998a-244d-49b4-8183-591ab13b3884",
        "address": "",
        "phone": "505899245",
        "email": "makka000@hotmail.com",
        "emirate": "Fujairah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "428",
    "owner": "Makiya Salem Saleh Al Kaabi",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "802ff8be-891b-451b-bb05-501bfb3c2ced",
    "slug": "al-itqan-legal-translation-services",
    "name": "Al-Itqan Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-11-03",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-31",
    "licenseIssueDate": "2023-06-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Itqan Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_802ff8be-891b-451b-bb05-501bfb3c2ced",
        "address": "",
        "phone": "522971508",
        "email": "malaktranslation@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "0362",
    "owner": "Malak Ali Al-Baghdadi",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "5c225e35-22f0-4c8a-be39-d18464c9e120",
    "slug": "golden-bridges-translation-services",
    "name": "Golden Bridges Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Golden Bridges Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5c225e35-22f0-4c8a-be39-d18464c9e120",
        "address": "",
        "phone": "523710511",
        "email": "Golden Bridges Legal Translation Services Office 0523710511 Bridges.translarion@gmail.com Dubai",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "694",
    "owner": "Maha Mahmoud Abdel Rahim",
    "individuals": [
      "e3592671-3ed2-4693-90f2-777db84b98cd"
    ],
    "lawyerCount": 1
  },
  {
    "id": "03096a27-c9b2-462f-92db-2ab0e9688ce8",
    "slug": "elite-legal-translation-services",
    "name": "Elite legal translation services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBFTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Elite legal translation services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_03096a27-c9b2-462f-92db-2ab0e9688ce8",
        "address": "",
        "phone": "508159359",
        "email": "Elite Legal Translation Services Abu Dhabi Tel: 6277663 0508159359 P.O. Box: 33413 Khatib.mahdi@elitetranslation.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "328",
    "owner": "Mahdi Ibrahim Al-Khatib",
    "individuals": [
      "ec04aaf9-c471-4644-bc43-8ef3b922bc20"
    ],
    "lawyerCount": 1
  },
  {
    "id": "96ea3714-8954-4952-96ff-fffecd7fcbb4",
    "slug": "golden-word-legal-translation",
    "name": "Golden Word Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-11-01",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-20",
    "licenseIssueDate": "2023-01-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Golden Word Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_96ea3714-8954-4952-96ff-fffecd7fcbb4",
        "address": "",
        "phone": "0503268182",
        "email": "mikeysorokin@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "743",
    "owner": "Mikhail Sorokin",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "b485df9c-5ff3-4ae3-a31b-48aaf2bc3fb4",
    "slug": "tawtheeq-for-corporate-services-and-legal-translation",
    "name": "Tawtheeq for corporate services and legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-11-23",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-11",
    "licenseIssueDate": "2024-01-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Tawtheeq for corporate services and legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b485df9c-5ff3-4ae3-a31b-48aaf2bc3fb4",
        "address": "",
        "phone": "0507431134",
        "email": "nasad.hastar@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "314",
    "owner": "Naji Sami Assad",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "02f6ffa5-664f-434c-adf5-267797de9307",
    "slug": "fmkin-legal-translation-services",
    "name": "Fmkin Legal Translation Services",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBGTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-11-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-25",
    "licenseIssueDate": "2025-05-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Fmkin Legal Translation Services",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_02f6ffa5-664f-434c-adf5-267797de9307",
        "address": "",
        "phone": "527267668",
        "email": "nader.raziq87@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "761",
    "owner": "Nader Abdel Razzaq Abdel Majid",
    "individuals": [
      "e5bf6fcc-8017-4705-afae-b5cc008a2e6f"
    ],
    "lawyerCount": 1
  },
  {
    "id": "df365cca-3120-440b-be9f-7d934d4063fa",
    "slug": "apex-legal-translation-dubai",
    "name": "Apex Legal Translation - Dubai",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-12-12",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-30",
    "licenseIssueDate": "2023-01-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Apex Legal Translation - Dubai",
    "consultationFee": 300,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_df365cca-3120-440b-be9f-7d934d4063fa",
        "address": "",
        "phone": "0525422274",
        "email": "nancy.tahir86@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "692",
    "owner": "Nancy Adel Hussein",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "39adc7c2-9e67-4e3e-9ada-f39c9211f9e9",
    "slug": "nada-ghandour-legal-translation-office",
    "name": "Nada Ghandour Legal Translation Office",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBORwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 33,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1992-10-26",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-01",
    "licenseIssueDate": "1992-10-26",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Nada Ghandour Legal Translation Office",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_39adc7c2-9e67-4e3e-9ada-f39c9211f9e9",
        "address": "",
        "phone": "0506228495",
        "email": "translation@nadaghandour.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "83",
    "owner": "Nada Muhammad Aliwan",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "5f52430b-236d-4a02-90fb-784a72ae9c50",
    "slug": "german-arab-center-for-legal-translation",
    "name": "German Arab Center for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBHQQogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "German"
    ],
    "mojLicense": "2003-05-28",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-22",
    "licenseIssueDate": "2023-09-11",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: German Arab Center for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5f52430b-236d-4a02-90fb-784a72ae9c50",
        "address": "",
        "phone": "505744199",
        "email": "gatic@eim.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "211",
    "owner": "Nermin Daoud Morgan",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "14c8df13-91a7-4322-98dd-cf7ad0211a1b",
    "slug": "magic-of-word-for-legal-translation",
    "name": "Magic of Word for legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2024-06-01",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Magic of Word for legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_14c8df13-91a7-4322-98dd-cf7ad0211a1b",
        "address": "",
        "phone": "0528741466",
        "email": "transnas42@omail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "651",
    "owner": "Nasr Muhammad Mahmoud Gomaa",
    "individuals": [
      "dcc53252-dde0-4ee2-918e-574335d2c554"
    ],
    "lawyerCount": 1
  },
  {
    "id": "fb10ffe2-4274-4a57-be38-39ccbb474987",
    "slug": "knowledge-of-legal-translation",
    "name": "Knowledge of legal translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBLTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-01-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-19",
    "licenseIssueDate": "2023-07-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Knowledge of legal translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fb10ffe2-4274-4a57-be38-39ccbb474987",
        "address": "",
        "phone": "0551046887",
        "email": "nasralilegaltrans@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "459",
    "owner": "Nasr Nasr Ali Abu Al-Aila",
    "individuals": [
      "1e1940ed-eced-4b44-81a0-248cd99e78e0"
    ],
    "lawyerCount": 1
  },
  {
    "id": "39a164d4-f6b3-48df-8655-87fb934a15dc",
    "slug": "al-wessam-legal-translation",
    "name": "Al Wessam Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBVwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-11-23",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-16",
    "licenseIssueDate": "2024-01-24",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al Wessam Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_39a164d4-f6b3-48df-8655-87fb934a15dc",
        "address": "",
        "phone": "552250170",
        "email": "translator.noha@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "710",
    "owner": "Noha Ghaleb Abdel Majeed",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "9754d171-f5f7-4b26-a326-abfae003d84f",
    "slug": "saeed-foshal-legal-translation",
    "name": "Saeed Foshal Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBTRgogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-05-23",
    "licenseStatus": "active",
    "licenseExpiry": "2023-09-24",
    "licenseIssueDate": "2023-09-26",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Saeed Foshal Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9754d171-f5f7-4b26-a326-abfae003d84f",
        "address": "",
        "phone": "521186070",
        "email": "nayera183@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "755",
    "owner": "Naira Mustafa Momen",
    "individuals": [
      "3631115d-80fd-4514-9cca-a790d0a9dcc9"
    ],
    "lawyerCount": 1
  },
  {
    "id": "d41f36b2-c28d-4c17-a483-784e6349de03",
    "slug": "lingo-legal-translation",
    "name": "Lingo Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBMTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-03-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-12-17",
    "licenseIssueDate": "2025-01-30",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Lingo Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d41f36b2-c28d-4c17-a483-784e6349de03",
        "address": "",
        "phone": "0503323067",
        "email": "haniibrahim.a@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "404",
    "owner": "Hani Ibrahim Atwa",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "d00515d1-c3f2-474c-8f77-bc730e6d20b3",
    "slug": "trans-home-translation",
    "name": "Trans Home Translation.",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBUSAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-01-21",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-28",
    "licenseIssueDate": "2020-04-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Trans Home Translation.",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d00515d1-c3f2-474c-8f77-bc730e6d20b3",
        "address": "",
        "phone": "971505231685",
        "email": "haithaman@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "491",
    "owner": "Haitham Muhammad Ahmed Daoud",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "ad82e30a-7d96-4f05-bac5-5bd9275c7c8a",
    "slug": "al-itqan-legal-translation-services-al-ain",
    "name": "Al-Itqan Legal Translation Services - Al Ain",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBBTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-11-30",
    "licenseStatus": "active",
    "licenseExpiry": "2024-06-14",
    "licenseIssueDate": "2024-06-24",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Al-Itqan Legal Translation Services - Al Ain",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ad82e30a-7d96-4f05-bac5-5bd9275c7c8a",
        "address": "",
        "phone": "0543575159",
        "email": "walaa_salah5@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "765",
    "owner": "Walaa Salah Ahmed Abdel Muti",
    "individuals": [
      "cd985e98-f279-4994-983e-d94dae4b2556"
    ],
    "lawyerCount": 1
  },
  {
    "id": "31a34d44-5218-4b18-96bf-e66abbed27b9",
    "slug": "justice-for-legal-translation",
    "name": "Justice for Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBKTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-11-01",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-26",
    "licenseIssueDate": "2022-12-27",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Justice for Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_31a34d44-5218-4b18-96bf-e66abbed27b9",
        "address": "",
        "phone": "05888154420",
        "email": "yarayahiatr@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "740",
    "owner": "Yara Muhammad Yahya",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "d4e0e38e-a952-46a5-aed0-da4ada3f87f8",
    "slug": "midwest-legal-translation",
    "name": "Midwest Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBNTAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-02-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-02",
    "licenseIssueDate": "2023-06-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Midwest Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d4e0e38e-a952-46a5-aed0-da4ada3f87f8",
        "address": "",
        "phone": "0567287575",
        "email": "yasirosman2001@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "627",
    "owner": "Yasser Othman Omar",
    "individuals": [
      "08ce404b-0cfa-40a5-b91c-0a38b519f2d7"
    ],
    "lawyerCount": 1
  },
  {
    "id": "eabfcffb-4a42-4531-947b-326c230f826b",
    "slug": "ward-care-legal-translation",
    "name": "Ward Care Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBXQwogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-02-05",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-12",
    "licenseIssueDate": "2023-09-22",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Ward Care Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eabfcffb-4a42-4531-947b-326c230f826b",
        "address": "",
        "phone": "0552342032",
        "email": "yasmeen_ossama@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "539",
    "owner": "Yasmine Muhammad Osama Labib Ahmed",
    "individuals": [
      "1b2e3449-25fe-458d-8ec4-07226b1546c4"
    ],
    "lawyerCount": 1
  },
  {
    "id": "5b9e4f8f-c39a-4b40-a0c6-1e5b866f713a",
    "slug": "plus-point-legal-translation",
    "name": "Plus Point Legal Translation",
    "title": "Translation Services",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yRmlybUdyYWRpZW50IiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj4KICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDQ3ODU3O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwNDUyNDtzdG9wLW9wYWNpdHk6MSIgLz4KICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgICAgICAgICAgPGZpbHRlciBpZD0idHJhbnNsYXRvckZpcm1TaGFkb3ciIHg9Ii01MCUiIHk9Ii01MCUiIHdpZHRoPSIyMDAlIiBoZWlnaHQ9IjIwMCUiPgogICAgICAgICAgICAgIDxmZURyb3BTaGFkb3cgZHg9IjAiIGR5PSI2IiBzdGREZXZpYXRpb249IjEyIiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjE1KSIvPgogICAgICAgICAgICA8L2ZpbHRlcj4KICAgICAgICAgIDwvZGVmcz4KICAgICAgICAgIDxyZWN0IHg9IjEwIiB5PSIxMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgcnk9IjIwIiAKICAgICAgICAgICAgICAgIGZpbGw9InVybCgjdHJhbnNsYXRvckZpcm1HcmFkaWVudCkiIGZpbHRlcj0idXJsKCN0cmFuc2xhdG9yRmlybVNoYWRvdykiLz4KICAgICAgICAgIDx0ZXh0IHg9IjYwIiB5PSI3MCIgZm9udC1mYW1pbHk9IkludGVyLCAtYXBwbGUtc3lzdGVtLCBCbGlua01hY1N5c3RlbUZvbnQsIHNhbnMtc2VyaWYiIAogICAgICAgICAgICAgICAgZm9udC1zaXplPSIyOCIgZm9udC13ZWlnaHQ9IjcwMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICBQUAogICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvc3ZnPg==",
    "specializations": [
      "Translation",
      "Legal Translation",
      "Document Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-26",
    "licenseIssueDate": "2021-10-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Translation Services"
    ],
    "description": "Licensed translation services: Plus Point Legal Translation",
    "consultationFee": 300,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5b9e4f8f-c39a-4b40-a0c6-1e5b866f713a",
        "address": "",
        "phone": "0528675297",
        "email": "y.online@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Translation Services services",
        "price": 300,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Firms",
    "registrationNumber": "663",
    "owner": "Youssef Ibrahim Al-Qaseer",
    "individuals": [],
    "lawyerCount": 0
  },
  {
    "id": "f2e18952-1599-404a-8635-0e283d2ab6ea",
    "slug": "dreams-of-abdul-majeed",
    "name": "Dreams of Abdul Majeed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgREEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Dreams of Abdul Majeed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f2e18952-1599-404a-8635-0e283d2ab6ea",
        "address": "",
        "phone": "501229362",
        "email": "Al-Ahram 2000 for Translation - Abu Dhabi Tel: 6713339 / F: 6766913 Ahrm2000@eim.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "120",
    "firmId": "56b7da87-0291-48b4-bb27-1f4f8af91849",
    "firmName": "Mashareq Legal Translation Services",
    "role": "Owner",
    "company": "56b7da87-0291-48b4-bb27-1f4f8af91849"
  },
  {
    "id": "b6717395-badd-40f2-9c6e-60415166a655",
    "slug": "ahmed-ibrahim-ramadan",
    "name": "Ahmed Ibrahim Ramadan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-06-01",
    "licenseStatus": "active",
    "licenseExpiry": "2028-03-06",
    "licenseIssueDate": "2025-03-07",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Ibrahim Ramadan",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_b6717395-badd-40f2-9c6e-60415166a655",
        "address": "",
        "phone": "0555524229",
        "email": "ahmadrmdn@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "559",
    "company": "e5026e22-8963-489e-86c0-797aaeedef6c",
    "firmId": "e5026e22-8963-489e-86c0-797aaeedef6c",
    "firmName": "Scribe for legal translation",
    "role": "Owner"
  },
  {
    "id": "6aeafa36-ef6a-459b-8921-d43524310af2",
    "slug": "ahmed-saber-abbas",
    "name": "Ahmed Saber Abbas",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Saber Abbas",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6aeafa36-ef6a-459b-8921-d43524310af2",
        "address": "",
        "phone": "undefined",
        "email": "badruae.com@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "9cd7e57e-230c-409c-b57f-4f4c5d5efb06",
    "firmName": "Champollion Translation Services",
    "role": "Owner",
    "company": "9cd7e57e-230c-409c-b57f-4f4c5d5efb06"
  },
  {
    "id": "bdd5607b-81bd-4faf-b634-af95f7b82366",
    "slug": "osama-ali-ataa-al-mannan-building",
    "name": "Osama Ali Ataa Al-Mannan Building",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgT0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 25,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2000-10-02",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-01",
    "licenseIssueDate": "2024-02-01",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Osama Ali Ataa Al-Mannan Building",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_bdd5607b-81bd-4faf-b634-af95f7b82366",
        "address": "",
        "phone": "508109190",
        "email": "hassanalihassan93@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "188",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "4346680b-42d1-48db-afbd-aa39a1d13ea1",
    "slug": "ashraf-babiker-abdel-wahab-abdel-rahman",
    "name": "Ashraf Babiker Abdel Wahab Abdel Rahman",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ashraf Babiker Abdel Wahab Abdel Rahman",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4346680b-42d1-48db-afbd-aa39a1d13ea1",
        "address": "",
        "phone": "0501916710",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "674",
    "firmId": "b07c1529-62a9-4dd6-a72b-609765559e1b",
    "firmName": "Madad Legal Translation",
    "role": "Owner",
    "company": "b07c1529-62a9-4dd6-a72b-609765559e1b"
  },
  {
    "id": "995d0d7b-9da2-4263-a428-2195f5ba9d17",
    "slug": "amjad-ezz-el-din",
    "name": "Amjad Ezz El-Din",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUUKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Amjad Ezz El-Din",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_995d0d7b-9da2-4263-a428-2195f5ba9d17",
        "address": "",
        "phone": "0509478074",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "27f4b520-97c9-4509-b9b3-08bce8b4ded2",
    "slug": "anwar-ali-zidane",
    "name": "Anwar Ali Zidane",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Anwar Ali Zidane",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_27f4b520-97c9-4509-b9b3-08bce8b4ded2",
        "address": "",
        "phone": "564752440",
        "email": "Al Madina Center for Legal Translation Abu Dhabi 0564752440 INFO@ALPHA_AE.COM anwar.zedana@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "342"
  },
  {
    "id": "f7186277-3668-44ee-a0e1-a5aef979051f",
    "slug": "anwar-mahmoud-fneish",
    "name": "Anwar Mahmoud Fneish",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2007-04-12",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-18",
    "licenseIssueDate": "2024-03-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Anwar Mahmoud Fneish",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_f7186277-3668-44ee-a0e1-a5aef979051f",
        "address": "",
        "phone": "505883532",
        "email": "anfnaish@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "289",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "d810c879-da26-4be4-8c27-93e641120141",
    "slug": "ibtisam-abdel-wajed-mustafa",
    "name": "Ibtisam Abdel-Wajed Mustafa",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-03-18",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-17",
    "licenseIssueDate": "2023-10-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ibtisam Abdel-Wajed Mustafa",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d810c879-da26-4be4-8c27-93e641120141",
        "address": "",
        "phone": "0506690604",
        "email": "ibtesam.hassan@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "505",
    "company": "Judicial Department"
  },
  {
    "id": "268a0646-eb50-4ad6-b1d9-b5135f6037ee",
    "slug": "ibrahim-abu-al-saud-mamoun",
    "name": "Ibrahim Abu Al-Saud Mamoun",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-11-30",
    "licenseStatus": "active",
    "licenseExpiry": "2028-02-02",
    "licenseIssueDate": "2025-02-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ibrahim Abu Al-Saud Mamoun",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_268a0646-eb50-4ad6-b1d9-b5135f6037ee",
        "address": "",
        "phone": "0526654724",
        "email": "ibrahim.maamon@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "769",
    "company": "Emirates News Agency"
  },
  {
    "id": "2477e511-7112-42da-9fc7-4643435aa8e6",
    "slug": "abu-al-hussein-khamis-on-two-levels",
    "name": "Abu Al-Hussein Khamis, on two levels",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 28,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1998-05-10",
    "licenseStatus": "active",
    "licenseExpiry": "2027-04-03",
    "licenseIssueDate": "2024-04-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abu Al-Hussein Khamis, on two levels",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_2477e511-7112-42da-9fc7-4643435aa8e6",
        "address": "",
        "phone": "507910755",
        "email": "abuelhusseinali@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "140",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "1e1940ed-eced-4b44-81a0-248cd99e78e0",
    "slug": "abu-bakr-othman-ali",
    "name": "Abu Bakr Othman Ali",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abu Bakr Othman Ali",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1e1940ed-eced-4b44-81a0-248cd99e78e0",
        "address": "",
        "phone": "055505213",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "fb10ffe2-4274-4a57-be38-39ccbb474987",
    "firmName": "Knowledge of legal translation",
    "role": "Owner",
    "company": "fb10ffe2-4274-4a57-be38-39ccbb474987"
  },
  {
    "id": "08ce404b-0cfa-40a5-b91c-0a38b519f2d7",
    "slug": "abu-bakr-omar-othman-ali",
    "name": "Abu Bakr Omar Othman Ali",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abu Bakr Omar Othman Ali",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_08ce404b-0cfa-40a5-b91c-0a38b519f2d7",
        "address": "",
        "phone": "055505213",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "d4e0e38e-a952-46a5-aed0-da4ada3f87f8",
    "firmName": "Midwest Legal Translation",
    "role": "Owner",
    "company": "d4e0e38e-a952-46a5-aed0-da4ada3f87f8"
  },
  {
    "id": "1b2e3449-25fe-458d-8ec4-07226b1546c4",
    "slug": "ahmed-ibrahim-ali-muhammad",
    "name": "Ahmed Ibrahim Ali Muhammad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Ibrahim Ali Muhammad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1b2e3449-25fe-458d-8ec4-07226b1546c4",
        "address": "",
        "phone": "0564838138",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "eabfcffb-4a42-4531-947b-326c230f826b",
    "firmName": "Ward Care Legal Translation",
    "role": "Owner",
    "company": "eabfcffb-4a42-4531-947b-326c230f826b"
  },
  {
    "id": "d878b732-723d-4865-835d-cc1392243e65",
    "slug": "ahmed-hassan-hegazy",
    "name": "Ahmed Hassan Hegazy",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-12-04",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-24",
    "licenseIssueDate": "2023-04-25",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Hassan Hegazy",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_d878b732-723d-4865-835d-cc1392243e65",
        "address": "",
        "phone": "0554193396",
        "email": "ahmad.hegazi@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "429",
    "company": "533757eb-8584-4361-81fa-0724d4551452",
    "firmId": "533757eb-8584-4361-81fa-0724d4551452",
    "firmName": "Legal Translation House",
    "role": "Owner"
  },
  {
    "id": "cd985e98-f279-4994-983e-d94dae4b2556",
    "slug": "ahmed-ragab-abdel-muttalib-ibrahim-fouda",
    "name": "Ahmed Ragab Abdel Muttalib Ibrahim Fouda",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-06-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-02",
    "licenseIssueDate": "2020-08-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Ragab Abdel Muttalib Ibrahim Fouda",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cd985e98-f279-4994-983e-d94dae4b2556",
        "address": "",
        "phone": "0559622210",
        "email": "ahmad.r.fouda@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "698",
    "company": "ad82e30a-7d96-4f05-bac5-5bd9275c7c8a",
    "firmId": "ad82e30a-7d96-4f05-bac5-5bd9275c7c8a",
    "firmName": "Al-Itqan Legal Translation Services - Al Ain",
    "role": "Owner"
  },
  {
    "id": "08cd0734-9f83-4cae-b6f7-eed7905c57d6",
    "slug": "ahmed-refaat",
    "name": "Ahmed Refaat",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Refaat",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_08cd0734-9f83-4cae-b6f7-eed7905c57d6",
        "address": "",
        "phone": "0568322560",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "2cd106ab-f849-424b-888b-86209618816e",
    "slug": "ahmed-salim-issa",
    "name": "Ahmed Salim Issa",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Salim Issa",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2cd106ab-f849-424b-888b-86209618816e",
        "address": "",
        "phone": "0505644256",
        "email": "safforiya@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "103",
    "firmId": "b3924fb8-085a-493f-81cd-e50a869271a0",
    "firmName": "Kalimat Legal Translation Services",
    "role": "Owner",
    "company": "b3924fb8-085a-493f-81cd-e50a869271a0"
  },
  {
    "id": "c7b10792-65d0-41d4-93b6-b8ba9fa7f2ba",
    "slug": "ahmed-abdel-rahman-al-absi",
    "name": "Ahmed Abdel Rahman Al Absi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2006-02-21",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-03",
    "licenseIssueDate": "2023-05-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Abdel Rahman Al Absi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c7b10792-65d0-41d4-93b6-b8ba9fa7f2ba",
        "address": "",
        "phone": "0503006369",
        "email": "absiahmad@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "255"
  },
  {
    "id": "89e170f1-f6ef-4d11-a6a9-9817d1186cdb",
    "slug": "ahmed-obaid-ahmed-suleiman",
    "name": "Ahmed Obaid Ahmed Suleiman",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU8KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2006-06-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-09-17",
    "licenseIssueDate": "2024-09-17",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Obaid Ahmed Suleiman",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_89e170f1-f6ef-4d11-a6a9-9817d1186cdb",
        "address": "",
        "phone": "507721421",
        "email": "zagalona@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "346",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "81dc2c6c-c659-4bc6-b239-554ecb2bc060",
    "slug": "ahmed-lamrabet-ismail",
    "name": "Ahmed Lamrabet Ismail",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUwKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-03-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-29",
    "licenseIssueDate": "2023-08-29",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Lamrabet Ismail",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_81dc2c6c-c659-4bc6-b239-554ecb2bc060",
        "address": "",
        "phone": "508178475",
        "email": "alemrabott@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "377",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "61eca2e4-10f9-44a6-a8dc-14a21753db2b",
    "slug": "ahmed-magdy-moussa",
    "name": "Ahmed Magdy Moussa",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Magdy Moussa",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_61eca2e4-10f9-44a6-a8dc-14a21753db2b",
        "address": "",
        "phone": "0506911420",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "70f6cd1a-99b9-498f-92c4-4daf30611ddb",
    "slug": "ahmed-mohamed-al-sayed-rabiea",
    "name": "Ahmed Mohamed Al-Sayed Rabiea",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-05-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-19",
    "licenseIssueDate": "2023-08-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Mohamed Al-Sayed Rabiea",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_70f6cd1a-99b9-498f-92c4-4daf30611ddb",
        "address": "",
        "phone": "0551238267",
        "email": "ahmedrabieah@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "440",
    "company": "3716f105-fdb9-4a1e-9b68-39aa06ea8cb4",
    "firmId": "3716f105-fdb9-4a1e-9b68-39aa06ea8cb4",
    "firmName": "Mondo Legal Translation",
    "role": "Owner"
  },
  {
    "id": "65674b6f-b5fd-4370-aa09-b9b6491839f8",
    "slug": "ahmed-muhammad-issa-yassin",
    "name": "Ahmed Muhammad Issa Yassin",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ahmed Muhammad Issa Yassin",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_65674b6f-b5fd-4370-aa09-b9b6491839f8",
        "address": "",
        "phone": "556090880",
        "email": "London Legal Translation Dubai info@londont.com 0556090880",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "420"
  },
  {
    "id": "dcc53252-dde0-4ee2-918e-574335d2c554",
    "slug": "osama-muhammad-mahmoud-hassan",
    "name": "Osama Muhammad Mahmoud Hassan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgT00KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-07-06",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-20",
    "licenseIssueDate": "2023-09-11",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Osama Muhammad Mahmoud Hassan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dcc53252-dde0-4ee2-918e-574335d2c554",
        "address": "",
        "phone": "562994170",
        "email": "osama4translation@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "322",
    "company": "14c8df13-91a7-4322-98dd-cf7ad0211a1b",
    "firmId": "14c8df13-91a7-4322-98dd-cf7ad0211a1b",
    "firmName": "Magic of Word for legal translation",
    "role": "Owner"
  },
  {
    "id": "acf2211c-6afd-47d0-92b6-aab6d4a29abe",
    "slug": "israa-makki",
    "name": "Israa Makki",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Israa Makki",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_acf2211c-6afd-47d0-92b6-aab6d4a29abe",
        "address": "",
        "phone": "0507881373",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "6d8d301f-7079-4f26-b0b7-f5ef1ca8ba9c",
    "firmName": "Raven Legal Translation",
    "role": "Owner",
    "company": "6d8d301f-7079-4f26-b0b7-f5ef1ca8ba9c"
  },
  {
    "id": "253672ec-4730-4176-b4dc-8460683344c1",
    "slug": "names-abdullah-al-shamousi",
    "name": "Names: Abdullah Al-Shamousi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 22,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2004-04-18",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-26",
    "licenseIssueDate": "2023-12-27",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Names: Abdullah Al-Shamousi",
    "consultationFee": 250,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_253672ec-4730-4176-b4dc-8460683344c1",
        "address": "",
        "phone": "507833555",
        "email": "asmashmoosi@gmail.com",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "227",
    "company": "Department of Culture - Sharjah"
  },
  {
    "id": "3548058e-fbdb-464d-920e-fde5f21bd0f2",
    "slug": "asmaa-mahmoud-saleh-ghareeb-abu-shehab",
    "name": "Asmaa Mahmoud Saleh Ghareeb Abu Shehab",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2024-09-30",
    "licenseStatus": "active",
    "licenseExpiry": "2028-05-18",
    "licenseIssueDate": "2025-05-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Asmaa Mahmoud Saleh Ghareeb Abu Shehab",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3548058e-fbdb-464d-920e-fde5f21bd0f2",
        "address": "",
        "phone": "563295750",
        "email": "sampleangel@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "777",
    "company": "77d913de-602f-4726-9a6a-88183a369694",
    "firmId": "77d913de-602f-4726-9a6a-88183a369694",
    "firmName": "Moscow Legal Translation",
    "role": "Owner"
  },
  {
    "id": "32d517fb-c97d-4141-83f3-afec3da246ae",
    "slug": "ismail-gamal-ibrahim",
    "name": "Ismail Gamal Ibrahim",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSUcKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-06-04",
    "licenseStatus": "active",
    "licenseExpiry": "2028-06-10",
    "licenseIssueDate": "2025-06-11",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ismail Gamal Ibrahim",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_32d517fb-c97d-4141-83f3-afec3da246ae",
        "address": "",
        "phone": "0508175232",
        "email": "My Services LLC.M.M Abu Dhabi Tel: 0508175232 Ismail_Ibrahim@adec.ac.ae",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "474",
    "company": "Abu Dhabi Media"
  },
  {
    "id": "d1c83cb0-8b00-4ba9-896b-d70c8b71f38e",
    "slug": "ashraf-nabil-abdel-maboud",
    "name": "Ashraf Nabil Abdel Maboud",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU4KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-06-30",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-25",
    "licenseIssueDate": "2023-09-26",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ashraf Nabil Abdel Maboud",
    "consultationFee": 250,
    "emirate": "Ras Al Khaimah",
    "verified": true,
    "offices": [
      {
        "id": "office_d1c83cb0-8b00-4ba9-896b-d70c8b71f38e",
        "address": "",
        "phone": "0543455712",
        "email": "ashrafmajed@yahoo.com",
        "emirate": "Ras Al Khaimah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "376",
    "company": "bdb32fe4-ccaf-4ab9-b019-f31a610afa48",
    "firmId": "bdb32fe4-ccaf-4ab9-b019-f31a610afa48",
    "firmName": "Department of Services (Ras Al Khaimah Government)"
  },
  {
    "id": "3ee840dd-4e69-46f1-a062-439f9a1b4e84",
    "slug": "asif-khalil-shawkat",
    "name": "Asif Khalil Shawkat",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUsKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-11-19",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-18",
    "licenseIssueDate": "2023-06-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Asif Khalil Shawkat",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3ee840dd-4e69-46f1-a062-439f9a1b4e84",
        "address": "",
        "phone": "0543033308",
        "email": "assefsaeed@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "449",
    "company": "Judicial Department"
  },
  {
    "id": "b4625cf1-c7e0-45af-ac86-3f122967db8c",
    "slug": "al-zaki-al-amin-al-obaid",
    "name": "Al-Zaki Al-Amin Al-Obaid",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Al-Zaki Al-Amin Al-Obaid",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b4625cf1-c7e0-45af-ac86-3f122967db8c",
        "address": "",
        "phone": "0507063344",
        "email": "zaki translate zaki.translate@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "492"
  },
  {
    "id": "e1333ff6-2eda-4431-95d9-e8fbb57153fc",
    "slug": "mr-hossam",
    "name": "Mr. Hossam",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mr. Hossam",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e1333ff6-2eda-4431-95d9-e8fbb57153fc",
        "address": "",
        "phone": "undefined",
        "email": "hossam.infinity2019@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "3b418beb-009b-4d01-b324-9bce7461ced7",
    "slug": "al-taher-adam-abdul-aziz-adam",
    "name": "Al-Taher Adam Abdul Aziz Adam",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-06-04",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-19",
    "licenseIssueDate": "2024-01-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Al-Taher Adam Abdul Aziz Adam",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_3b418beb-009b-4d01-b324-9bce7461ced7",
        "address": "",
        "phone": "0509099165",
        "email": "adamsontahir@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "470",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "8d54ab4e-f905-451a-8ebd-6d2f19f0b745",
    "slug": "the-infection-shahata-the-infection-abu-al-saad",
    "name": "The infection, Shahata, the infection, Abu Al-Saad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: The infection, Shahata, the infection, Abu Al-Saad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8d54ab4e-f905-451a-8ebd-6d2f19f0b745",
        "address": "",
        "phone": "0504917770",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "15626684-75ab-4ef3-b10f-4f82a9fc4fc8",
    "slug": "nile-idris-mohamed-ahmed",
    "name": "Nile Idris Mohamed Ahmed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTkkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Nile Idris Mohamed Ahmed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_15626684-75ab-4ef3-b10f-4f82a9fc4fc8",
        "address": "",
        "phone": "0504161692",
        "email": "alneel1607@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "325",
    "firmId": "66758b44-395a-4747-811d-44b6140106ac",
    "firmName": "Global Gulf Legal Translation Services",
    "role": "Owner",
    "company": "66758b44-395a-4747-811d-44b6140106ac"
  },
  {
    "id": "cb0ca730-217b-4b4b-9c99-79bc545c5623",
    "slug": "amani-salah-hamed-mohamed",
    "name": "Amani Salah Hamed Mohamed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2028-02-28",
    "licenseIssueDate": "2025-02-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Amani Salah Hamed Mohamed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_cb0ca730-217b-4b4b-9c99-79bc545c5623",
        "address": "",
        "phone": "0503472554",
        "email": "amany.rahma@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "645",
    "company": "Rabdan Academy - Governmental"
  },
  {
    "id": "4705aa17-b28c-4e95-a21e-199215b9851d",
    "slug": "amjad-muhammad-mounir-is-a-gift",
    "name": "Amjad Muhammad Mounir is a gift",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Amjad Muhammad Mounir is a gift",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4705aa17-b28c-4e95-a21e-199215b9851d",
        "address": "",
        "phone": "0527769988",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "071e20b3-8887-4b1b-8de4-e32a5e5302c9",
    "firmName": "Mawazine Legal Translation",
    "role": "Owner",
    "company": "071e20b3-8887-4b1b-8de4-e32a5e5302c9"
  },
  {
    "id": "15fe4201-e1bb-4a20-bc3f-807261a54c40",
    "slug": "security-of-muhammad-juma-muftah",
    "name": "Security of Muhammad Juma Muftah",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU00KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Security of Muhammad Juma Muftah",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_15fe4201-e1bb-4a20-bc3f-807261a54c40",
        "address": "",
        "phone": "0547475200",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "94a13e3b-d295-466d-a39d-5d340baf1724",
    "slug": "iyad-ahmed-snobra",
    "name": "Iyad Ahmed Snobra",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-12-25",
    "licenseStatus": "active",
    "licenseExpiry": "2028-04-09",
    "licenseIssueDate": "2025-04-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Iyad Ahmed Snobra",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_94a13e3b-d295-466d-a39d-5d340baf1724",
        "address": "",
        "phone": "555665584",
        "email": "eyad119@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "403",
    "company": "Central Bank of the Emirates"
  },
  {
    "id": "151efa58-9a82-46ec-9ded-26a9863d941f",
    "slug": "badr-al-din-al-din-ali-al-jaifari",
    "name": "Badr al-Din al-Din Ali al-Jaifari",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-11-04",
    "licenseStatus": "active",
    "licenseExpiry": "2025-01-31",
    "licenseIssueDate": "2022-01-31",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Badr al-Din al-Din Ali al-Jaifari",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_151efa58-9a82-46ec-9ded-26a9863d941f",
        "address": "",
        "phone": "0554649483",
        "email": "Badreldin.elguaiffri@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "727"
  },
  {
    "id": "75df029c-bc84-47da-a3d5-45758bdf715f",
    "slug": "brael-muhammad-abdel-jalil",
    "name": "Brael Muhammad Abdel Jalil",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQk0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Brael Muhammad Abdel Jalil",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_75df029c-bc84-47da-a3d5-45758bdf715f",
        "address": "",
        "phone": "505817404",
        "email": "Abdul Jalil Translation Office - Abu Dhabi 0506724686 jaleeltranslation@gmail.Com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "58",
    "firmId": "fe0bd18a-ab0a-426e-8bd5-9a0f8d91f47f",
    "firmName": "Takhlees for government services",
    "role": "Owner",
    "company": "fe0bd18a-ab0a-426e-8bd5-9a0f8d91f47f"
  },
  {
    "id": "abde4543-aa29-4086-83e6-c8075a832b88",
    "slug": "bassam-mohammed-al-haffar",
    "name": "Bassam Mohammed Al-Haffar",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQk0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-05-20",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "licenseIssueDate": "2023-10-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Bassam Mohammed Al-Haffar",
    "consultationFee": 250,
    "emirate": "Sharjah",
    "verified": true,
    "offices": [
      {
        "id": "office_abde4543-aa29-4086-83e6-c8075a832b88",
        "address": "",
        "phone": "507273792",
        "email": "BassamHA@emiratesNBD.com",
        "emirate": "Sharjah",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "513",
    "company": "Emirates NBD Bank - Sharjah"
  },
  {
    "id": "075bd49e-9c59-4f4b-b288-4c4039e567b9",
    "slug": "statement-by-ali-mujar",
    "name": "Statement by Ali Mujar",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Statement by Ali Mujar",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_075bd49e-9c59-4f4b-b288-4c4039e567b9",
        "address": "",
        "phone": "555939353",
        "email": "Leaders Legal Translation and Interpretation 0555939353 Abu Dhabi bayon.majar@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "518"
  },
  {
    "id": "55a24229-97d3-4b63-86f6-a3b4b61705c0",
    "slug": "tamim-abdul-rahman-qara",
    "name": "Tamim Abdul Rahman Qara",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgVEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-07-08",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-05",
    "licenseIssueDate": "2024-02-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Tamim Abdul Rahman Qara",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_55a24229-97d3-4b63-86f6-a3b4b61705c0",
        "address": "",
        "phone": "504449173",
        "email": "tkarabala@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "141",
    "company": "8425e685-d98c-482c-ae60-fa5d01a8fa6b",
    "firmId": "8425e685-d98c-482c-ae60-fa5d01a8fa6b",
    "firmName": "JOSEP Legal Translation",
    "role": "Owner"
  },
  {
    "id": "657f81a9-cf79-4365-ae5f-153445ec9084",
    "slug": "tawfiq-ahmed-baghdadi",
    "name": "Tawfiq Ahmed Baghdadi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgVEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Tawfiq Ahmed Baghdadi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_657f81a9-cf79-4365-ae5f-153445ec9084",
        "address": "",
        "phone": "0524050151",
        "email": "tawfikb@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "533",
    "firmId": "57068848-a379-4d4f-9361-9fffafa4b82d",
    "firmName": "Arab American Center for Legal Translation",
    "role": "Owner",
    "company": "57068848-a379-4d4f-9361-9fffafa4b82d"
  },
  {
    "id": "85a71c93-07ba-4eef-adc6-3ecc005313eb",
    "slug": "soraya-amin-youssef",
    "name": "Soraya Amin Youssef",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Soraya Amin Youssef",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_85a71c93-07ba-4eef-adc6-3ecc005313eb",
        "address": "",
        "phone": "503170249",
        "email": "Al Manar Legal Translation - Abu Dhabi Tel: 0503170249 / 026779747 Fax: 026747071 Thoraia190@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "337"
  },
  {
    "id": "270f4c33-edce-4570-b592-ccef3f5aebb6",
    "slug": "jubayr-al-amin-mustafa",
    "name": "Jubayr Al-Amin Mustafa",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Jubayr Al-Amin Mustafa",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_270f4c33-edce-4570-b592-ccef3f5aebb6",
        "address": "",
        "phone": "0569291751",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "698f0338-5bb1-45e7-9d97-4486cbadb442",
    "slug": "jamal-al-din-hamed",
    "name": "Jamal Al-Din Hamed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-10-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "licenseIssueDate": "2023-03-14",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Jamal Al-Din Hamed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_698f0338-5bb1-45e7-9d97-4486cbadb442",
        "address": "",
        "phone": "0509851480",
        "email": "gamalhamid63@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "397"
  },
  {
    "id": "49cf3146-af83-4853-a160-8b93782d274a",
    "slug": "jihad-abdel-qader-al-sayed-ali-tariya",
    "name": "Jihad Abdel Qader Al-Sayed Ali Tariya",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2008-12-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-08",
    "licenseIssueDate": "2024-01-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Jihad Abdel Qader Al-Sayed Ali Tariya",
    "consultationFee": 250,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_49cf3146-af83-4853-a160-8b93782d274a",
        "address": "",
        "phone": "050-2703614",
        "email": "mrgvip@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "321",
    "company": "64b99adb-9027-4666-a8e9-e477a78fdfc2",
    "firmId": "64b99adb-9027-4666-a8e9-e477a78fdfc2",
    "firmName": "Sky Legal Translation",
    "role": "Owner"
  },
  {
    "id": "12247f7b-86b7-42b3-a02e-2dc3f6eda69b",
    "slug": "hatem-ahmed-al-wakeel",
    "name": "Hatem Ahmed Al-Wakeel",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hatem Ahmed Al-Wakeel",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_12247f7b-86b7-42b3-a02e-2dc3f6eda69b",
        "address": "",
        "phone": "502289801",
        "email": "Palmyra Legal Translation Office Dubai",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "680"
  },
  {
    "id": "3a691e45-629e-4ec9-ad92-33cfea3e2c2f",
    "slug": "hassan-ismail-guy",
    "name": "Hassan Ismail Guy",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": "2025-07-07",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hassan Ismail Guy",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3a691e45-629e-4ec9-ad92-33cfea3e2c2f",
        "address": "",
        "phone": "501424501",
        "email": "hassangheya@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "786"
  },
  {
    "id": "a9f5ab8e-819e-4124-9b95-fb3950021693",
    "slug": "hassan-al-zubair-is-wet",
    "name": "Hassan Al-Zubair is wet",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hassan Al-Zubair is wet",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_a9f5ab8e-819e-4124-9b95-fb3950021693",
        "address": "",
        "phone": "0506717150",
        "email": "hassanalzubair@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "369",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "65e5c070-45f3-4806-8b78-a5067c6ec296",
    "slug": "hassan-hamdi-muhammad",
    "name": "Hassan Hamdi Muhammad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hassan Hamdi Muhammad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_65e5c070-45f3-4806-8b78-a5067c6ec296",
        "address": "",
        "phone": "505919053",
        "email": "Orbit Legal Translation Abu Dhabi 0561838437 Public4trans@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "626",
    "firmId": "4cdb9b22-d80a-445d-97fa-85a83699aa79",
    "firmName": "Professional legal translation",
    "role": "Owner",
    "company": "4cdb9b22-d80a-445d-97fa-85a83699aa79"
  },
  {
    "id": "7b6c7186-929f-491d-b274-3c528050dfbd",
    "slug": "hassan-muhammad-saleh-khairi",
    "name": "Hassan Muhammad Saleh Khairi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSE0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-11-23",
    "licenseStatus": "active",
    "licenseExpiry": "2027-04-24",
    "licenseIssueDate": "2024-04-25",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hassan Muhammad Saleh Khairi",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_7b6c7186-929f-491d-b274-3c528050dfbd",
        "address": "",
        "phone": "561116605",
        "email": "boshi_net@hotmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "704",
    "company": "5cbd29e6-de48-400c-8fb8-07f19ab39491",
    "firmId": "5cbd29e6-de48-400c-8fb8-07f19ab39491",
    "firmName": "Al-Jihad for legal translation and printing services",
    "role": "Owner"
  },
  {
    "id": "101e0c45-3b6c-41d7-aa90-35fb9c425b04",
    "slug": "hassan-naeem-daoud",
    "name": "Hassan Naeem Daoud",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSE4KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hassan Naeem Daoud",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_101e0c45-3b6c-41d7-aa90-35fb9c425b04",
        "address": "",
        "phone": "0509418126",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "593"
  },
  {
    "id": "e40689a2-1184-4457-ab82-0313ec8a5e26",
    "slug": "hassouna-nour-al-daim-al-tayeb-muhammad",
    "name": "Hassouna Nour Al-Daim Al-Tayeb Muhammad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSE4KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-12-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "licenseIssueDate": "2023-06-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hassouna Nour Al-Daim Al-Tayeb Muhammad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e40689a2-1184-4457-ab82-0313ec8a5e26",
        "address": "",
        "phone": "0508027166",
        "email": "hassunanoor@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "357"
  },
  {
    "id": "e0439939-0081-46ec-a3eb-cab980a4dcc5",
    "slug": "hussein-musa-muhammad-adam",
    "name": "Hussein Musa Muhammad Adam",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSE0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-04-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-29",
    "licenseIssueDate": "2023-05-30",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hussein Musa Muhammad Adam",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e0439939-0081-46ec-a3eb-cab980a4dcc5",
        "address": "",
        "phone": "0558143497",
        "email": "hussein73@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "412",
    "company": "4b20db97-0bf4-49ec-b2f3-a87e953f5b49",
    "firmId": "4b20db97-0bf4-49ec-b2f3-a87e953f5b49",
    "firmName": "Al Burouj Legal Translation Services",
    "role": "Owner"
  },
  {
    "id": "89aeeb02-a51d-49a8-9a63-9b4d694913bb",
    "slug": "his-ruling-is-abdel-mawla-al-juma",
    "name": "His ruling is Abdel Mawla Al Juma",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSFIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: His ruling is Abdel Mawla Al Juma",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_89aeeb02-a51d-49a8-9a63-9b4d694913bb",
        "address": "",
        "phone": "0545288307",
        "email": "hikmat1972@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "307"
  },
  {
    "id": "4cd40693-e102-4769-bb77-123f3d741108",
    "slug": "hamza-erdogan",
    "name": "Hamza Erdogan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEUKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hamza Erdogan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_4cd40693-e102-4769-bb77-123f3d741108",
        "address": "",
        "phone": "undefined",
        "email": "hamertr@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "288"
  },
  {
    "id": "d199ef2e-da56-4c78-af02-371fe9280530",
    "slug": "hamida-abdel-ati-ali",
    "name": "Hamida Abdel Ati Ali",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-05-20",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-15",
    "licenseIssueDate": "2023-06-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hamida Abdel Ati Ali",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d199ef2e-da56-4c78-af02-371fe9280530",
        "address": "",
        "phone": "0557474297",
        "email": "hamadaabdelati@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "516",
    "company": "ABM Marks & Rights"
  },
  {
    "id": "5016ac4f-fe45-40e6-a876-f7110ec933ee",
    "slug": "khaled-mahmoud-al-ali",
    "name": "Khaled Mahmoud Al-Ali",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgS00KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2020-11-23",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": "2021-04-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Khaled Mahmoud Al-Ali",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5016ac4f-fe45-40e6-a876-f7110ec933ee",
        "address": "",
        "phone": "0505737589",
        "email": "rakpoliceghq@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "707"
  },
  {
    "id": "72515955-4e99-42c1-babd-ebe31f215bc1",
    "slug": "khader-dhifallah-musa-al-khalifat",
    "name": "Khader Dhifallah Musa Al-Khalifat",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgS0QKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-01-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-12",
    "licenseIssueDate": "2023-03-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Khader Dhifallah Musa Al-Khalifat",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_72515955-4e99-42c1-babd-ebe31f215bc1",
        "address": "",
        "phone": "0503212910",
        "email": "khaderdmkh@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "456"
  },
  {
    "id": "9f0ae0b8-4601-4255-a852-fe05b68c33ee",
    "slug": "ould-omars-danger",
    "name": "Ould Omar's danger",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgT08KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-07-12",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "licenseIssueDate": "2023-11-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ould Omar's danger",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_9f0ae0b8-4601-4255-a852-fe05b68c33ee",
        "address": "",
        "phone": "506921978",
        "email": "khattra2002@yahoo.fr",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "327",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "27310979-874e-4b2d-ab96-30cb120cc685",
    "slug": "khaldoun-khaled-mustafa-al-omari",
    "name": "Khaldoun Khaled Mustafa Al-Omari",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgS0sKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-01-07",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-06",
    "licenseIssueDate": "2023-04-07",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Khaldoun Khaled Mustafa Al-Omari",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_27310979-874e-4b2d-ab96-30cb120cc685",
        "address": "",
        "phone": "0555100506",
        "email": "Khaldoun75@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "317"
  },
  {
    "id": "d37acb21-c44b-4f97-9d82-8f0570d0a8f5",
    "slug": "kholoud-haiman-al-khatib",
    "name": "Kholoud Haiman Al-Khatib",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgS0gKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2024-02-14",
    "licenseIssueDate": "2021-05-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Kholoud Haiman Al-Khatib",
    "consultationFee": 250,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_d37acb21-c44b-4f97-9d82-8f0570d0a8f5",
        "address": "",
        "phone": "528347080",
        "email": "akholood@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "395",
    "company": "58bcb645-edf8-4afb-a3bf-87c026489064",
    "firmId": "58bcb645-edf8-4afb-a3bf-87c026489064",
    "firmName": "Department of Financial Control, Government of Dubai"
  },
  {
    "id": "eea0e07d-87dd-4a8d-9e2f-a048f4878eae",
    "slug": "dima-muhammad-salmin",
    "name": "Dima Muhammad Salmin",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRE0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Dima Muhammad Salmin",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_eea0e07d-87dd-4a8d-9e2f-a048f4878eae",
        "address": "",
        "phone": "0506638893",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "728"
  },
  {
    "id": "c8ac4cbe-c5ee-4da4-9bbd-fa0b774d51ea",
    "slug": "dina-samih-farhat",
    "name": "Dina Samih Farhat",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRFMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Dina Samih Farhat",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c8ac4cbe-c5ee-4da4-9bbd-fa0b774d51ea",
        "address": "",
        "phone": "569924186",
        "email": "Creative Solio Chans Translation Services 0569924186",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "536"
  },
  {
    "id": "f09cb964-554e-4623-b977-71ab6bdbecf9",
    "slug": "rashid-ali-ahmed-ali-al-mutawa",
    "name": "Rashid Ali Ahmed Ali Al-Mutawa",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgUkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Rashid Ali Ahmed Ali Al-Mutawa",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f09cb964-554e-4623-b977-71ab6bdbecf9",
        "address": "",
        "phone": "0505262603",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "e7bfda59-eab1-4cd8-9b7f-48a4f483b5e2",
    "slug": "rashad-mohammed-attia",
    "name": "Rashad Mohammed Attia",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgUk0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Rashad Mohammed Attia",
    "consultationFee": 250,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_e7bfda59-eab1-4cd8-9b7f-48a4f483b5e2",
        "address": "",
        "phone": "556695644",
        "email": "rashadattya@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "364",
    "company": "Dubai Electricity and Water Authority"
  },
  {
    "id": "1e773785-0ff3-4ed7-b8a9-ac34cd160098",
    "slug": "rola-amin-mohammed-sharif",
    "name": "Rola Amin Mohammed Sharif",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgUkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-30",
    "licenseIssueDate": "2025-07-31",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Rola Amin Mohammed Sharif",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1e773785-0ff3-4ed7-b8a9-ac34cd160098",
        "address": "",
        "phone": "0547886689",
        "email": "rula_fraiwan@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "781",
    "company": "Central Bank of the Emirates"
  },
  {
    "id": "6834681b-8301-4ec4-bd99-2d62f50241ee",
    "slug": "rima-rasem-abu-al-naga",
    "name": "Rima Rasem Abu Al-Naga",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgUlIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-31",
    "licenseIssueDate": "2024-05-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Rima Rasem Abu Al-Naga",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6834681b-8301-4ec4-bd99-2d62f50241ee",
        "address": "",
        "phone": "506535912",
        "email": "Rima@abounaja.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "228",
    "company": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmId": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmName": "Al Sharq Legal Translation Services"
  },
  {
    "id": "54452986-fe9a-4b6b-a78c-47ae400be5c9",
    "slug": "zakaria-ali-hassan-ali",
    "name": "Zakaria Ali Hassan Ali",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Zakaria Ali Hassan Ali",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_54452986-fe9a-4b6b-a78c-47ae400be5c9",
        "address": "",
        "phone": "0503550258",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "79d03783-0197-4399-841b-612cff896099",
    "firmName": "Al-Rafidain Legal Translation",
    "role": "Owner",
    "company": "79d03783-0197-4399-841b-612cff896099"
  },
  {
    "id": "43e38318-0c7d-475c-9976-d09c3ab63dc4",
    "slug": "zakaria-muhammad-salman",
    "name": "Zakaria Muhammad Salman",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWk0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-05-20",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-02",
    "licenseIssueDate": "2023-05-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Zakaria Muhammad Salman",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_43e38318-0c7d-475c-9976-d09c3ab63dc4",
        "address": "",
        "phone": "0501029208",
        "email": "zakareyamohamed@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "507",
    "company": "Anwar Gargash Diplomatic Academy"
  },
  {
    "id": "c20f3ebe-4d85-47e4-8a5e-1c17281d57cd",
    "slug": "zaki-ahmed-zaki",
    "name": "Zaki Ahmed Zaki",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Zaki Ahmed Zaki",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c20f3ebe-4d85-47e4-8a5e-1c17281d57cd",
        "address": "",
        "phone": "0558251813",
        "email": "Legal.translation@zahmiadv.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "367"
  },
  {
    "id": "e5bf6fcc-8017-4705-afae-b5cc008a2e6f",
    "slug": "sameh-shehadta-abdel-razzaq",
    "name": "Sameh Shehadta Abdel Razzaq",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU1MKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Sameh Shehadta Abdel Razzaq",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e5bf6fcc-8017-4705-afae-b5cc008a2e6f",
        "address": "",
        "phone": "552250170",
        "email": "Al Wessam Legal Translation Dubai 0501381528 / P.O. Box: 93335 sameh@marveltranslation.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "358",
    "firmId": "02f6ffa5-664f-434c-adf5-267797de9307",
    "firmName": "Fmkin Legal Translation Services",
    "role": "Owner",
    "company": "02f6ffa5-664f-434c-adf5-267797de9307"
  },
  {
    "id": "059af9e2-1482-48ae-93d7-32b3cc623265",
    "slug": "sami-ayyad-falah-al-majali",
    "name": "Sami Ayyad Falah Al-Majali",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-11-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-26",
    "licenseIssueDate": "2024-03-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Sami Ayyad Falah Al-Majali",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_059af9e2-1482-48ae-93d7-32b3cc623265",
        "address": "",
        "phone": "0567667370",
        "email": "majali.sami@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "768",
    "company": "Global Aerospace Logistics Company"
  },
  {
    "id": "3631115d-80fd-4514-9cca-a790d0a9dcc9",
    "slug": "said-foshal",
    "name": "Said Foshal",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0YKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-05-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-24",
    "licenseIssueDate": "2023-08-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Said Foshal",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3631115d-80fd-4514-9cca-a790d0a9dcc9",
        "address": "",
        "phone": "556450820",
        "email": "fouchalsaid@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "433",
    "company": "9754d171-f5f7-4b26-a326-abfae003d84f",
    "firmId": "9754d171-f5f7-4b26-a326-abfae003d84f",
    "firmName": "Saeed Foshal Legal Translation"
  },
  {
    "id": "2895e0d7-06b6-4bd3-bed9-a4934c2fe298",
    "slug": "salama-ghanem-abbas",
    "name": "Salama Ghanem Abbas",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0cKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 6,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2019-06-26",
    "licenseStatus": "active",
    "licenseExpiry": "2028-08-19",
    "licenseIssueDate": "2025-08-28",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Salama Ghanem Abbas",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2895e0d7-06b6-4bd3-bed9-a4934c2fe298",
        "address": "",
        "phone": "561604548",
        "email": "salamatranslation@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "679"
  },
  {
    "id": "496ef9f2-76b3-431f-a7bc-4d710e4c7a7e",
    "slug": "suleiman-muhammad-adam-ghabash",
    "name": "Suleiman Muhammad Adam Ghabash",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU00KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Suleiman Muhammad Adam Ghabash",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_496ef9f2-76b3-431f-a7bc-4d710e4c7a7e",
        "address": "",
        "phone": "561405260",
        "email": "Lexical Legal Translation 0557446688 lexicaldubai@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "541",
    "firmId": "617254f7-f266-4d85-86fc-7cfd76e6b18e",
    "firmName": "Al Madar Legal Translation",
    "role": "Owner",
    "company": "617254f7-f266-4d85-86fc-7cfd76e6b18e"
  },
  {
    "id": "825414cc-41ad-45ce-99df-d3d80b754076",
    "slug": "semaan-hanna-al-khoury",
    "name": "Semaan Hanna Al-Khoury",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0gKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Semaan Hanna Al-Khoury",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_825414cc-41ad-45ce-99df-d3d80b754076",
        "address": "",
        "phone": "505695699",
        "email": "0",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "89"
  },
  {
    "id": "f6335aa4-b6ff-406e-9b18-c709affca3b6",
    "slug": "samir-muhammad-ali-al-majidi",
    "name": "Samir Muhammad Ali Al-Majidi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU00KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2004-12-20",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-08",
    "licenseIssueDate": "2023-03-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Samir Muhammad Ali Al-Majidi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f6335aa4-b6ff-406e-9b18-c709affca3b6",
        "address": "",
        "phone": "0507811393",
        "email": "sameer4mohali@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "238"
  },
  {
    "id": "63ddeb8f-3551-4024-8e95-dab6361138ff",
    "slug": "sohi-lotfi-jaber-al-jundi",
    "name": "Sohi Lotfi Jaber Al-Jundi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0wKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Sohi Lotfi Jaber Al-Jundi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_63ddeb8f-3551-4024-8e95-dab6361138ff",
        "address": "",
        "phone": "561083400",
        "email": "Cultural Center for Legal Translation 0545119063 sulalj@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "425"
  },
  {
    "id": "0ae02c0a-59eb-4e51-9bb7-4025d6d8a5bd",
    "slug": "shadi-maroun-farah",
    "name": "Shadi Maroun Farah",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU00KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2003-03-29",
    "licenseStatus": "active",
    "licenseExpiry": "2028-03-18",
    "licenseIssueDate": "2025-03-19",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Shadi Maroun Farah",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_0ae02c0a-59eb-4e51-9bb7-4025d6d8a5bd",
        "address": "",
        "phone": "",
        "email": "",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "221",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "fe2b16b3-939a-47ac-8b63-47413a82435a",
    "slug": "champollion-translation-services",
    "name": "Champollion Translation Services",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQ1QKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Champollion Translation Services",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fe2b16b3-939a-47ac-8b63-47413a82435a",
        "address": "",
        "phone": "0569082970",
        "email": "champollion.co@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "e85a86d8-25af-4d1c-aded-671273a01007",
    "slug": "shatha-abdel-hafeez-muhammad-rahma",
    "name": "Shatha Abdel Hafeez Muhammad Rahma",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-07-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-12",
    "licenseIssueDate": "2023-10-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Shatha Abdel Hafeez Muhammad Rahma",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_e85a86d8-25af-4d1c-aded-671273a01007",
        "address": "",
        "phone": "0505055346",
        "email": "shaza.abdul@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "522",
    "company": "7f867c31-c0d9-4e4e-badf-f26fe53149b3",
    "firmId": "7f867c31-c0d9-4e4e-badf-f26fe53149b3",
    "firmName": "Dorrat Al Majd for translation and legal translation services",
    "role": "Owner"
  },
  {
    "id": "fd8468c5-e006-45d4-8f0b-b8b749ee76f0",
    "slug": "shatha-abdel-hafeez-muhammad-rahma",
    "name": "Shatha Abdel Hafeez Muhammad Rahma",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Shatha Abdel Hafeez Muhammad Rahma",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fd8468c5-e006-45d4-8f0b-b8b749ee76f0",
        "address": "",
        "phone": "0505055346",
        "email": "shaza-abdul@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "167"
  },
  {
    "id": "f67d6e20-4a93-4e86-9559-c92db947a35d",
    "slug": "sherif-hamed-al-sayed-abu-al-ezz",
    "name": "Sherif Hamed Al-Sayed Abu Al-Ezz",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0gKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-15",
    "licenseIssueDate": "2023-10-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Sherif Hamed Al-Sayed Abu Al-Ezz",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f67d6e20-4a93-4e86-9559-c92db947a35d",
        "address": "",
        "phone": "505088371",
        "email": "ezzfone@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "639",
    "company": "272bb245-fad0-4bfa-afb0-ed7d8c860bde",
    "firmId": "272bb245-fad0-4bfa-afb0-ed7d8c860bde",
    "firmName": "MSK Legal Translation",
    "role": "Owner"
  },
  {
    "id": "54cc7d1d-2e60-4db5-b7ec-0dd58c7b003c",
    "slug": "shehab-ahmed-saber-al-sayed",
    "name": "Shehab Ahmed Saber Al-Sayed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-28",
    "licenseIssueDate": "2025-07-24",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Shehab Ahmed Saber Al-Sayed",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_54cc7d1d-2e60-4db5-b7ec-0dd58c7b003c",
        "address": "",
        "phone": "0505325083",
        "email": "shehabasaber@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "782",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "b34cc732-71aa-4a4d-b925-2c4829e42a2f",
    "slug": "certificate-for-whom-it-may-concern",
    "name": "Certificate for whom it may concern",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQ1cKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Certificate for whom it may concern",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b34cc732-71aa-4a4d-b925-2c4829e42a2f",
        "address": "",
        "phone": "undefined",
        "email": "alyusrtranslate@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "2ab3ef58-166f-464d-9847-4cf0ce5ccdb3",
    "slug": "shaima-jaber-morsi",
    "name": "Shaima Jaber Morsi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0oKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Shaima Jaber Morsi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2ab3ef58-166f-464d-9847-4cf0ce5ccdb3",
        "address": "",
        "phone": "0558734431",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "81fe642b-37f2-4445-8a91-7247e348e436",
    "firmName": "Domninet Legal Translation",
    "role": "Owner",
    "company": "81fe642b-37f2-4445-8a91-7247e348e436"
  },
  {
    "id": "cd66595b-fec7-4dc3-bfa6-e050f235cb79",
    "slug": "hamdoks-friend-al-basha-hamed",
    "name": "Hamdok's friend Al-Basha Hamed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEYKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hamdok's friend Al-Basha Hamed",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_cd66595b-fec7-4dc3-bfa6-e050f235cb79",
        "address": "",
        "phone": "0503194436",
        "email": "hamdok1957@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "448",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "1b05e09e-eb1d-4c5c-b0ff-006c176fc500",
    "slug": "salahuddin-hassan-muhammad",
    "name": "Salahuddin Hassan Muhammad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0gKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Salahuddin Hassan Muhammad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1b05e09e-eb1d-4c5c-b0ff-006c176fc500",
        "address": "",
        "phone": "0563502945",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "087809ac-bd5a-4448-b845-ae894559a90b",
    "slug": "salah-eid-muhammad-al-sunnah",
    "name": "Salah Eid Muhammad Al-Sunnah",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgU0UKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Salah Eid Muhammad Al-Sunnah",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_087809ac-bd5a-4448-b845-ae894559a90b",
        "address": "",
        "phone": "0506734122",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "304",
    "firmId": "83615c12-6a37-4829-84ef-d3e446d0164d",
    "firmName": "Sawa Lingua Translation Services",
    "role": "Owner",
    "company": "83615c12-6a37-4829-84ef-d3e446d0164d"
  },
  {
    "id": "e81ea903-d54c-457c-8c18-0ec5927e7f22",
    "slug": "abd-rabbo-fadl-hajj-hassan-abu-assi",
    "name": "Abd Rabbo Fadl Hajj Hassan Abu Assi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abd Rabbo Fadl Hajj Hassan Abu Assi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e81ea903-d54c-457c-8c18-0ec5927e7f22",
        "address": "",
        "phone": "0564816677",
        "email": "Al-Alsun Legal Typing and Translation - Sharjah 0506465830 Tel: 5752831 / F: 5752832 Al_alson@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "324",
    "firmId": "1c2b01df-553c-4167-afee-24fcc8d3644e",
    "firmName": "Zoe Legal Translation",
    "role": "Owner",
    "company": "1c2b01df-553c-4167-afee-24fcc8d3644e"
  },
  {
    "id": "ad858d89-4ffd-4f9a-9e2b-622c55d54717",
    "slug": "abdul-ilah-nafis",
    "name": "Abdul Ilah Nafis",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-24",
    "licenseIssueDate": "2025-08-28",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdul Ilah Nafis",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ad858d89-4ffd-4f9a-9e2b-622c55d54717",
        "address": "",
        "phone": "0506780773",
        "email": "abdelilahnafis@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "799",
    "company": "d65a89d3-4700-45d1-81ad-663c7bfeaf8c",
    "firmId": "d65a89d3-4700-45d1-81ad-663c7bfeaf8c",
    "firmName": "Diplomat Legal Translation",
    "role": "Owner"
  },
  {
    "id": "9ac18b25-7b36-4833-b3f3-a3b9f5327a70",
    "slug": "abdul-hamid-abdul-hamid-ali-makhlouf",
    "name": "Abdul Hamid Abdul Hamid Ali Makhlouf",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdul Hamid Abdul Hamid Ali Makhlouf",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9ac18b25-7b36-4833-b3f3-a3b9f5327a70",
        "address": "",
        "phone": "0504241577",
        "email": "Translator_eg@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "396",
    "firmId": "06fd1f2d-eac7-46dc-b85b-dd5d1096d7a1",
    "firmName": "Al-Shadi Translation Services",
    "role": "Owner",
    "company": "06fd1f2d-eac7-46dc-b85b-dd5d1096d7a1"
  },
  {
    "id": "21a493c7-79f7-4888-af7d-a51ee05b491f",
    "slug": "abdul-raouf-abdul-majid",
    "name": "Abdul Raouf Abdul Majid",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdul Raouf Abdul Majid",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_21a493c7-79f7-4888-af7d-a51ee05b491f",
        "address": "",
        "phone": "0561254149",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "d7884d53-f701-4316-971d-151396b56053",
    "firmName": "Expert for legal translation",
    "role": "Owner",
    "company": "d7884d53-f701-4316-971d-151396b56053"
  },
  {
    "id": "80807574-b187-483e-a506-292f175536a2",
    "slug": "abdul-rahman-muhammad-khaled-bustani",
    "name": "Abdul Rahman Muhammad Khaled Bustani",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-04-26",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-30",
    "licenseIssueDate": "2023-11-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdul Rahman Muhammad Khaled Bustani",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_80807574-b187-483e-a506-292f175536a2",
        "address": "",
        "phone": "0503700935",
        "email": "abdbustani@outlook.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "630",
    "company": "20ae26fc-e3b4-464f-ab7e-37ec3e6f46c5",
    "firmId": "20ae26fc-e3b4-464f-ab7e-37ec3e6f46c5",
    "firmName": "The supplier for legal translation",
    "role": "Owner"
  },
  {
    "id": "47faf682-fd9d-4284-88c6-50ee67ff1052",
    "slug": "abdul-salam-lee",
    "name": "Abdul Salam Lee",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdul Salam Lee",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_47faf682-fd9d-4284-88c6-50ee67ff1052",
        "address": "",
        "phone": "0553487326",
        "email": "abdoul.salam17@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "602"
  },
  {
    "id": "a2d246e3-d25e-4f7b-87cd-ca1649eea193",
    "slug": "abdulazizi-abu-al-qasim-zain-al-abidin-abu-saleh",
    "name": "Abdulazizi Abu Al-Qasim Zain Al-Abidin Abu Saleh",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-06-17",
    "licenseStatus": "active",
    "licenseExpiry": "2021-12-08",
    "licenseIssueDate": "2019-01-14",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdulazizi Abu Al-Qasim Zain Al-Abidin Abu Saleh",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a2d246e3-d25e-4f7b-87cd-ca1649eea193",
        "address": "",
        "phone": "505105400",
        "email": "fatimagasim@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "504",
    "firmId": "afb52437-ec76-4ef9-bd97-72b37f0c62e4",
    "firmName": "Dictionary translation services",
    "role": "Owner",
    "company": "afb52437-ec76-4ef9-bd97-72b37f0c62e4"
  },
  {
    "id": "a75cfb10-2d04-46ae-8156-dc3f423171ff",
    "slug": "abdul-azim-muhammad-okasha",
    "name": "Abdul-Azim Muhammad Okasha",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdul-Azim Muhammad Okasha",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a75cfb10-2d04-46ae-8156-dc3f423171ff",
        "address": "",
        "phone": "507680215",
        "email": "Al-Balagha for Legal Translation Tel: 04/7680215 / F: 04/3327885 P.O. Box: 13626 Abdelazim.akasha@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "249"
  },
  {
    "id": "e3592671-3ed2-4693-90f2-777db84b98cd",
    "slug": "abdel-fattah-abdullah-mahmoud-abbas",
    "name": "Abdel Fattah Abdullah Mahmoud Abbas",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUYKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-04-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-07",
    "licenseIssueDate": "2023-06-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdel Fattah Abdullah Mahmoud Abbas",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e3592671-3ed2-4693-90f2-777db84b98cd",
        "address": "",
        "phone": "0502316474",
        "email": "abdul_fand@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "349",
    "company": "5c225e35-22f0-4c8a-be39-d18464c9e120",
    "firmId": "5c225e35-22f0-4c8a-be39-d18464c9e120",
    "firmName": "Golden Bridges Translation Services",
    "role": "Owner"
  },
  {
    "id": "90bdcd96-a0c5-4889-86ae-386ce3fc73aa",
    "slug": "abdullah-bilal-yaqut-rashid",
    "name": "Abdullah Bilal Yaqut Rashid",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-08-05",
    "licenseIssueDate": "2025-08-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdullah Bilal Yaqut Rashid",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_90bdcd96-a0c5-4889-86ae-386ce3fc73aa",
        "address": "",
        "phone": "0559640610",
        "email": "abdullah.belal@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "623",
    "company": "armed forces"
  },
  {
    "id": "d4e0f2af-b6d0-498d-b2b9-4cc992931da7",
    "slug": "abdullah-ali-ismail-ibrahim",
    "name": "Abdullah Ali Ismail Ibrahim",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-03-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-30",
    "licenseIssueDate": "2023-05-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdullah Ali Ismail Ibrahim",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d4e0f2af-b6d0-498d-b2b9-4cc992931da7",
        "address": "",
        "phone": "0521399146",
        "email": "ismail_20122020@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "749",
    "company": "Rabdan Academy - Governmental"
  },
  {
    "id": "82cbf816-8a46-40aa-9516-ee5ee2635d78",
    "slug": "abdul-muti-issa",
    "name": "Abdul Muti Issa",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdul Muti Issa",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_82cbf816-8a46-40aa-9516-ee5ee2635d78",
        "address": "",
        "phone": "0503667433",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "286",
    "firmId": "5d44732d-4505-42cb-8174-38ec25b3a83a",
    "firmName": "Dar Luqman Translation Services",
    "role": "Owner",
    "company": "5d44732d-4505-42cb-8174-38ec25b3a83a"
  },
  {
    "id": "87ec02f5-b782-4e63-9fd6-cc737e70036d",
    "slug": "abdel-moneim-ahmed-al-hawa",
    "name": "Abdel Moneim Ahmed Al-Hawa",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdel Moneim Ahmed Al-Hawa",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_87ec02f5-b782-4e63-9fd6-cc737e70036d",
        "address": "",
        "phone": "0506735631",
        "email": "hawwab@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "525",
    "firmId": "41056950-c4e3-4499-b1fa-9288c7047111",
    "firmName": "Al-Ahram for business services and translation",
    "role": "Owner",
    "company": "41056950-c4e3-4499-b1fa-9288c7047111"
  },
  {
    "id": "27bc534d-51c8-42b3-b725-121daad39a0c",
    "slug": "abdel-moneim-mohammed-abdel-moneim-al-qat",
    "name": "Abdel Moneim Mohammed Abdel Moneim Al-Qat",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-12-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-11",
    "licenseIssueDate": "2023-09-12",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Abdel Moneim Mohammed Abdel Moneim Al-Qat",
    "consultationFee": 250,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_27bc534d-51c8-42b3-b725-121daad39a0c",
        "address": "",
        "phone": "0501691190",
        "email": "mrabdelmoneim1@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "467",
    "company": "58bcb645-edf8-4afb-a3bf-87c026489064",
    "firmId": "58bcb645-edf8-4afb-a3bf-87c026489064",
    "firmName": "Department of Financial Control, Government of Dubai"
  },
  {
    "id": "0f523c49-c155-4874-bcf2-772ef75f3dad",
    "slug": "arabiz",
    "name": "Arabiz",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQVIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Arabiz",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0f523c49-c155-4874-bcf2-772ef75f3dad",
        "address": "",
        "phone": "undefined",
        "email": "irfan.chan@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "9ac243d9-945b-4ad4-b989-1b3936fad7ae",
    "slug": "ezzedine-muhammad",
    "name": "Ezzedine Muhammad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ezzedine Muhammad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9ac243d9-945b-4ad4-b989-1b3936fad7ae",
        "address": "",
        "phone": "0502655933",
        "email": "ezz@asaslt.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "c6acfadc-75b6-499a-8f53-f79b18310ca9",
    "slug": "alaa-al-sayyed-anwar-mousi",
    "name": "Alaa Al-Sayyed Anwar Mousi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2008-05-04",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-10",
    "licenseIssueDate": "2023-12-11",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Alaa Al-Sayyed Anwar Mousi",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_c6acfadc-75b6-499a-8f53-f79b18310ca9",
        "address": "",
        "phone": "503291280",
        "email": "alaaanwar@hotmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "306",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "5db54015-c952-4fe0-8c19-69d838234a7d",
    "slug": "alaa-gamal-abdel-hakim",
    "name": "Alaa Gamal Abdel Hakim",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUcKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-07-15",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-17",
    "licenseIssueDate": "2023-09-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Alaa Gamal Abdel Hakim",
    "consultationFee": 250,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_5db54015-c952-4fe0-8c19-69d838234a7d",
        "address": "",
        "phone": "0505725466",
        "email": "alaa-mohammad@outlook.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "331",
    "company": "bdb32fe4-ccaf-4ab9-b019-f31a610afa48",
    "firmId": "bdb32fe4-ccaf-4ab9-b019-f31a610afa48",
    "firmName": "Department of Services (Ras Al Khaimah Government)"
  },
  {
    "id": "3e7d14d0-b4fe-4746-82a7-8cd1b5f83bdc",
    "slug": "alaa-abdel-qader-hashem-suleiman",
    "name": "Alaa Abdel Qader Hashem Suleiman",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 19,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2006-11-23",
    "licenseStatus": "active",
    "licenseExpiry": "2027-05-19",
    "licenseIssueDate": "2024-05-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Alaa Abdel Qader Hashem Suleiman",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_3e7d14d0-b4fe-4746-82a7-8cd1b5f83bdc",
        "address": "",
        "phone": "0507300705",
        "email": "a_hashem1968@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "269",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "e4222041-efac-4623-9fbe-a6e3bd04e978",
    "slug": "alaa-obaid-morsis-friend",
    "name": "Alaa Obaid, Morsi's friend",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU8KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-05-09",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-19",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Alaa Obaid, Morsi's friend",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e4222041-efac-4623-9fbe-a6e3bd04e978",
        "address": "",
        "phone": "0547170069",
        "email": "alaa_seddiq22@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "753"
  },
  {
    "id": "ad5048fd-6304-46cb-8bc2-682660f66acf",
    "slug": "ali-muhammad-abdo-qasim",
    "name": "Ali Muhammad Abdo Qasim",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ali Muhammad Abdo Qasim",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ad5048fd-6304-46cb-8bc2-682660f66acf",
        "address": "",
        "phone": "555132498",
        "email": "Westb Legal Translation Abu Dhabi 026272065 / 050/6428915 Tel: 0555132498 / Fax: 626725702 alikasem@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "48"
  },
  {
    "id": "9b06707c-b517-44d1-9984-13b35f875d40",
    "slug": "imad-zaki",
    "name": "Imad Zaki",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSVoKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Imad Zaki",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9b06707c-b517-44d1-9984-13b35f875d40",
        "address": "",
        "phone": "0507212129",
        "email": "efraiji@moj.gov.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "9999"
  },
  {
    "id": "52a1fbaa-b463-42b9-9371-1af370b84140",
    "slug": "ammar-muhammad-ahmed",
    "name": "Ammar Muhammad Ahmed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ammar Muhammad Ahmed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_52a1fbaa-b463-42b9-9371-1af370b84140",
        "address": "",
        "phone": "0502311335",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "2e573c44-2851-498e-b52d-986105540deb",
    "slug": "ammar-muhammad-ahmed-abbas",
    "name": "Ammar Muhammad Ahmed Abbas",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Ammar Muhammad Ahmed Abbas",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2e573c44-2851-498e-b52d-986105540deb",
        "address": "",
        "phone": "0502311335",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "eee1fe77-c994-4fe1-9bb9-83ecd832091b",
    "firmName": "Praise be to legal translation",
    "role": "Owner",
    "company": "eee1fe77-c994-4fe1-9bb9-83ecd832091b"
  },
  {
    "id": "169b20a6-e951-47e1-8075-26e1e32ba8c5",
    "slug": "omar-muhammad-al-zoubi",
    "name": "Omar Muhammad Al-Zoubi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgT00KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Omar Muhammad Al-Zoubi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_169b20a6-e951-47e1-8075-26e1e32ba8c5",
        "address": "",
        "phone": "0558750044",
        "email": "Tanween Legal Translation Dubai 971558750044 nrz695@live.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "735"
  },
  {
    "id": "e1e89937-b817-447a-a2a0-b1d01cecbf4b",
    "slug": "amr-ahmed-el-sayed-metwally",
    "name": "Amr Ahmed El-Sayed Metwally",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Amr Ahmed El-Sayed Metwally",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e1e89937-b817-447a-a2a0-b1d01cecbf4b",
        "address": "",
        "phone": "0506268910",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "9fb0076c-6810-4f7b-bbf1-11f1324f7179",
    "slug": "charming-chu-ling",
    "name": "Charming Chu Ling",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQ0MKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Charming Chu Ling",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9fb0076c-6810-4f7b-bbf1-11f1324f7179",
        "address": "",
        "phone": "506562196",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "290"
  },
  {
    "id": "9a029658-c8a8-4050-8dc2-dced3d48922c",
    "slug": "faten-abdullah-abdul-hafeez",
    "name": "Faten Abdullah Abdul Hafeez",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-12-13",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-13",
    "licenseIssueDate": "2023-06-14",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Faten Abdullah Abdul Hafeez",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9a029658-c8a8-4050-8dc2-dced3d48922c",
        "address": "",
        "phone": "0544408050",
        "email": "fatensam@gamil.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "344",
    "company": "Judicial Department"
  },
  {
    "id": "54fc3cbe-7587-4e86-ae3a-589f25648b25",
    "slug": "fadi-adnan",
    "name": "Fadi Adnan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Fadi Adnan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_54fc3cbe-7587-4e86-ae3a-589f25648b25",
        "address": "",
        "phone": "0507064000",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "ec04aaf9-c471-4644-bc43-8ef3b922bc20",
    "slug": "fadia-ibrahim-al-khatib",
    "name": "Fadia Ibrahim Al-Khatib",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRkkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-11-10",
    "licenseStatus": "active",
    "licenseExpiry": "2028-06-30",
    "licenseIssueDate": "2025-07-01",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Fadia Ibrahim Al-Khatib",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_ec04aaf9-c471-4644-bc43-8ef3b922bc20",
        "address": "",
        "phone": "0503258521",
        "email": "fadia238@hotmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "616",
    "company": "03096a27-c9b2-462f-92db-2ab0e9688ce8",
    "firmId": "03096a27-c9b2-462f-92db-2ab0e9688ce8",
    "firmName": "Elite legal translation services",
    "role": "Owner"
  },
  {
    "id": "7602320f-11e6-441e-a6c6-697bda482336",
    "slug": "fadel-omar-al-jassim",
    "name": "Fadel Omar Al-Jassim",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRk8KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Fadel Omar Al-Jassim",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7602320f-11e6-441e-a6c6-697bda482336",
        "address": "",
        "phone": "0503392757",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "540"
  },
  {
    "id": "8fc07c87-5928-4415-8b9a-806a11376064",
    "slug": "fatima-belhassan",
    "name": "Fatima Belhassan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRkIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-11-10",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-01",
    "licenseIssueDate": "2024-03-05",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Fatima Belhassan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8fc07c87-5928-4415-8b9a-806a11376064",
        "address": "",
        "phone": "553169507",
        "email": "Bien_est@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "617",
    "company": "Emirates Islamic Bank"
  },
  {
    "id": "961b6078-68dd-489b-9114-fb511e12a786",
    "slug": "fatima-abdullah-durar",
    "name": "Fatima Abdullah Durar",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Fatima Abdullah Durar",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_961b6078-68dd-489b-9114-fb511e12a786",
        "address": "",
        "phone": "0505467296",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "6ef616b3-688e-4c69-85ef-254207d5560e",
    "slug": "fayez-ahmed-abdulaziz-al-jamal",
    "name": "Fayez Ahmed Abdulaziz Al-Jamal",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 41,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1984-09-11",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-23",
    "licenseIssueDate": "2023-08-24",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Fayez Ahmed Abdulaziz Al-Jamal",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6ef616b3-688e-4c69-85ef-254207d5560e",
        "address": "",
        "phone": "0507115004",
        "email": "faljamal@etisalat.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "9",
    "company": "992e56a9-53e0-41ad-9605-93fd99692454",
    "firmId": "992e56a9-53e0-41ad-9605-93fd99692454",
    "firmName": "Communication for legal translation"
  },
  {
    "id": "510ac6ad-256b-459a-92d6-8df5eeb83051",
    "slug": "redemption-of-muhammad-abu-hassoun",
    "name": "Redemption of Muhammad Abu Hassoun",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgUk0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-02-17",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-15",
    "licenseIssueDate": "2023-05-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Redemption of Muhammad Abu Hassoun",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_510ac6ad-256b-459a-92d6-8df5eeb83051",
        "address": "",
        "phone": "0503309345",
        "email": "fida.teacher@hotmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "622",
    "company": "83acfa7c-d3f5-4e74-8101-c023d3e22be5",
    "firmId": "83acfa7c-d3f5-4e74-8101-c023d3e22be5",
    "firmName": "Trading for translation services",
    "role": "Owner"
  },
  {
    "id": "ae5a8fe6-6c4c-49c5-82d7-e3a57db7bf50",
    "slug": "firas-fadel-hassan-hassan",
    "name": "Firas Fadel Hassan Hassan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRkYKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 4,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2022-02-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-03-19",
    "licenseIssueDate": "2025-03-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Firas Fadel Hassan Hassan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ae5a8fe6-6c4c-49c5-82d7-e3a57db7bf50",
        "address": "",
        "phone": "0501804404",
        "email": "firas_alnasry@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "734",
    "company": "Emirates News Agency"
  },
  {
    "id": "67cbf24c-649b-4fed-82bc-d4e7a62b8805",
    "slug": "faryal-abdel-ali",
    "name": "Faryal Abdel Ali",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Faryal Abdel Ali",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_67cbf24c-649b-4fed-82bc-d4e7a62b8805",
        "address": "",
        "phone": "0503316814",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "f49ff468-5772-4003-ab6b-2093038c9f51",
    "slug": "four-corners-legal-translation",
    "name": "Four Corners Legal Translation",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRkMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Four Corners Legal Translation",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f49ff468-5772-4003-ab6b-2093038c9f51",
        "address": "",
        "phone": "0503090031",
        "email": "ceo@4translationgroup.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "a12bbdfb-a254-41ff-bf50-57f5f8b53831",
    "slug": "karim-fouad-sharqawi",
    "name": "Karim Fouad Sharqawi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgS0YKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-11-29",
    "licenseStatus": "active",
    "licenseExpiry": "2023-02-06",
    "licenseIssueDate": "2023-02-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Karim Fouad Sharqawi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a12bbdfb-a254-41ff-bf50-57f5f8b53831",
        "address": "",
        "phone": "0567274504",
        "email": "karim.sharkawi@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "535",
    "company": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmId": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmName": "Al Sharq Legal Translation Services"
  },
  {
    "id": "fc1cb290-114d-4541-b1cf-400e1f716d0d",
    "slug": "kenana-ibrahim-nasra",
    "name": "Kenana Ibrahim Nasra",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgS0kKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2005-06-18",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-16",
    "licenseIssueDate": "2023-10-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Kenana Ibrahim Nasra",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fc1cb290-114d-4541-b1cf-400e1f716d0d",
        "address": "",
        "phone": "506255339",
        "email": "kinana@nasra.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "246",
    "company": "Nasra Foundation for Marketing Studies"
  },
  {
    "id": "87b75345-097c-4aec-876c-070a75c13a3f",
    "slug": "kawthar-abboud-muhammad",
    "name": "Kawthar Abboud Muhammad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgS0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-02-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-12",
    "licenseIssueDate": "2023-03-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Kawthar Abboud Muhammad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_87b75345-097c-4aec-876c-070a75c13a3f",
        "address": "",
        "phone": "0503107256",
        "email": "kawtharmohamad72@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "544"
  },
  {
    "id": "25a5a84b-819b-4817-b22f-9afe26bb5137",
    "slug": "louay-abdul-latif-income-income-god",
    "name": "Louay Abdul Latif, income, income, God",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-03-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-27",
    "licenseIssueDate": "2024-03-28",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Louay Abdul Latif, income, income, God",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_25a5a84b-819b-4817-b22f-9afe26bb5137",
        "address": "",
        "phone": "555550047",
        "email": "uncolored@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "353",
    "company": "e85f25e6-2169-4d37-9ec7-dadd36fbf7a0",
    "firmId": "e85f25e6-2169-4d37-9ec7-dadd36fbf7a0",
    "firmName": "Ministry of Defense - Administrative Affairs Department"
  },
  {
    "id": "1181c879-bbd7-48bf-9561-8bbca021ed6d",
    "slug": "lamia-ibrahim-ali",
    "name": "Lamia Ibrahim Ali",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTEkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Lamia Ibrahim Ali",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1181c879-bbd7-48bf-9561-8bbca021ed6d",
        "address": "",
        "phone": "Green City Legal Translation Al Ain T.0506652094",
        "email": "Ahmed.hegazi@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "442"
  },
  {
    "id": "4a46b847-f97b-409d-bd96-1b5074c90e91",
    "slug": "lamia-abdel-fattah-bashir-abdel-sadiq",
    "name": "Lamia Abdel Fattah Bashir Abdel Sadiq",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-11-16",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-19",
    "licenseIssueDate": "2023-11-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Lamia Abdel Fattah Bashir Abdel Sadiq",
    "consultationFee": 250,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_4a46b847-f97b-409d-bd96-1b5074c90e91",
        "address": "",
        "phone": "503020633",
        "email": "daralkhubara@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "389",
    "company": "58bcb645-edf8-4afb-a3bf-87c026489064",
    "firmId": "58bcb645-edf8-4afb-a3bf-87c026489064",
    "firmName": "Department of Financial Control, Government of Dubai"
  },
  {
    "id": "5fcca782-5fdb-450a-a68a-5e4181d44dc0",
    "slug": "magic-of-word",
    "name": "Magic of Word",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTVcKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Magic of Word",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5fcca782-5fdb-450a-a68a-5e4181d44dc0",
        "address": "",
        "phone": "0506077121",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "13ba1bdf-8372-4f68-b694-11df5ff06483",
    "slug": "maria-luisa-revolna",
    "name": "Maria Luisa Revolna",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUwKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 1,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2025-07-07",
    "licenseStatus": "active",
    "licenseExpiry": "2028-08-20",
    "licenseIssueDate": "2025-08-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Maria Luisa Revolna",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_13ba1bdf-8372-4f68-b694-11df5ff06483",
        "address": "",
        "phone": "0586497891",
        "email": "crtranslations5@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "795"
  },
  {
    "id": "ed2e9678-5c1c-4405-9a37-d8a52640d9ca",
    "slug": "maher",
    "name": "Maher",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Maher",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ed2e9678-5c1c-4405-9a37-d8a52640d9ca",
        "address": "",
        "phone": "6262053-050",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "79"
  },
  {
    "id": "25070dbd-4ba3-4287-b820-9177139f75cf",
    "slug": "congratulations-yaqut-mubarak",
    "name": "Congratulations Yaqut Mubarak",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQ1kKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Congratulations Yaqut Mubarak",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_25070dbd-4ba3-4287-b820-9177139f75cf",
        "address": "",
        "phone": "0565736635",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "8b161202-d522-4d1f-8ec8-e7fa9463c135",
    "slug": "legal-translator",
    "name": "Legal translator",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTFQKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Legal translator",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8b161202-d522-4d1f-8ec8-e7fa9463c135",
        "address": "",
        "phone": "undefined",
        "email": "haladxb2020@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "0184e883-8840-47c3-91d4-258562f186c6",
    "slug": "mujeeb-rahman",
    "name": "Mujeeb Rahman",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTVIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mujeeb Rahman",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0184e883-8840-47c3-91d4-258562f186c6",
        "address": "",
        "phone": "0545436262",
        "email": "info@wordcraft.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "fbd661bd-861a-4d78-9cad-83ac9380c2f2",
    "slug": "mohamed-ahmed-sabry-al-sayed",
    "name": "Mohamed Ahmed Sabry Al-Sayed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mohamed Ahmed Sabry Al-Sayed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_fbd661bd-861a-4d78-9cad-83ac9380c2f2",
        "address": "",
        "phone": "0555540760",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "382"
  },
  {
    "id": "f1d60501-fbb6-4c05-8730-ab0f98752b64",
    "slug": "muhammad-ibrahim-al-sayed-musa-al-najjar",
    "name": "Muhammad Ibrahim Al-Sayed Musa Al-Najjar",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2021-04-20",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-14",
    "licenseIssueDate": "2025-01-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Ibrahim Al-Sayed Musa Al-Najjar",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f1d60501-fbb6-4c05-8730-ab0f98752b64",
        "address": "",
        "phone": "0502824408",
        "email": "muhammad_elnaggar@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "716",
    "company": "Statistics Center"
  },
  {
    "id": "9bfc0a67-fe79-4119-ab2f-ee81e6976bfd",
    "slug": "muhammad-ahmed-barakat",
    "name": "Muhammad Ahmed Barakat",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 40,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1986-05-24",
    "licenseStatus": "active",
    "licenseExpiry": "2026-05-15",
    "licenseIssueDate": "2023-05-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Ahmed Barakat",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9bfc0a67-fe79-4119-ab2f-ee81e6976bfd",
        "address": "",
        "phone": "506713783",
        "email": "translators@moj.gov.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "97"
  },
  {
    "id": "5919077c-f553-44d7-8970-245fa0c7aa62",
    "slug": "mohamed-ahmed-abdel-qader",
    "name": "Mohamed Ahmed Abdel Qader",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mohamed Ahmed Abdel Qader",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_5919077c-f553-44d7-8970-245fa0c7aa62",
        "address": "",
        "phone": "0506337763",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "e858364c-18b8-4679-a966-ffb0b0e27b50",
    "slug": "muhammad-al-amin-othman-omar",
    "name": "Muhammad Al-Amin Othman Omar",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Al-Amin Othman Omar",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_e858364c-18b8-4679-a966-ffb0b0e27b50",
        "address": "",
        "phone": "0569468452",
        "email": "muhamado@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "40dea162-b047-4bd7-ac2f-a688c3cbb713",
    "firmName": "Golden Letters for Legal Translation - Dubai",
    "role": "Owner",
    "company": "40dea162-b047-4bd7-ac2f-a688c3cbb713"
  },
  {
    "id": "0d4a57b9-21df-471f-a500-e56a0175d80e",
    "slug": "muhammad-al-sayed-al-ajroud",
    "name": "Muhammad Al-Sayed Al-Ajroud",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2003-05-26",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-05",
    "licenseIssueDate": "2023-09-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Al-Sayed Al-Ajroud",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0d4a57b9-21df-471f-a500-e56a0175d80e",
        "address": "",
        "phone": "0504149520",
        "email": "ms.ladjeroud@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "213",
    "company": "Judicial Department"
  },
  {
    "id": "773779b8-794e-40a9-9658-e2447eeb0499",
    "slug": "muhammad-amin-al-abbasi",
    "name": "Muhammad Amin Al-Abbasi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-01-07",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-30",
    "licenseIssueDate": "2023-05-01",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Amin Al-Abbasi",
    "consultationFee": 250,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_773779b8-794e-40a9-9658-e2447eeb0499",
        "address": "",
        "phone": "0505724018",
        "email": "medaminos28@gmail.com",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "313",
    "company": "58bcb645-edf8-4afb-a3bf-87c026489064",
    "firmId": "58bcb645-edf8-4afb-a3bf-87c026489064",
    "firmName": "Department of Financial Control, Government of Dubai"
  },
  {
    "id": "7bce5559-5905-409a-bac5-b1f0f89143ac",
    "slug": "muhammad-anas-al-sabagh",
    "name": "Muhammad Anas Al-Sabagh",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Anas Al-Sabagh",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7bce5559-5905-409a-bac5-b1f0f89143ac",
        "address": "",
        "phone": "0507764941",
        "email": "",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "96170f1f-c5ad-4d6a-968d-24c824ea655f",
    "slug": "muhammad-basil-abdul-wahab-al-abtah",
    "name": "Muhammad Basil Abdul Wahab Al-Abtah",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-11-30",
    "licenseStatus": "active",
    "licenseExpiry": "2027-02-01",
    "licenseIssueDate": "2024-03-12",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Basil Abdul Wahab Al-Abtah",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_96170f1f-c5ad-4d6a-968d-24c824ea655f",
        "address": "",
        "phone": "0589424714",
        "email": "mba@dubaitranslation.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "764",
    "company": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmId": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmName": "Al Sharq Legal Translation Services"
  },
  {
    "id": "c783edd9-9661-4b1d-a9eb-ad19d1573a20",
    "slug": "muhammad-bishri-youssef",
    "name": "Muhammad Bishri Youssef",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 18,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2007-10-31",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-12",
    "licenseIssueDate": "2023-03-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Bishri Youssef",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c783edd9-9661-4b1d-a9eb-ad19d1573a20",
        "address": "",
        "phone": "0504150192",
        "email": "Boshra_man79@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "295"
  },
  {
    "id": "a10f953c-b5bc-4d77-b785-20e005e55e92",
    "slug": "muhammad-jibril-ismail-othman",
    "name": "Muhammad Jibril Ismail Othman",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUoKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Jibril Ismail Othman",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a10f953c-b5bc-4d77-b785-20e005e55e92",
        "address": "",
        "phone": "0529859903",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "537",
    "firmId": "86ce3825-4eb5-4e3c-b5a1-1cc7957734e8",
    "firmName": "Word bridges for legal translation",
    "role": "Owner",
    "company": "86ce3825-4eb5-4e3c-b5a1-1cc7957734e8"
  },
  {
    "id": "1a0801df-485f-49e2-973b-1120cdb24793",
    "slug": "muhammad-hassan-muhammad-al-jazzar",
    "name": "Muhammad Hassan Muhammad Al-Jazzar",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-03-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-07-05",
    "licenseIssueDate": "2023-07-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Hassan Muhammad Al-Jazzar",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1a0801df-485f-49e2-973b-1120cdb24793",
        "address": "",
        "phone": "501052920",
        "email": "moh89translator@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "751",
    "company": "Global Aerospace Logistics Company"
  },
  {
    "id": "6a081da5-90b1-418f-b4cd-869adc636abd",
    "slug": "muhammad-hussein-al-ahmad-ajlani-al-anzi",
    "name": "Muhammad Hussein Al-Ahmad Ajlani Al-Anzi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-01-20",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-02",
    "licenseIssueDate": "2020-03-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Hussein Al-Ahmad Ajlani Al-Anzi",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_6a081da5-90b1-418f-b4cd-869adc636abd",
        "address": "",
        "phone": "0528707974",
        "email": "M2hizam@hotmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "338",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "aa2b20cc-5a21-4c23-b192-fb668b4d161b",
    "slug": "muhammad-rashid-muhammad-ayoub",
    "name": "Muhammad Rashid Muhammad Ayoub",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTVIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "Portuguese"
    ],
    "mojLicense": "2015-07-22",
    "licenseStatus": "active",
    "licenseExpiry": "2027-09-30",
    "licenseIssueDate": "2024-10-01",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Rashid Muhammad Ayoub",
    "consultationFee": 250,
    "emirate": "Dubai",
    "verified": true,
    "offices": [
      {
        "id": "office_aa2b20cc-5a21-4c23-b192-fb668b4d161b",
        "address": "",
        "phone": "556006042",
        "email": "mohammed.ayub@rta.ae",
        "emirate": "Dubai",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "519",
    "company": "Roads and Transport Authority - Dubai"
  },
  {
    "id": "8f42608e-06a2-448e-83d4-e13a251fefea",
    "slug": "muhammad-abdel-hamid-abdel-hamid",
    "name": "Muhammad Abdel Hamid Abdel Hamid",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Abdel Hamid Abdel Hamid",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8f42608e-06a2-448e-83d4-e13a251fefea",
        "address": "",
        "phone": "0568559113",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "207f4ae0-4b16-4fa0-8e14-dd37f4663484",
    "slug": "muhammad-abdullah-qureshi-abu-sayyah",
    "name": "Muhammad Abdullah Qureshi Abu Sayyah",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-11-13",
    "licenseStatus": "active",
    "licenseExpiry": "2027-03-20",
    "licenseIssueDate": "2024-03-21",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Abdullah Qureshi Abu Sayyah",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_207f4ae0-4b16-4fa0-8e14-dd37f4663484",
        "address": "",
        "phone": "507210470",
        "email": "Malgurashi@aacic.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "450",
    "company": "029a4eb3-8886-4cd0-947c-a2ea67af0c11",
    "firmId": "029a4eb3-8886-4cd0-947c-a2ea67af0c11",
    "firmName": "Dar Al-Alsun for Legal Translation - Abu Dhabi",
    "role": "Owner"
  },
  {
    "id": "737b763f-566c-40f8-b55a-18600dc61fa8",
    "slug": "muhammad-abdullah-muhammad-morsi",
    "name": "Muhammad Abdullah Muhammad Morsi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 10,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2016-02-07",
    "licenseStatus": "active",
    "licenseExpiry": "2026-01-18",
    "licenseIssueDate": "2023-03-22",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Abdullah Muhammad Morsi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_737b763f-566c-40f8-b55a-18600dc61fa8",
        "address": "",
        "phone": "0508535036",
        "email": "mo.abdalla002@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "613"
  },
  {
    "id": "2643e6f1-3f94-4be9-a715-812ce0db05d5",
    "slug": "muhammad-artan-ismail",
    "name": "Muhammad Artan Ismail",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Artan Ismail",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2643e6f1-3f94-4be9-a715-812ce0db05d5",
        "address": "",
        "phone": "509286099",
        "email": "Makarem Legal Translation Office Abu Dhabi 0509286099",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "669"
  },
  {
    "id": "d84bc119-cbee-4b4e-bc22-dd90cb8aeab0",
    "slug": "mohamed-ezzedine-khaled-al-sayed",
    "name": "Mohamed Ezzedine Khaled Al-Sayed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUUKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mohamed Ezzedine Khaled Al-Sayed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d84bc119-cbee-4b4e-bc22-dd90cb8aeab0",
        "address": "",
        "phone": "0505320741",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "54acdb6d-d7ee-4a0c-bcab-6e89a0e7307e",
    "firmName": "AS Smart Translation",
    "role": "Owner",
    "company": "54acdb6d-d7ee-4a0c-bcab-6e89a0e7307e"
  },
  {
    "id": "043662bf-44b6-401a-b368-0a061f5d8be0",
    "slug": "muhammad-attia-al-shawadfi",
    "name": "Muhammad Attia Al-Shawadfi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-01-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-05",
    "licenseIssueDate": "2023-03-27",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Attia Al-Shawadfi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_043662bf-44b6-401a-b368-0a061f5d8be0",
        "address": "",
        "phone": "501858659",
        "email": "alalsunman@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "461",
    "company": "Rabdan Academy - Governmental"
  },
  {
    "id": "949fbf5c-9710-431b-a216-4b54e02ad0d8",
    "slug": "muhammad-kamal-muhammad",
    "name": "Muhammad Kamal Muhammad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUsKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2013-03-09",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-12",
    "licenseIssueDate": "2023-03-13",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Kamal Muhammad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_949fbf5c-9710-431b-a216-4b54e02ad0d8",
        "address": "",
        "phone": "566898403",
        "email": "mkamalm01@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "446"
  },
  {
    "id": "2c9d5ecb-3dff-430c-9425-100fffb44d1e",
    "slug": "mohamed-mohamed-ahmed-abdel-aty",
    "name": "Mohamed Mohamed Ahmed Abdel-Aty",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2024-03-27",
    "licenseStatus": "active",
    "licenseExpiry": "2027-04-25",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mohamed Mohamed Ahmed Abdel-Aty",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2c9d5ecb-3dff-430c-9425-100fffb44d1e",
        "address": "",
        "phone": "507318262",
        "email": "muh_2010@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "315"
  },
  {
    "id": "cd832f05-0998-4ec3-aea9-1d452f1957d3",
    "slug": "muhammad-mustafa-al-athba",
    "name": "Muhammad Mustafa Al-Athba",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-03-30",
    "licenseStatus": "active",
    "licenseExpiry": "2026-04-25",
    "licenseIssueDate": "2023-04-26",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhammad Mustafa Al-Athba",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_cd832f05-0998-4ec3-aea9-1d452f1957d3",
        "address": "",
        "phone": "0506918745",
        "email": "azbahail@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "347",
    "company": "63fb112c-b55a-44f1-9b37-30271373cbe7",
    "firmId": "63fb112c-b55a-44f1-9b37-30271373cbe7",
    "firmName": "GUST Legal Translation",
    "role": "Owner"
  },
  {
    "id": "8455c991-12e9-4e39-84c4-9feff2f8e762",
    "slug": "mahmoud-abdel-al-ahmed-shaaban",
    "name": "Mahmoud Abdel-Al Ahmed Shaaban",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-05-20",
    "licenseStatus": "active",
    "licenseExpiry": "2027-12-27",
    "licenseIssueDate": "2025-01-27",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mahmoud Abdel-Al Ahmed Shaaban",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8455c991-12e9-4e39-84c4-9feff2f8e762",
        "address": "",
        "phone": "0506826015",
        "email": "mahmoud.translator@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "508",
    "company": "756665e2-72d9-4c09-bf20-ea04cbe4952b",
    "firmId": "756665e2-72d9-4c09-bf20-ea04cbe4952b",
    "firmName": "Al Anwar Legal Translation",
    "role": "Owner"
  },
  {
    "id": "ae4f71dc-5722-42e4-9f56-b04de21f2234",
    "slug": "mahmoud-muhammad-al-sawan",
    "name": "Mahmoud Muhammad Al-Sawan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mahmoud Muhammad Al-Sawan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ae4f71dc-5722-42e4-9f56-b04de21f2234",
        "address": "",
        "phone": "506244045",
        "email": "Al Sawan Translation Center P.O. Box: 600 Sharjah 0506244045 alsawan1@emirates.net.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "35"
  },
  {
    "id": "679a06ea-78c3-4eac-bc5f-3125a5ef6d26",
    "slug": "mahmoud-mohamed-al-mohanni",
    "name": "Mahmoud Mohamed Al-Mohanni",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 20,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2006-01-31",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-14",
    "licenseIssueDate": "2023-09-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mahmoud Mohamed Al-Mohanni",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_679a06ea-78c3-4eac-bc5f-3125a5ef6d26",
        "address": "",
        "phone": "508499865",
        "email": "mahmoudalarabi@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "262",
    "company": "Judicial Department"
  },
  {
    "id": "407a4c58-36bd-40e2-836f-c5c79f8073ed",
    "slug": "mahmoud-mohamed-sharif",
    "name": "Mahmoud Mohamed Sharif",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mahmoud Mohamed Sharif",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_407a4c58-36bd-40e2-836f-c5c79f8073ed",
        "address": "",
        "phone": "05012899040",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "e894b6a8-2ed9-46c9-9491-55f2055ce1a2",
    "slug": "mukhaled-alyan-musa-al-hawamdeh",
    "name": "Mukhaled Alyan Musa Al-Hawamdeh",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-04-26",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-26",
    "licenseIssueDate": "2023-12-27",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mukhaled Alyan Musa Al-Hawamdeh",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_e894b6a8-2ed9-46c9-9491-55f2055ce1a2",
        "address": "",
        "phone": "0503862474",
        "email": "Mkld1973@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "465",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "2007e44f-1a30-4905-9458-4a69be78ea64",
    "slug": "marwan-ibrahim-abdel-majid-ibrahim",
    "name": "Marwan Ibrahim Abdel Majid Ibrahim",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Marwan Ibrahim Abdel Majid Ibrahim",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2007e44f-1a30-4905-9458-4a69be78ea64",
        "address": "",
        "phone": "0509811043",
        "email": "morwan.ibrahim@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "401"
  },
  {
    "id": "12199478-fad0-437a-b4aa-48f19f4feb8a",
    "slug": "marwa-ahmed-al-sayed",
    "name": "Marwa Ahmed Al-Sayed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-10-03",
    "licenseStatus": "active",
    "licenseExpiry": "2026-12-17",
    "licenseIssueDate": "2023-12-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Marwa Ahmed Al-Sayed",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_12199478-fad0-437a-b4aa-48f19f4feb8a",
        "address": "",
        "phone": "0551886166",
        "email": "mseleem23@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "394",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "6203cc65-4b8d-41a8-b2de-91b45e9809da",
    "slug": "maryam-haider",
    "name": "Maryam Haider",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Maryam Haider",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6203cc65-4b8d-41a8-b2de-91b45e9809da",
        "address": "",
        "phone": "0561230592",
        "email": "remonda8819@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "551"
  },
  {
    "id": "c98a7b62-e409-445e-b932-89b6e52b4e7d",
    "slug": "mustafa-al-sayed-ahmed",
    "name": "Mustafa Al-Sayed Ahmed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mustafa Al-Sayed Ahmed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c98a7b62-e409-445e-b932-89b6e52b4e7d",
        "address": "",
        "phone": "0558669551",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null,
    "firmId": "1db8c6e9-4855-40a1-b690-908ce81e3b7d",
    "firmName": "United Legal Translation and Printing",
    "role": "Owner",
    "company": "1db8c6e9-4855-40a1-b690-908ce81e3b7d"
  },
  {
    "id": "7e057ccd-5d38-49bb-bbae-d5b7f3a6456e",
    "slug": "mustafa-sayed",
    "name": "Mustafa Sayed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mustafa Sayed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_7e057ccd-5d38-49bb-bbae-d5b7f3a6456e",
        "address": "",
        "phone": "0558669551",
        "email": "mohd.wadi@alwadiholding.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "495"
  },
  {
    "id": "57197b8b-1a4a-4843-8e31-a7982ff45f2c",
    "slug": "mustafa-fattouh-abdul-rasoul",
    "name": "Mustafa Fattouh Abdul Rasoul",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUYKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mustafa Fattouh Abdul Rasoul",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_57197b8b-1a4a-4843-8e31-a7982ff45f2c",
        "address": "",
        "phone": "553435846",
        "email": "Justice for Legal Translation 0553435246 Almrwa.translation@gmall.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "496"
  },
  {
    "id": "28e477b3-92a7-4ec6-8f5d-de99c34b8ddc",
    "slug": "mustafa-magdy-al-shahat-abdullah",
    "name": "Mustafa Magdy Al-Shahat Abdullah",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 3,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-05-09",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mustafa Magdy Al-Shahat Abdullah",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_28e477b3-92a7-4ec6-8f5d-de99c34b8ddc",
        "address": "",
        "phone": "0555518197",
        "email": "darshtranslator@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "754"
  },
  {
    "id": "9202e5a0-a21a-4d9d-8366-f2f8293d2796",
    "slug": "musaab-muhammad-zakaria",
    "name": "Musaab Muhammad Zakaria",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-01-23",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-19",
    "licenseIssueDate": "2023-03-20",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Musaab Muhammad Zakaria",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_9202e5a0-a21a-4d9d-8366-f2f8293d2796",
        "address": "",
        "phone": "0505856190",
        "email": "mzakarya@mubadala.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "458"
  },
  {
    "id": "b3c3602e-2f0c-4b3e-8049-6ef328240ff9",
    "slug": "moaz-yousry-muhammad-al-balkaimi",
    "name": "Moaz Yousry Muhammad Al-Balkaimi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTVkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Moaz Yousry Muhammad Al-Balkaimi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b3c3602e-2f0c-4b3e-8049-6ef328240ff9",
        "address": "",
        "phone": "555177353",
        "email": "moaaz.yousry@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "708"
  },
  {
    "id": "19bf824f-d3a4-43af-8f8f-171789d1c428",
    "slug": "al-khabeer-legal-translation-office",
    "name": "Al Khabeer Legal Translation Office",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgQUsKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Al Khabeer Legal Translation Office",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_19bf824f-d3a4-43af-8f8f-171789d1c428",
        "address": "",
        "phone": "0501695555",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "290b7c11-bc40-421e-9efb-33e5e6652869",
    "slug": "mansour-hamdan-suleiman-muhammad",
    "name": "Mansour Hamdan Suleiman Muhammad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2024-03-27",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mansour Hamdan Suleiman Muhammad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_290b7c11-bc40-421e-9efb-33e5e6652869",
        "address": "",
        "phone": "551724586",
        "email": "mansour.lingua@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "773"
  },
  {
    "id": "03f24b2b-4dc4-463b-b577-a538801e2f19",
    "slug": "mansour-sayed-mansour-farag",
    "name": "Mansour Sayed Mansour Farag",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-01-22",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-14",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mansour Sayed Mansour Farag",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_03f24b2b-4dc4-463b-b577-a538801e2f19",
        "address": "",
        "phone": "0555550950",
        "email": "monsourfarag79@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "619"
  },
  {
    "id": "ab3a7959-bba8-49fb-a139-4d9a47d0f3a0",
    "slug": "mona-muhammad",
    "name": "Mona Muhammad",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mona Muhammad",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ab3a7959-bba8-49fb-a139-4d9a47d0f3a0",
        "address": "",
        "phone": "0562406245",
        "email": "mona.hayaty2411@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "2eecd433-45ec-45bf-852b-29b76b8c0451",
    "slug": "mona-muhammad-abu-zaid",
    "name": "Mona Muhammad Abu Zaid",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 27,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1998-11-12",
    "licenseStatus": "active",
    "licenseExpiry": "2028-06-28",
    "licenseIssueDate": "2025-08-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mona Muhammad Abu Zaid",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_2eecd433-45ec-45bf-852b-29b76b8c0451",
        "address": "",
        "phone": "0562406245",
        "email": "abumonabuzaid@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "135",
    "company": "6af323d2-2edc-4a33-9345-f1877eadedf1",
    "firmId": "6af323d2-2edc-4a33-9345-f1877eadedf1",
    "firmName": "DTS Translation Services",
    "role": "Owner"
  },
  {
    "id": "b16917dc-daa8-4de2-acbd-2acf565ebd08",
    "slug": "muhannad-hassan",
    "name": "Muhannad Hassan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhannad Hassan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b16917dc-daa8-4de2-acbd-2acf565ebd08",
        "address": "",
        "phone": "0522285693",
        "email": "almuhla.translation@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "27b14970-7bf2-4d51-9ae2-f8bff8ac17d2",
    "slug": "muhannad-muhammad-yousef-al-thawabiya",
    "name": "Muhannad Muhammad Yousef Al-Thawabiya",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-11-24",
    "licenseIssueDate": "2024-11-25",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Muhannad Muhammad Yousef Al-Thawabiya",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_27b14970-7bf2-4d51-9ae2-f8bff8ac17d2",
        "address": "",
        "phone": "501339950",
        "email": "mohannad.alth@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "666",
    "company": "Kalba University"
  },
  {
    "id": "a08df77e-6941-47e5-a494-46a58763342a",
    "slug": "mahinour-tariq-jamal-al-din",
    "name": "Mahinour Tariq Jamal Al-Din",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTVQKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-03-18",
    "licenseStatus": "active",
    "licenseExpiry": "2028-07-09",
    "licenseIssueDate": "2025-07-14",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mahinour Tariq Jamal Al-Din",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a08df77e-6941-47e5-a494-46a58763342a",
        "address": "",
        "phone": "0508153543",
        "email": "Mahenour_tarek@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "483",
    "company": "US Consulate General"
  },
  {
    "id": "f15e736d-1c39-48ba-a610-19565e6990a0",
    "slug": "mian-jinlong",
    "name": "Mian Jinlong",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTUoKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-09-24",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-18",
    "licenseIssueDate": "2023-03-17",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Mian Jinlong",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_f15e736d-1c39-48ba-a610-19565e6990a0",
        "address": "",
        "phone": "0505856190",
        "email": "mianjinlong@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "417",
    "company": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmId": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmName": "Al Sharq Legal Translation Services"
  },
  {
    "id": "bc063a21-2f4d-44f3-93e1-b91fa6fe2a65",
    "slug": "maymouna-mohammed-hassan",
    "name": "Maymouna Mohammed Hassan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Maymouna Mohammed Hassan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_bc063a21-2f4d-44f3-93e1-b91fa6fe2a65",
        "address": "",
        "phone": "0551876887",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "dea9b943-7ab3-44f3-88b3-8ebaed8e48ab",
    "slug": "nadine-hassan-aroud",
    "name": "Nadine Hassan Aroud",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTkgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 7,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-06-26",
    "licenseStatus": "active",
    "licenseExpiry": "2025-11-27",
    "licenseIssueDate": "2023-01-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Nadine Hassan Aroud",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dea9b943-7ab3-44f3-88b3-8ebaed8e48ab",
        "address": "",
        "phone": "",
        "email": "nadeenaroud@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "681"
  },
  {
    "id": "20750f04-3065-42bd-be04-9e19c3ac734d",
    "slug": "nazlin-abdel-hamid",
    "name": "Nazlin Abdel Hamid",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Nazlin Abdel Hamid",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_20750f04-3065-42bd-be04-9e19c3ac734d",
        "address": "",
        "phone": "0502608744",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "3acdc6e0-7c14-4a53-8f64-14f3cdd9fa63",
    "slug": "nahida-fakhri-traveled",
    "name": "Nahida Fakhri traveled",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTkYKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Nahida Fakhri traveled",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3acdc6e0-7c14-4a53-8f64-14f3cdd9fa63",
        "address": "",
        "phone": "0507594065",
        "email": "seifertnahida@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "0"
  },
  {
    "id": "ff1726de-123e-445d-b86b-dfab74e3f7ef",
    "slug": "nabila-halish",
    "name": "Nabila Halish",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTkgKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Nabila Halish",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ff1726de-123e-445d-b86b-dfab74e3f7ef",
        "address": "",
        "phone": "521350556",
        "email": "Polyglot Legal Translation Dubai ideal@emirates.net.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "410"
  },
  {
    "id": "8bfd7fc5-d5ac-439e-85e6-10f71af5cdbb",
    "slug": "naglaa-ramadan-rushdi",
    "name": "Naglaa Ramadan Rushdi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTlIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 13,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic",
      "Russian"
    ],
    "mojLicense": "2012-12-24",
    "licenseStatus": "active",
    "licenseExpiry": "2026-09-03",
    "licenseIssueDate": "2023-09-04",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Naglaa Ramadan Rushdi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8bfd7fc5-d5ac-439e-85e6-10f71af5cdbb",
        "address": "",
        "phone": "555808953",
        "email": "sana4005@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "432",
    "company": "Ministry of Justice"
  },
  {
    "id": "6635cace-9d49-4876-abdd-d907e0d06c9e",
    "slug": "nermin-mustafa-al-azzawi",
    "name": "Nermin Mustafa Al-Azzawi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTk0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2011-06-16",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-21",
    "licenseIssueDate": "2023-08-22",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Nermin Mustafa Al-Azzawi",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_6635cace-9d49-4876-abdd-d907e0d06c9e",
        "address": "",
        "phone": "508236557",
        "email": "elazzawi@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "386",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "3bef0cbc-db08-4366-9743-e900954cfccd",
    "slug": "nizar-mubarak-ahmed-al-imam",
    "name": "Nizar Mubarak Ahmed Al-Imam",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTk0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-03-30",
    "licenseStatus": "active",
    "licenseExpiry": "2021-02-04",
    "licenseIssueDate": "2017-07-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Nizar Mubarak Ahmed Al-Imam",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_3bef0cbc-db08-4366-9743-e900954cfccd",
        "address": "",
        "phone": "0569982723",
        "email": "nezo_1966@hotmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "348",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "8e7827c0-e062-4d21-bd42-20f164f6b235",
    "slug": "nazzal-youssef-hamad-nazzal",
    "name": "Nazzal Youssef Hamad Nazzal",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTlkKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 23,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2002-09-04",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-06",
    "licenseIssueDate": "2023-10-18",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Nazzal Youssef Hamad Nazzal",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_8e7827c0-e062-4d21-bd42-20f164f6b235",
        "address": "",
        "phone": "504626900",
        "email": "Al-Nazzal Legal Translation 0504626900",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "199",
    "company": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmId": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmName": "Al Sharq Legal Translation Services"
  },
  {
    "id": "6674b07f-babd-458d-8fcd-88c47c59fc2b",
    "slug": "his-brother-in-law-hashem-al-jazzar",
    "name": "His brother-in-law Hashem Al-Jazzar",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 2,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2023-06-07",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-05",
    "licenseIssueDate": "2023-06-06",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: His brother-in-law Hashem Al-Jazzar",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_6674b07f-babd-458d-8fcd-88c47c59fc2b",
        "address": "",
        "phone": "0525907823",
        "email": "nj.aljazzar@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "757",
    "company": "NMC Asteco - Abu Dhabi"
  },
  {
    "id": "3b39af3a-585c-4c7e-8d3a-78fd6d6863c6",
    "slug": "nasri-abdel-hafez-lets",
    "name": "Nasri Abdel Hafez Let's",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgTkEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Nasri Abdel Hafez Let's",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_3b39af3a-585c-4c7e-8d3a-78fd6d6863c6",
        "address": "",
        "phone": "505462667",
        "email": "Global Express Legal Translation Abu Dhabi Tel: 026224496 geltoffice@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "526"
  },
  {
    "id": "92ffa056-9628-4dce-a541-8045401eded3",
    "slug": "exiled-by-shawqi-ali-al-shaarawy",
    "name": "Exiled by Shawqi Ali Al-Shaarawy",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgRVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 15,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-11-03",
    "licenseStatus": "active",
    "licenseExpiry": "2026-08-28",
    "licenseIssueDate": "2023-08-29",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Exiled by Shawqi Ali Al-Shaarawy",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_92ffa056-9628-4dce-a541-8045401eded3",
        "address": "",
        "phone": "0506388374",
        "email": "nevenesha@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "379"
  },
  {
    "id": "6c2877e0-f563-47b5-8cfe-2d5f9cb52f34",
    "slug": "hani-farouk-abdullah-salem-hussein",
    "name": "Hani Farouk Abdullah Salem Hussein",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEYKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 14,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2012-04-15",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": "2020-09-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hani Farouk Abdullah Salem Hussein",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_6c2877e0-f563-47b5-8cfe-2d5f9cb52f34",
        "address": "",
        "phone": "0501190015",
        "email": "hany.f.hussein@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "406"
  },
  {
    "id": "98f62153-92b1-42b5-976e-f6b0db420eea",
    "slug": "hani-muhammad-al-sharif",
    "name": "Hani Muhammad Al-Sharif",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSE0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 11,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2015-03-18",
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": "2023-06-08",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hani Muhammad Al-Sharif",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_98f62153-92b1-42b5-976e-f6b0db420eea",
        "address": "",
        "phone": "0508268966",
        "email": "hanitranslator@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "501",
    "company": "Global Aerospace Logistics Company"
  },
  {
    "id": "38662584-7303-4ac5-9ba0-63058436a18a",
    "slug": "hoda-al-zarouni",
    "name": "Hoda Al Zarouni",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hoda Al Zarouni",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_38662584-7303-4ac5-9ba0-63058436a18a",
        "address": "",
        "phone": "0502555199",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "a85064a0-c836-4c49-aaf4-6b4680f48430",
    "slug": "hadeel-mohammed-saeed",
    "name": "Hadeel Mohammed Saeed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSE0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-10-04",
    "licenseStatus": "active",
    "licenseExpiry": "2026-11-14",
    "licenseIssueDate": "2023-11-15",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hadeel Mohammed Saeed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_a85064a0-c836-4c49-aaf4-6b4680f48430",
        "address": "",
        "phone": "0563772000",
        "email": "majid7877@icloud.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "646",
    "company": "ADNOC Wild"
  },
  {
    "id": "ba2fb9ec-ffde-46c0-bf72-6d71606274ca",
    "slug": "hana-rasmy-wadi",
    "name": "Hana Rasmy Wadi",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSFIKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 17,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2009-01-12",
    "licenseStatus": "active",
    "licenseExpiry": "2023-01-04",
    "licenseIssueDate": "2020-01-05",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Hana Rasmy Wadi",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_ba2fb9ec-ffde-46c0-bf72-6d71606274ca",
        "address": "",
        "phone": "0505656962",
        "email": "hwadi9999@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "320",
    "company": "684a17b2-cfa2-4dbc-bc5f-b21ad92d16a9",
    "firmId": "684a17b2-cfa2-4dbc-bc5f-b21ad92d16a9",
    "firmName": "Al Wadi Holding Legal Translation"
  },
  {
    "id": "b2e082ad-60fe-4f9f-a453-83187e130f49",
    "slug": "haifa-abdul-wahed-al-farhan",
    "name": "Haifa Abdul Wahed Al Farhan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 21,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2005-01-17",
    "licenseStatus": "active",
    "licenseExpiry": "2027-08-12",
    "licenseIssueDate": "2024-09-23",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Haifa Abdul Wahed Al Farhan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_b2e082ad-60fe-4f9f-a453-83187e130f49",
        "address": "",
        "phone": "0506352118",
        "email": "info@alqabastranslation.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "240"
  },
  {
    "id": "098caba7-556b-4811-b000-fc2b6cc0feec",
    "slug": "haifa-abdel-wahed-farhan",
    "name": "Haifa Abdel Wahed Farhan",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgSEEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Haifa Abdel Wahed Farhan",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_098caba7-556b-4811-b000-fc2b6cc0feec",
        "address": "",
        "phone": "0506028233",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "5d61e454-d9ee-4dda-a3fc-e5612c5b0dc9",
    "slug": "wael-al-husseini-ahmed-badran",
    "name": "Wael Al-Husseini Ahmed Badran",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgV0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 16,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2010-03-17",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-15",
    "licenseIssueDate": "2023-03-16",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Wael Al-Husseini Ahmed Badran",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_5d61e454-d9ee-4dda-a3fc-e5612c5b0dc9",
        "address": "",
        "phone": "0529728074",
        "email": "wbadran2020@yahoo.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "368",
    "company": "3b97f53d-ba89-48f8-84a3-9af18041cbdd",
    "firmId": "3b97f53d-ba89-48f8-84a3-9af18041cbdd",
    "firmName": "Atlas of legal translation",
    "role": "Owner"
  },
  {
    "id": "d836f380-3732-4944-aca9-2ef2383037b8",
    "slug": "wafi-adam-muhammad-ali",
    "name": "Wafi Adam Muhammad Ali",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgV0EKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2018-01-18",
    "licenseStatus": "active",
    "licenseExpiry": "2027-10-08",
    "licenseIssueDate": "2024-10-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Wafi Adam Muhammad Ali",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d836f380-3732-4944-aca9-2ef2383037b8",
        "address": "",
        "phone": "521620595",
        "email": "wafi.almahri@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "661"
  },
  {
    "id": "dc48a902-f408-4696-9791-a605e46a3565",
    "slug": "walid-zakaria-maghazi-al-khatib",
    "name": "Walid Zakaria Maghazi Al-Khatib",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgV1oKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 9,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-04-26",
    "licenseStatus": "active",
    "licenseExpiry": "2026-06-25",
    "licenseIssueDate": "2023-06-26",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Walid Zakaria Maghazi Al-Khatib",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_dc48a902-f408-4696-9791-a605e46a3565",
        "address": "",
        "phone": "0504233817",
        "email": "walidelkhatib1980@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "633",
    "company": "Sheikh Shakhbout Medical City"
  },
  {
    "id": "afd69b62-1471-432e-b003-506622dfc539",
    "slug": "oh-muhammad-ahmed",
    "name": "Oh Muhammad Ahmed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgT00KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Oh Muhammad Ahmed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_afd69b62-1471-432e-b003-506622dfc539",
        "address": "",
        "phone": "0505628300",
        "email": "yassergad123@hormail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "75986c50-3911-4e2c-9966-59331d2db444",
    "slug": "yasser",
    "name": "Yasser",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Yasser",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_75986c50-3911-4e2c-9966-59331d2db444",
        "address": "",
        "phone": "0506909519",
        "email": "yassiryoussif@yahoo.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "1c4c6e75-4ec8-44f7-b2fd-3265341abc26",
    "slug": "yasser-al-sayyed-musa-al-jarran",
    "name": "Yasser Al-Sayyed Musa Al-Jarran",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Yasser Al-Sayyed Musa Al-Jarran",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_1c4c6e75-4ec8-44f7-b2fd-3265341abc26",
        "address": "",
        "phone": "0569938269",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "662"
  },
  {
    "id": "a6224868-374d-4bc0-9eca-89f807bf1c39",
    "slug": "yasser-suleiman-al-masry",
    "name": "Yasser Suleiman Al-Masry",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 12,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2014-04-04",
    "licenseStatus": "active",
    "licenseExpiry": "2027-01-08",
    "licenseIssueDate": "2024-01-09",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Yasser Suleiman Al-Masry",
    "consultationFee": 250,
    "emirate": "Abu Dhabi",
    "verified": true,
    "offices": [
      {
        "id": "office_a6224868-374d-4bc0-9eca-89f807bf1c39",
        "address": "",
        "phone": "545119564",
        "email": "yasserabuhani@gmail.com",
        "emirate": "Abu Dhabi",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "471",
    "company": "Abu Dhabi Police General Headquarters"
  },
  {
    "id": "d56f9aa9-d4c7-4b08-a5c3-4bc3b2098672",
    "slug": "yasser-abdel-rahman-ibrahim",
    "name": "Yasser Abdel Rahman Ibrahim",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Yasser Abdel Rahman Ibrahim",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d56f9aa9-d4c7-4b08-a5c3-4bc3b2098672",
        "address": "",
        "phone": "0555442022",
        "email": "y_a_ibrahim@hotmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "642"
  },
  {
    "id": "c7cbd43a-76da-48c1-9e3e-e3775012dee5",
    "slug": "yasser-mohamed-ahmed",
    "name": "Yasser Mohamed Ahmed",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWU0KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Yasser Mohamed Ahmed",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_c7cbd43a-76da-48c1-9e3e-e3775012dee5",
        "address": "",
        "phone": "0505628300",
        "email": "undefined",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": null
  },
  {
    "id": "d7b54dba-030f-4147-8c3e-bf91f70e57d3",
    "slug": "yahya-omar-nassif",
    "name": "Yahya Omar Nassif",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWU8KICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 5,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": null,
    "licenseStatus": "active",
    "licenseExpiry": "2025-12-31",
    "licenseIssueDate": null,
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Yahya Omar Nassif",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_d7b54dba-030f-4147-8c3e-bf91f70e57d3",
        "address": "",
        "phone": "502335200",
        "email": "Al-Wafi Legal Translation 0502335200 abuomar1960@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "479"
  },
  {
    "id": "52c134f2-42f8-4a08-8235-8535dd97740f",
    "slug": "yassuna-suleiman-al-nour",
    "name": "Yassuna Suleiman Al-Nour",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWVMKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 8,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "2017-08-07",
    "licenseStatus": "active",
    "licenseExpiry": "2026-10-30",
    "licenseIssueDate": "2023-11-10",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Yassuna Suleiman Al-Nour",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_52c134f2-42f8-4a08-8235-8535dd97740f",
        "address": "",
        "phone": "0508422570",
        "email": "ylagal2020@gmail.com",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "636",
    "company": "Yassuna Suleiman Al-Nour"
  },
  {
    "id": "0a6d8b34-1876-4678-aae0-6eeb383bdc1a",
    "slug": "youssef-abdel-rahman-arar",
    "name": "Youssef Abdel Rahman Arar",
    "title": "Legal Translator",
    "photo": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgICA8ZGVmcz4KICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJ0cmFuc2xhdG9yR3JhZGllbnQiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPgogICAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMwNTk2Njk7c3RvcC1vcGFjaXR5OjEiIC8+CiAgICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMDA2MzM2O3N0b3Atb3BhY2l0eToxIiAvPgogICAgICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgICAgICA8ZmlsdGVyIGlkPSJ0cmFuc2xhdG9yU2hhZG93IiB4PSItNTAlIiB5PSItNTAlIiB3aWR0aD0iMjAwJSIgaGVpZ2h0PSIyMDAlIj4KICAgICAgICAgICAgICA8ZmVEcm9wU2hhZG93IGR4PSIwIiBkeT0iNCIgc3RkRGV2aWF0aW9uPSI4IiBmbG9vZC1jb2xvcj0icmdiYSgwLDAsMCwwLjEpIi8+CiAgICAgICAgICAgIDwvZmlsdGVyPgogICAgICAgICAgPC9kZWZzPgogICAgICAgICAgPGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNTgiIGZpbGw9InVybCgjdHJhbnNsYXRvckdyYWRpZW50KSIgZmlsdGVyPSJ1cmwoI3RyYW5zbGF0b3JTaGFkb3cpIi8+CiAgICAgICAgICA8dGV4dCB4PSI2MCIgeT0iNzAiIGZvbnQtZmFtaWx5PSJJbnRlciwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBzYW5zLXNlcmlmIiAKICAgICAgICAgICAgICAgIGZvbnQtc2l6ZT0iMzIiIGZvbnQtd2VpZ2h0PSI2MDAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgWUEKICAgICAgICAgIDwvdGV4dD4KICAgICAgICA8L3N2Zz4=",
    "specializations": [
      "Translation",
      "Legal Translation"
    ],
    "experience": 37,
    "rating": 4.0,
    "reviewCount": 0,
    "languages": [
      "English",
      "Arabic"
    ],
    "mojLicense": "1989-04-02",
    "licenseStatus": "active",
    "licenseExpiry": "2026-03-13",
    "licenseIssueDate": "2023-04-03",
    "education": [
      "Translation Education"
    ],
    "achievements": [
      "Licensed Legal Translator"
    ],
    "description": "Licensed legal translator: Youssef Abdel Rahman Arar",
    "consultationFee": 250,
    "emirate": "UAE",
    "verified": true,
    "offices": [
      {
        "id": "office_0a6d8b34-1876-4678-aae0-6eeb383bdc1a",
        "address": "",
        "phone": "506520550",
        "email": "Arar Legal Translation / Dubai Tel: 2218883 / Fax: 2274441 P.O. Box: 63873 yar2001@emirates.net.ae",
        "emirate": "UAE",
        "isMain": true
      }
    ],
    "services": [
      {
        "name": "Legal Translation",
        "description": "Legal Translator services",
        "price": 250,
        "duration": "1 hour"
      }
    ],
    "availability": {
      "monday": [
        "09:00-17:00"
      ],
      "tuesday": [
        "09:00-17:00"
      ],
      "wednesday": [
        "09:00-17:00"
      ],
      "thursday": [
        "09:00-17:00"
      ],
      "sunday": [
        "09:00-17:00"
      ]
    },
    "category": "Translation_Individuals",
    "registrationNumber": "45",
    "company": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmId": "9c392772-b626-49d4-9f1c-4212cd35d4e6",
    "firmName": "Al Sharq Legal Translation Services"
  }
];
